export default {
  "pages.layouts.userLayout.title":
    "Ant Design is the most influential web design specification in Xihu district",
  "pages.dashboard.overview.title": "Overview",
  "pages.dashboard.overview.betUserCount": "Bet Users",
  "pages.dashboard.overview.betCount": "Bet Count",
  "pages.dashboard.overview.betAmount": "Bet Amount",
  "pages.dashboard.overview.ggr": "GGR",
  "pages.dashboard.overview.avgBetCountPerUser": "Avg Bets/User",
  "pages.dashboard.overview.avgBetAmountPerUser": "Avg Bet Amount/Person",
  "pages.dashboard.overview.today": "Today",
  "pages.dashboard.overview.yesterday": "Yesterday",
  "pages.dashboard.overview.total": "Total",
  "pages.dashboard.chart.twoDayAgo": "2 Days Ago",
  "pages.dashboard.userData.title": "User Data",
  "pages.dashboard.userData.tab.last7Days": "Last 7 Days",
  "pages.dashboard.userData.tab.last15Days": "Last 15 Days",
  "pages.dashboard.userData.tab.last30Days": "Last 30 Days",
  "pages.dashboard.userData.empty": "No user data",
  "pages.dashboard.top10.tab.today": "Today",
  "pages.dashboard.top10.tab.yesterday": "Yesterday",
  "pages.dashboard.top10.tab.twoDayAgo": "2 Days Ago",
  "pages.dashboard.top10.metric.betAmount": "Bet Amount",
  "pages.dashboard.top10.metric.betCount": "Bet Count",
  "pages.dashboard.top10.metric.betUserCount": "Bet Users",
  "pages.dashboard.top10.metric.ggr": "GGR",
  "pages.dashboard.top10.empty": "No Top10 data",
  "pages.dashboard.top10.unknownMerchant": "Merchant {index}",
  "pages.dashboard.onlineStats.title": "Online Stats",
  "pages.dashboard.onlineStats.tab.visitUsers": "Visitors",
  "pages.dashboard.onlineStats.tab.betUsers": "Bet Users",
  "pages.dashboard.onlineStats.empty": "No trend data",
  "pages.dashboard.onlineStats.filter.game": "Game Filter",
  "pages.dashboard.onlineStats.filter.merchant": "Merchant Filter",
  "pages.dashboard.betStats.title": "Bet Stats",
  "pages.dashboard.betStats.tab.betAmount": "Bet Amount",
  "pages.dashboard.betStats.tab.betCount": "Bet Count",
  "pages.dashboard.betStats.empty": "No bet data",
  "pages.dashboard.betUserRatio.title": "Bet User Ratio",
  "pages.dashboard.betUserRatio.tab.amount": "Amount",
  "pages.dashboard.betUserRatio.tab.count": "Users",
  "pages.dashboard.betUserRatio.empty": "No ratio data",
  "pages.dashboard.chart.newVisits": "New Visits",
  "pages.dashboard.chart.newBets": "New Bets",
  "pages.dashboard.chart.totalVisits": "Total Visits",
  "pages.dashboard.chart.totalBets": "Total Bets",
  "pages.dashboard.chart.newUser": "New User",
  "pages.dashboard.chart.oldUser": "Old User",
  "pages.dashboard.time.minutesAgo": "{minutes} minutes ago",
  "pages.dashboard.time.hoursAgo": "{hours} hours ago",
  "pages.dashboard.time.daysAgo": "{days} days ago",
  "pages.dashboard.error.fetchFailed": "Failed to fetch overview",
  "pages.dashboard.gameTop10": "Game Top10",
  "pages.dashboard.merchantTop10": "Merchant Top10",
  "pages.dashboard.riskAlerts.title": "Risk Alert Monitoring",
  "pages.dashboard.riskAlerts.extra": "Recent Alerts",
  "pages.dashboard.riskAlerts.empty": "No alert data",

  "pages.dashboard.announcement.title": "Announcements",
  "pages.dashboard.announcement.empty": "No announcements",
  "pages.dashboard.announcement.detail.title": "Announcement Detail",
  "pages.login.accountLogin.tab": "Account Login",
  "pages.login.accountLogin.errorMessage": "Incorrect username or password",
  "pages.login.failure": "Login failed, please try again!",
  "pages.login.success": "Login successful!",
  "pages.login.username.placeholder": "Username",
  "pages.login.username.required": "Please input your username!",
  "pages.login.password.placeholder": "Password",
  "pages.login.password.required": "Please input your password!",
  "pages.login.rememberMe": "Remember me",
  "pages.login.submit": "Login",
  "pages.login.submit.google": "Verify and Login",
  "pages.login.google.title": "Google Code",
  "pages.login.google.placeholder": "Google Code",
  "pages.login.google.required": "Please input your Google code!",
  "pages.login.google.tip.input": "Please input Google code",
  "pages.login.google.tip.bind": "Please bind Google code",
  "pages.login.google.alert.input":
    "Account verified, please input Google code to complete login",
  "pages.login.google.alert.bind":
    "Account verified, please scan the QR code below to bind Google code",
  "pages.login.google.scan": "Please use Google Authenticator to scan",
  "pages.login.google.back": "Back to Account Login",
  "pages.login.error.exception": "Login exception, please try again later",
  "pages.login.error.verify": "Verification failed, please re-enter",
  "pages.login.error.operation": "Operation failed, please try again!",
  "pages.login.error.tokenNotFound": "Login token not found",
  "pages.login.redirecting": "Redirecting to home in {countdown} seconds",
  "pages.login.loading": "Logging in...",
  "pages.login.title": "Login - Croco Manage",
  "pages.login.subTitle": "Game Management System",
  "pages.login.subTitle.platform": "Platform",
  "pages.login.subTitle.merchant": "Merchant",
  "pages.login.loginWith": "Login with :",
  "pages.login.registerAccount": "Register Account",

  // Merchant Management - Members List

  // Merchant Apply
  "pages.merchant.apply.list.title": "Merchant Apply",
  "pages.merchant.apply.filter.applyTime": "Apply Time",
  "pages.merchant.apply.filter.all": "All",
  "pages.merchant.apply.filter.keywords": "Merchant",
  "pages.merchant.apply.filter.keywords.placeholder":
    "Enter merchant name or ID",
  "pages.merchant.apply.filter.walletMode.placeholder": "Select wallet type",
  "pages.merchant.apply.filter.reviewStatus": "Review Status",
  "pages.merchant.apply.filter.reviewStatus.placeholder":
    "Select review status",
  "pages.merchant.apply.status.pendingSubmit": "Pending Submit",
  "pages.merchant.apply.status.reviewing": "Reviewing",
  "pages.merchant.apply.status.approved": "Approved",
  "pages.merchant.apply.status.rejected": "Rejected",
  "pages.merchant.apply.statusValue.1": "Pending Submit",
  "pages.merchant.apply.statusValue.2": "Reviewing",
  "pages.merchant.apply.statusValue.3": "Approved",
  "pages.merchant.apply.statusValue.4": "Rejected",
  "pages.merchant.apply.column.id": "ID",
  "pages.merchant.apply.column.operatorName": "Merchant/Agent Name",
  "pages.merchant.apply.column.appid": "APPID",
  "pages.merchant.apply.column.agentLevel": "Agent Level",
  "pages.merchant.apply.column.parentOperatorName": "Parent Operator",
  "pages.merchant.apply.column.applyAdminName": "Applicant",
  "pages.merchant.apply.column.applyAdminUserName": "Applicant Account",
  "pages.merchant.apply.column.contactInformation": "Contact",
  "pages.merchant.apply.column.reviewStatus": "Review Status",
  "pages.merchant.apply.column.handlerName": "Handler",
  "pages.merchant.apply.column.reviewComments": "Review Comments",
  "pages.merchant.apply.column.applyTime": "Apply Time",
  "pages.merchant.apply.column.processingTime": "Processing Time",
  "pages.merchant.apply.column.operation": "Action",
  "pages.merchant.apply.action.detail": "View Detail",
  "pages.merchant.apply.action.approve": "Approve",
  "pages.merchant.apply.action.reject": "Reject",
  "pages.merchant.apply.detail.title": "Merchant Onboarding Request",
  "pages.merchant.apply.detail.title.agent": "Agent Onboarding Request",
  "pages.merchant.apply.detail.section.content": "Submitted Content",
  "pages.merchant.apply.detail.field.orderNo": "Order No",
  "pages.merchant.apply.detail.field.applicant": "Applicant",
  "pages.merchant.apply.detail.field.applicantName": "Applicant Name",
  "pages.merchant.apply.detail.field.applicantAffiliation":
    "Applicant Affiliation",
  "pages.merchant.apply.detail.field.createdAt": "Submitted At",
  "pages.merchant.apply.detail.field.merchantName": "Merchant Name",
  "pages.merchant.apply.detail.field.loginPassword": "Login Password",
  "pages.merchant.apply.detail.field.remark": "Remark",
  "pages.merchant.apply.detail.field.contactEmail": "Contact Email",
  "pages.merchant.apply.detail.field.fee": "Fee Rate",
  "pages.merchant.apply.detail.field.parent": "Direct Parent",
  "pages.merchant.apply.detail.field.manager": "Manager",
  "pages.merchant.apply.detail.field.walletMode": "Wallet Mode",
  "pages.merchant.apply.detail.field.status": "Status",
  "pages.merchant.apply.detail.field.loginAccount": "Login Account",
  "pages.merchant.apply.detail.field.ipWhitelist": "IP Whitelist",
  "pages.merchant.apply.detail.field.openGames": "Open Games",
  "pages.merchant.apply.action.approve.title": "Confirm Approve Request",
  "pages.merchant.apply.action.reject.title": "Confirm Reject Request",
  "pages.merchant.apply.action.approve.description":
    "You are processing the merchant onboarding request for order {id}",
  "pages.merchant.apply.action.reject.description":
    "You are processing the merchant onboarding request for order {id}",
  "pages.merchant.apply.action.approve.placeholder":
    "Please enter approval reason (optional)",
  "pages.merchant.apply.action.reject.placeholder":
    "Please enter rejection reason (optional)",
  "pages.merchant.apply.message.approveMissingId":
    "Missing request ID, unable to approve",
  "pages.merchant.apply.message.rejectMissingId":
    "Missing request ID, unable to reject",
  "pages.merchant.apply.message.approveSuccess": "Approved successfully",
  "pages.merchant.apply.message.approveFailed": "Approval failed",
  "pages.merchant.apply.message.rejectSuccess": "Rejected successfully",
  "pages.merchant.apply.message.rejectFailed": "Rejection failed",
  "pages.merchant.review.column.operatorName": "Merchant/Agent Name",
  "pages.merchant.review.list.title": "Merchant Publish Review",
  "pages.merchant.review.detail.title": "Merchant Pending Publish Detail",
  "pages.merchant.review.detail.title.agent": "Agent Pending Publish Detail",
  "pages.merchant.review.status.pendingRelease": "Pending Publish",
  "pages.merchant.review.action.edit": "Edit",
  "pages.merchant.review.action.publish": "Publish",
  "pages.merchant.review.drawer.title.merchant": "Edit Merchant Draft",
  "pages.merchant.review.drawer.title.agent": "Edit Agent Draft",
  "pages.merchant.review.confirm.publish.title": "Confirm Submit For Review?",
  "pages.merchant.review.confirm.publish.content":
    "After submission, this draft enters the reviewing status and can no longer be edited until the review is completed.",
  "pages.merchant.review.message.publishMissingId":
    "Missing request ID, unable to publish",
  "pages.merchant.review.message.publishSuccess": "Published successfully",
  "pages.merchant.review.message.publishFailed": "Publish failed",

  // Manual Settlement
  "pages.merchant.settle.list.title": "Manual Settlement",
  "pages.merchant.settle.filter.merchant": "Merchant",
  "pages.merchant.settle.filter.game": "Game",
  "pages.merchant.settle.filter.status": "Status",
  "pages.merchant.settle.filter.orderId": "Order ID",
  "pages.merchant.settle.filter.orderId.placeholder": "Enter bet ID",
  "pages.merchant.settle.filter.dateRange": "Date Range",
  "pages.merchant.settle.column.parentId": "Bet ID",
  "pages.merchant.settle.column.merchantName": "Merchant Name",
  "pages.merchant.settle.column.roleId": "User ID",
  "pages.merchant.settle.column.gameName": "Game Name",
  "pages.merchant.settle.column.currency": "Currency",
  "pages.merchant.settle.column.betAmount": "Bet Amount",
  "pages.merchant.settle.column.scoreAmount": "Win Amount",
  "pages.merchant.settle.column.remark": "Remark",
  "pages.merchant.settle.column.status": "Status",
  "pages.merchant.settle.column.adminId": "Operator",
  "pages.merchant.settle.column.createdAt": "Operation Time",
  "pages.merchant.settle.column.settleTime": "Settlement Time",
  "pages.merchant.settle.status.reviewing": "Reviewing",
  "pages.merchant.settle.status.published": "Published",
  "pages.merchant.settle.status.rejected": "Rejected",
  "pages.merchant.settle.status.pendingExecute": "Not Executed",
  "pages.merchant.settle.status.executed": "Executed",
  "pages.merchant.settle.action.detail": "Detail",
  "pages.merchant.settle.action.manualSettle": "Manual Settlement",
  "pages.merchant.settle.action.retry": "Re-settle",
  "pages.merchant.settle.column.action": "Action",
  "pages.merchant.settle.retry.success": "Re-settlement successful",
  "pages.merchant.settle.retry.confirm.title": "Confirm Re-settlement",
  "pages.merchant.settle.retry.confirm.content":
    'Manual settlement did not complete. Please click the "Re-settle" button to re-execute the settlement. This operation does not require review.',
  "pages.merchant.settle.retry.confirm.operator": "Operator: ",
  "pages.merchant.settle.modal.title": "Manual Settlement",
  "pages.merchant.settle.modal.parentId": "Order ID",
  "pages.merchant.settle.modal.parentId.placeholder": "Enter bet ID",
  "pages.merchant.settle.modal.parentId.required": "Please enter order ID",
  "pages.merchant.settle.modal.remark": "Remark",
  "pages.merchant.settle.modal.remark.placeholder": "Enter remark",
  "pages.merchant.settle.modal.missingTicket":
    "Missing Google verification ticket",
  "pages.merchant.settle.modal.success.review":
    "Settlement confirmed successfully",
  "pages.merchant.settle.modal.success.submit":
    "Manual settlement review submitted successfully",
  "pages.merchant.settle.detail.title": "Order Details",
  "pages.merchant.settle.detail.receiptId": "Receipt ID",
  "pages.merchant.settle.detail.betLevel": "Bet Level",
  "pages.merchant.settle.detail.orderStatus": "Order Status",
  "pages.merchant.settle.detail.orderStatus.0": "In Progress",
  "pages.merchant.settle.detail.orderStatus.1": "Completed",
  "pages.merchant.settle.detail.surplusCoin": "Surplus Coin",
  "pages.merchant.settle.detail.exchangeRate": "Exchange Rate",
  "pages.merchant.settle.detail.currencyMult": "Currency Multiplier",
  "pages.merchant.settle.detail.roundEnd": "Round End",
  "pages.merchant.settle.detail.configVersion": "Config Version",
  "pages.merchant.settle.detail.countryCode": "Country Code",
  "pages.merchant.settle.detail.region": "Region",
  "pages.merchant.settle.detail.ip": "IP",
  "pages.merchant.settle.detail.createDatetime": "Create Time",
  "pages.merchant.settle.detail.buyBonusType": "Game Mode",

  "pages.merchant.members.id": "Merchant ID",
  "pages.merchant.members.appid": "AppID",
  "pages.merchant.members.name": "Merchant Name",
  "pages.merchant.members.manager": "Manager",
  "pages.merchant.members.contact": "Contact",
  "pages.merchant.members.level": "Level",
  "pages.merchant.members.level.tooltip":
    "Level 1 Agent: Can add Level 2 agents or direct merchants, cannot open games\nLevel 2 Agent: Can add merchants, cannot open games\nMerchant: Lowest level, can open games",
  "pages.merchant.members.level.1": "Level 1 Agent",
  "pages.merchant.members.level.2": "Level 2 Agent",
  "pages.merchant.members.level.normal": "Normal Merchant",
  "pages.merchant.members.walletMode": "Wallet Mode",
  "pages.merchant.members.walletMode.single": "Single Wallet",
  "pages.merchant.members.walletMode.transfer": "Transfer Mode",
  "pages.merchant.members.currencyRatio": "Currency Ratio",
  "pages.merchant.members.currencyRatio.tooltip":
    "Based on real-time exchange rates, reflecting the actual currency value of each merchant. Default is 1:1.\nTaking USD as an example: if a merchant's currency ratio is set to 1:100, the currency value is 1USD/100, i.e. 0.01USD",
  "pages.merchant.members.currencyRatioModal.title": "Currency Ratio",
  "pages.merchant.members.currencyRatioModal.subtitle":
    "Configuring currency ratio for merchant {name}",
  "pages.merchant.members.currencyRatioModal.form.label": "*Set Ratio",
  "pages.merchant.members.currencyRatioModal.showModifiedOnly":
    "Show Modified Only",
  "pages.merchant.members.currencyRatioModal.resetAll": "Reset All to 1:1",
  "pages.merchant.members.currencyRatioModal.noModified": "No modifications",
  "pages.merchant.members.currencyRatioModal.tip":
    "Based on real-time exchange rates, reflecting the actual currency value of each merchant. Default is 1:1. (Only integer values are allowed)\nTaking USD as an example: if a merchant's currency ratio is set to 1:100, the currency value is 1USD/100, i.e. 0.01USD",
  "pages.merchant.members.currencyRatioModal.success":
    "Currency ratio updated successfully",
  "pages.merchant.members.currencyRatioModal.loadFailed":
    "Failed to load currency ratios",
  "pages.merchant.members.currencyRatioModal.apply.title":
    "Apply to Other Merchants",
  "pages.merchant.members.currencyRatioModal.apply.selectedCount":
    "Selected ({selected}/{total})",
  "pages.merchant.members.currencyRatioModal.apply.selectAll": "Select All",
  "pages.merchant.members.currencyRatioModal.apply.cancelAll": "Deselect All",
  "pages.merchant.members.currencyRatioModal.apply.desc":
    "Apply to other merchants under the same agent",
  "pages.merchant.members.currencyRatioModal.apply.empty":
    "No other merchants available under the current user",
  "pages.merchant.members.currencyRatioModal.apply.tip":
    "*Selected merchants will be overridden by this currency ratio configuration",
  "pages.merchant.members.fee": "Fee Share",
  "pages.merchant.members.fee.tooltip":
    "Profit Sharing Ratio: The share the merchant can receive.\nSubordinate ratios follow the superior. If a Level 1 agent is 90%, all Level 2 agents and merchants under it are 90%",
  "pages.merchant.members.childrenCount": "Subordinates Count",
  "pages.merchant.members.childrenCount.tooltip":
    "Subordinate count calculation method\nLevel 1 Agent: Sum of Level 2 agents + merchants\nLevel 2 Agent: Only counts merchants",
  "pages.merchant.members.createdAt": "Created Time",
  "pages.merchant.members.status": "Status",
  "pages.merchant.members.option": "Action",
  "pages.merchant.members.search.placeholder": "ID or Name",
  "pages.merchant.members.search.title": "Search Merchant",
  "pages.merchant.members.list.title": "Merchant and Agent List",
  "pages.merchant.members.list.stats":
    " (L1 Agents: {agent1Count}  L2 Agents: {agent2Count}  Merchants: {merchantCount})",
  "pages.merchant.members.list.selected": "Selected {count} items",
  "pages.merchant.members.action.batchEnable": "Batch Enable",
  "pages.merchant.members.action.batchDisable": "Batch Disable",
  "pages.merchant.members.action.cancelSelection": "Cancel Selection",
  "pages.merchant.members.action.addAgent": "Add Agent",
  "pages.merchant.members.action.addMerchant": "Add Merchant",
  "pages.merchant.members.action.batchAdd": "Batch Add",
  "pages.merchant.members.action.export": "Export Merchant",
  "pages.merchant.members.hallSwitch": "Hall Status",
  "pages.merchant.members.hallSwitch.enabled": "Enabled",
  "pages.merchant.members.hallSwitch.disabled": "Not Enabled",
  "pages.merchant.members.action.hallConfig": "Hall Config",
  "pages.merchant.members.hallConfig.title": "Hall Config",
  "pages.merchant.members.hallConfig.save": "Save and Publish",
  "pages.merchant.members.hallConfig.loadFailed":
    "Failed to load hall configuration",
  "pages.merchant.members.hallConfig.saveSuccess":
    "Hall configuration saved successfully",
  "pages.merchant.members.hallConfig.reviewPending":
    "An existing configuration is pending review and cannot be modified",
  "pages.merchant.members.hallConfig.section.switch": "Games and Modules",
  "pages.merchant.members.hallConfig.section.activity": "Event Config",
  "pages.merchant.members.hallConfig.section.game": "Games Config",
  "pages.merchant.members.hallConfig.switch.hall": "Hall Switch",
  "pages.merchant.members.hallConfig.switch.hallHint":
    "When disabled, players cannot open the hall UI while playing this merchant's games",
  "pages.merchant.members.hallConfig.switch.activity": "Event Module",
  "pages.merchant.members.hallConfig.switch.activityHint":
    "Show active event games, countdowns, and privilege badges",
  "pages.merchant.members.hallConfig.switch.game": "Games Module",
  "pages.merchant.members.hallConfig.switch.gameHint":
    "Show all games enabled for the merchant for quick navigation",
  "pages.merchant.members.hallConfig.activity.column.type": "Activity Type",
  "pages.merchant.members.hallConfig.activity.column.gameName": "Game Name",
  "pages.merchant.members.hallConfig.activity.column.name": "Activity Name",
  "pages.merchant.members.hallConfig.activity.column.time": "Activity Time",
  "pages.merchant.members.hallConfig.activity.column.badge": "Activity Badge",
  "pages.merchant.members.hallConfig.game.column.name": "Game",
  "pages.merchant.members.hallConfig.game.column.badge": "Game Badge",
  "pages.merchant.members.hallConfig.column.weight": "Weight",
  "pages.merchant.members.hallConfig.column.visible": "Visible",
  "pages.merchant.members.hallConfig.badge.placeholder": "Select badge",
  "pages.merchant.members.hallConfig.activityType.cumulative": "Cumulative",
  "pages.merchant.members.hallConfig.activityType.sevenDay": "7-day",
  "pages.merchant.members.hallConfig.activityType.surprise": "Surprise",
  "pages.merchant.members.hallConfig.empty": "No configuration data",
  "pages.merchant.members.edit.title.edit": "Edit Merchant",
  "pages.merchant.members.edit.title.add": "Add Merchant",
  "pages.merchant.members.edit.form.merchantName": "Merchant Name",
  "pages.merchant.members.edit.form.merchantName.required":
    "Please enter merchant name",
  "pages.merchant.members.edit.form.manager": "Manager",
  "pages.merchant.members.edit.form.manager.required": "Please enter manager",
  "pages.merchant.members.edit.form.email": "Contact Email",
  "pages.merchant.members.edit.form.email.required":
    "Please enter contact email",
  "pages.merchant.members.edit.form.email.invalid":
    "Please enter a valid email address",
  "pages.merchant.members.edit.form.username": "Login Account",
  "pages.merchant.members.edit.form.username.required":
    "Please enter login account",
  "pages.merchant.members.edit.form.password": "Login Password",
  "pages.merchant.members.edit.form.password.required":
    "Please enter login password",
  "pages.merchant.members.edit.form.parent": "Parent",
  "pages.merchant.members.edit.form.parent.placeholder": "Select (single)",
  "pages.merchant.members.edit.form.walletType": "Wallet Type",
  "pages.merchant.members.edit.form.walletType.required":
    "Please select wallet type",
  "pages.merchant.members.edit.form.walletType.transfer": "Transfer Mode",
  "pages.merchant.members.edit.form.walletType.single": "Single Wallet Mode",
  "pages.merchant.members.edit.form.incomeShare": "Income Share (%)",
  "pages.merchant.members.edit.form.feeRate": "Fee Rate (%)",
  "pages.merchant.members.edit.form.serverAddress": "Server Address",
  "pages.merchant.members.edit.form.serverAddress.required":
    "Please enter server address",
  "pages.merchant.members.edit.form.serverAddress.placeholder":
    "Please enter IP address or domain",
  "pages.merchant.members.edit.form.serverAddress.invalid":
    "Please enter a valid IP address or domain",
  "pages.merchant.members.edit.form.serverRegion": "Server Region",
  "pages.merchant.members.edit.form.serverRegion.placeholder":
    "Please select server region",
  "pages.merchant.members.edit.form.serverRegion.required":
    "Please select server region",
  "pages.merchant.members.edit.form.ipWhitelist": "IP Whitelist",
  "pages.merchant.members.edit.form.ipWhitelist.placeholder":
    "Please enter IP address",
  "pages.merchant.members.edit.form.ip.required": "Please enter IP address",
  "pages.merchant.members.edit.form.ip.invalid":
    "Please enter a valid IP address",
  "pages.merchant.members.edit.form.remark": "Remark",
  "pages.merchant.members.edit.form.groupDailySwitch": "Group Daily Report",
  "pages.merchant.members.edit.form.groupDailySwitch.tip":
    "After enabling, risk-control records for games under this channel are sent to the group",
  "pages.merchant.members.edit.form.groupDailySwitch.enabled": "Enable",
  "pages.merchant.members.edit.form.groupDailySwitch.disabled": "Disable",
  "pages.merchant.members.edit.form.forceSettlement": "Auto Settlement",
  "pages.merchant.members.edit.form.forceSettlement.open": "Enable",
  "pages.merchant.members.edit.form.forceSettlement.close": "Disable",
  "pages.merchant.members.edit.form.status": "Status",
  "pages.merchant.members.edit.form.status.required": "Please select status",
  "pages.merchant.members.edit.form.status.normal": "Normal",
  "pages.merchant.members.edit.form.status.frozen": "Frozen",
  "pages.merchant.members.edit.form.placeholder": "Please enter",
  "pages.merchant.members.edit.message.updateSuccess": "Update success",
  "pages.merchant.members.edit.message.addSuccess":
    "Saved successfully. You can go to Onboarding Application to submit for publishing. The creation will complete after platform approval.",
  "pages.merchant.members.edit.action.saveDraft": "Save Draft",
  "pages.merchant.members.edit.message.operationSuccess":
    "Operation successful",
  "pages.merchant.members.apply.action.saveAndPublish": "Save and Publish",
  "pages.merchant.members.apply.message.submitSuccess":
    "Published successfully. You can go to Onboarding Application to check the review status.",
  "pages.merchant.members.edit.message.hierarchyChanged":
    'Modify success, added to "{name}" hierarchy',
  "pages.merchant.members.create.step.basic": "Basic Information",
  "pages.merchant.members.create.step.games": "Open Game",
  "pages.merchant.members.create.error.missingAppid":
    "Merchant created successfully, but appid was not returned, so game opening cannot continue",
  "pages.merchant.members.gameConfig.title": "Open Game - {merchantName}",
  "pages.merchant.members.gameConfig.selectedCount": "{count} items selected",
  "pages.merchant.members.gameConfig.batchEnable": "Batch Open",
  "pages.merchant.members.gameConfig.batchDisable": "Batch Close",
  "pages.merchant.members.gameConfig.confirm.titleAll":
    "Confirm close all games?",
  "pages.merchant.members.gameConfig.confirm.title": "Confirm close game?",
  "pages.merchant.members.gameConfig.confirm.contentAll":
    "After closing all games, the merchant will not be able to get all game resources, causing frontend users to be unable to bet normally. Please operate carefully!",
  "pages.merchant.members.gameConfig.confirm.content":
    "After closing the game, the merchant will not be able to get the game resource, causing frontend users to be unable to bet normally. Please operate carefully!",
  "pages.merchant.members.gameConfig.success":
    "Game configuration updated successfully",
  "pages.merchant.members.gameConfig.saveConfirm.title": "Confirm Save",
  "pages.merchant.members.gameConfig.saveConfirm.content":
    "Are you sure you want to save the current game configuration?",
  "pages.merchant.members.gameConfig.searchHint":
    'After modifying the switches in the list, click the "OK" button in the upper right corner to take effect.',
  "pages.merchant.members.gameConfig.loadFailed":
    "Failed to load game list, please try again",
  "pages.merchant.members.gameConfig.column.gameId": "Game ID",
  "pages.merchant.members.gameConfig.column.name": "Name",
  "pages.merchant.members.gameConfig.column.type": "Type",
  "pages.merchant.members.gameConfig.column.language": "Support Language",
  "pages.merchant.members.gameConfig.column.currency": "Support Currency",
  "pages.merchant.members.gameConfig.column.action": "Open/Close",
  "pages.merchant.members.gameConfig.column.action.tooltip":
    'After modifying the switch, please click "OK" to save the settings.',
  "pages.merchant.members.gameConfig.risk.apply.title":
    "Apply to Other Merchants Under the Same Agent",
  "pages.merchant.members.gameConfig.risk.apply.desc":
    "When checked, the current risk threshold will be synced to the selected merchants upon save. Unchecked merchants are unaffected.",
  "pages.merchant.members.gameConfig.risk.apply.selectedCount":
    "Selected ({selected}/{total})",
  "pages.merchant.members.gameConfig.risk.apply.selectAll": "Select All",
  "pages.merchant.members.gameConfig.risk.apply.cancelAll": "Deselect All",
  "pages.merchant.members.gameConfig.risk.apply.empty":
    "No other merchants available under the current user",
  "pages.merchant.members.gameConfig.newPlayer.apply.title":
    "Apply to Other Merchants",
  "pages.merchant.members.gameConfig.newPlayer.apply.desc":
    "Apply to other merchants under the same agent",
  "pages.merchant.members.gameConfig.newPlayer.apply.selectedCount":
    "Selected ({selected}/{total})",
  "pages.merchant.members.gameConfig.newPlayer.apply.selectAll": "Select All",
  "pages.merchant.members.gameConfig.newPlayer.apply.cancelAll": "Deselect All",
  "pages.merchant.members.gameConfig.newPlayer.apply.empty":
    "No other merchants available under the current user",
  "pages.merchant.members.gameConfig.newPlayer.effectiveData": "Effective",
  "pages.merchant.members.gameConfig.rtp.apply.title":
    "Apply to Other Merchants",
  "pages.merchant.members.gameConfig.rtp.apply.desc":
    "Apply to other merchants under the same agent",
  "pages.merchant.members.gameConfig.rtp.apply.selectedCount":
    "Selected ({selected}/{total})",
  "pages.merchant.members.gameConfig.rtp.apply.selectAll": "Select All",
  "pages.merchant.members.gameConfig.rtp.apply.cancelAll": "Deselect All",
  "pages.merchant.members.gameConfig.rtp.apply.empty":
    "No other merchants available under the current user",
  "pages.merchant.members.gameConfig.rtp.apply.tip":
    "*Selected merchants will be overridden by this RTP weight configuration",
  "pages.merchant.members.gameConfig.rtp.approved":
    "Your RTP weight adjustment has been approved.",
  "pages.merchant.members.gameConfig.rtp.rejected":
    "Your RTP weight adjustment has been rejected. Please check the review comments and resubmit.",
  "pages.merchant.members.gameConfig.rtp.reviewComments":
    "Review Comments: {comments}",
  "pages.merchant.members.gameConfig.rtp.submit": "Save & Publish",
  "pages.merchant.members.gameConfig.rtp.submit.pending": "Under Review",
  "pages.merchant.members.gameConfig.risk.entry": "Risk Threshold",
  "pages.merchant.members.gameConfig.risk.emptySetting": "Set Risk Threshold",
  "pages.merchant.members.gameConfig.risk.tooltip":
    "Max Single Bet / Max Re-Spin Times / New Player Single Bet Threshold",
  "pages.merchant.members.gameConfig.risk.title": "Risk Threshold",
  "pages.merchant.members.gameConfig.risk.success":
    "Risk threshold updated successfully",
  "pages.merchant.members.gameConfig.risk.confirm.title": "Confirm Save",
  "pages.merchant.members.gameConfig.risk.confirm.content":
    "Risk threshold changes take effect immediately. Confirm saving current configuration?",
  "pages.merchant.members.gameConfig.risk.loadFailed":
    "Failed to load risk threshold, please try again",
  "pages.merchant.members.gameConfig.risk.partialSuccess":
    "Current merchant saved, failed to sync: {merchants}",
  "pages.merchant.members.gameConfig.risk.currentMerchant": "Current Merchant",
  "pages.merchant.members.gameConfig.risk.currentGame": "Current Game",
  "pages.merchant.members.gameConfig.risk.currentAgent": "Parent Agent",
  "pages.merchant.members.gameConfig.risk.group.global":
    "Global Risk Threshold",
  "pages.merchant.members.gameConfig.risk.group.global.desc":
    "Configure general risk thresholds. Takes effect immediately after saving.",
  "pages.merchant.members.gameConfig.risk.group.special":
    "Special Risk Threshold",
  "pages.merchant.members.gameConfig.risk.group.special.desc":
    "Overrides risk limits for special scenarios. Uses global settings if left empty.",
  "pages.merchant.members.gameConfig.risk.special.deadGameRiskThreshold":
    "Mini Game 3 Mode Risk",
  "pages.merchant.members.gameConfig.risk.special.deadGameReSpinTimes":
    "ReSpin Times",
  "pages.merchant.members.gameConfig.risk.special.maxWinThreshold":
    "MaxWin Risk",
  "pages.merchant.members.gameConfig.risk.special.reSpinTimes": "ReSpin Times",
  "pages.merchant.members.gameConfig.risk.special.flyThreshold":
    "Fly Mode Risk",
  "pages.merchant.members.gameConfig.risk.special.game1Threshold":
    "Mini Game 1 Risk",
  "pages.merchant.members.gameConfig.risk.group.jackpot":
    "New Player Jackpot Risk Amount",
  "pages.merchant.members.gameConfig.risk.group.jackpot.desc":
    "Controls risk thresholds for the new player jackpot. Supports independent configuration.",
  "pages.merchant.members.gameConfig.risk.field.singleMaxAmount":
    "Single Bet Max Amount",
  "pages.merchant.members.gameConfig.risk.field.singleMaxAmount.desc":
    "Maximum amount triggered by a single bet.",
  "pages.merchant.members.gameConfig.risk.field.maxRandomTimes":
    "Max Random Times",
  "pages.merchant.members.gameConfig.risk.field.maxRandomTimes.desc":
    "Maximum number of random times allowed in one process. (Recommended: 20, max recommended: 50)",
  "pages.merchant.members.gameConfig.risk.field.moreInfo":
    "Special Risk Threshold",
  "pages.merchant.members.gameConfig.risk.field.newPlayerThreshold":
    "New Player Single Bet Risk Amount",
  "pages.merchant.members.gameConfig.risk.unit.amount": "Amount",
  "pages.merchant.members.gameConfig.risk.unit.times": "Times",
  "pages.merchant.members.gameConfig.risk.apply.keepGameConfig":
    "Batch sync only updates risk thresholds and will not overwrite existing game configurations of each merchant.",
  "pages.merchant.members.gameConfig.newPlayer.entry": "New Player Config",
  "pages.merchant.members.gameConfig.newPlayer.emptySetting":
    "Set New Player Pool",
  "pages.merchant.members.gameConfig.newPlayer.tooltip":
    "Remaining Jackpot / Initial Jackpot",
  "pages.merchant.members.gameConfig.newPlayer.title":
    "New Player Jackpot Configuration",
  "pages.merchant.members.gameConfig.newPlayer.loadFailed":
    "Failed to load new player config, please try again",
  "pages.merchant.members.gameConfig.newPlayer.success":
    "New player config saved successfully",
  "pages.merchant.members.gameConfig.newPlayer.submitFailed":
    "Failed to submit new player config, please try again",
  "pages.merchant.members.gameConfig.newPlayer.confirm.title":
    "Confirm Submission",
  "pages.merchant.members.gameConfig.newPlayer.confirm.content":
    "The new player config requires reviewer approval before taking effect. Confirm submission?",
  "pages.merchant.members.gameConfig.newPlayer.currentMerchant":
    "Current Merchant",
  "pages.merchant.members.gameConfig.newPlayer.currentGame": "Current Game",
  "pages.merchant.members.gameConfig.newPlayer.currentAgent": "Parent Agent",
  "pages.merchant.members.gameConfig.newPlayer.copy.action": "Copy Last Config",
  "pages.merchant.members.gameConfig.newPlayer.copy.empty":
    "No previous config to copy",
  "pages.merchant.members.gameConfig.newPlayer.copy.success":
    "Last config copied",
  "pages.merchant.members.gameConfig.newPlayer.copy.confirm.title":
    "Confirm Overwrite",
  "pages.merchant.members.gameConfig.newPlayer.copy.confirm.content":
    "The form already has content. Confirming will overwrite current input with the last saved configuration.",
  "pages.merchant.members.gameConfig.newPlayer.group.core":
    "Jackpot Basic Settings",
  "pages.merchant.members.gameConfig.newPlayer.group.nextDayJackpot":
    "Next Day Jackpot Amount",
  "pages.merchant.members.gameConfig.newPlayer.group.trigger":
    "Trigger Probability & Maintenance",
  "pages.merchant.members.gameConfig.newPlayer.group.exit":
    "Forced Exit Conditions",
  "pages.merchant.members.gameConfig.newPlayer.group.risk": "Risk Control",
  "pages.merchant.members.gameConfig.newPlayer.schedule.mode.daily": "Daily",
  "pages.merchant.members.gameConfig.newPlayer.schedule.mode.weekly": "Weekly",
  "pages.merchant.members.gameConfig.newPlayer.schedule.mode.monthly":
    "Monthly",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.1": "Monday",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.2": "Tuesday",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.3": "Wednesday",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.4": "Thursday",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.5": "Friday",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.6": "Saturday",
  "pages.merchant.members.gameConfig.newPlayer.schedule.weekday.7": "Sunday",
  "pages.merchant.members.gameConfig.newPlayer.schedule.monthDay": "Day {day}",
  "pages.merchant.members.gameConfig.newPlayer.field.cron.placeholder":
    "Enter schedule config",
  "pages.merchant.members.gameConfig.newPlayer.field.jackpot":
    "Initial Jackpot Amount",
  "pages.merchant.members.gameConfig.newPlayer.field.jackpot.desc":
    "Initial amount of the new player jackpot.",
  "pages.merchant.members.gameConfig.newPlayer.field.firstCron":
    "First Distribution Time",
  "pages.merchant.members.gameConfig.newPlayer.field.firstCron.desc":
    "Configure the first distribution time.",
  "pages.merchant.members.gameConfig.newPlayer.field.secondCron":
    "Second Distribution Time",
  "pages.merchant.members.gameConfig.newPlayer.field.secondCron.desc":
    "Configure the second distribution time.",
  "pages.merchant.members.gameConfig.newPlayer.field.subRtp":
    "Next Day Jackpot Trigger RTP",
  "pages.merchant.members.gameConfig.newPlayer.field.subRtp.desc":
    "(Next day trigger RTP - yesterday actual RTP) multiplied by yesterday total bet amount, used to determine next day jackpot trigger condition.",
  "pages.merchant.members.gameConfig.newPlayer.field.minSubScore":
    "Next Day Jackpot Trigger Threshold",
  "pages.merchant.members.gameConfig.newPlayer.field.minSubScore.desc":
    "When the calculated result is greater than or equal to this threshold, the high jackpot amount is used; otherwise the low jackpot amount is used.",
  "pages.merchant.members.gameConfig.newPlayer.field.gtSetJackpotScore":
    "High Jackpot Amount",
  "pages.merchant.members.gameConfig.newPlayer.field.gtSetJackpotScore.desc":
    "Used when trigger conditions are met.",
  "pages.merchant.members.gameConfig.newPlayer.field.gtSetJackpotScore.extra":
    "Used when trigger conditions met",
  "pages.merchant.members.gameConfig.newPlayer.field.ltSetJackpotScore":
    "Low Jackpot Amount",
  "pages.merchant.members.gameConfig.newPlayer.field.ltSetJackpotScore.desc":
    "Used when trigger conditions are not met.",
  "pages.merchant.members.gameConfig.newPlayer.field.ltSetJackpotScore.extra":
    "Used when trigger conditions not met",
  "pages.merchant.members.gameConfig.newPlayer.field.trigJackpotPercent":
    "Trigger Probability",
  "pages.merchant.members.gameConfig.newPlayer.field.trigJackpotPercent.desc":
    "Probability of a new account entering the new player state.",
  "pages.merchant.members.gameConfig.newPlayer.field.trigHighRtpPercent":
    "Maintenance Probability",
  "pages.merchant.members.gameConfig.newPlayer.field.trigHighRtpPercent.desc":
    "Probability of each spin hitting the new player RTP during new player status.",
  "pages.merchant.members.gameConfig.newPlayer.field.maxSpin":
    "Cumulative Spin",
  "pages.merchant.members.gameConfig.newPlayer.field.maxSpin.desc":
    "Number of spins to exit the new player state.",
  "pages.merchant.members.gameConfig.newPlayer.field.maxWin": "Cumulative Win",
  "pages.merchant.members.gameConfig.newPlayer.field.maxWin.desc":
    "Cumulative win amount to exit the new player state.",
  "pages.merchant.members.gameConfig.newPlayer.field.singleScore":
    "Single Bet Risk Amount",
  "pages.merchant.members.gameConfig.newPlayer.field.singleScore.desc":
    "Risk amount for new player hitting RTP.",
  "pages.merchant.members.gameConfig.rtp.entry": "RTP Adjustment",
  "pages.merchant.members.gameConfig.rtp.emptySetting": "Set RTP Adjustment",
  "pages.merchant.members.gameConfig.rtp.title": "Adjust RTP Weight",
  "pages.merchant.members.gameConfig.rtp.loadFailed":
    "Failed to load RTP config",
  "pages.merchant.members.gameConfig.rtp.success":
    "RTP adjustment request submitted",
  "pages.merchant.members.gameConfig.rtp.currentMerchant": "Merchant: ",
  "pages.merchant.members.gameConfig.rtp.currentGame": "Game: ",
  "pages.merchant.members.gameConfig.rtp.confirm.title": "Adjust RTP Weight",
  "pages.merchant.members.gameConfig.rtp.confirm.content":
    "The RTP weight adjustment requires reviewer approval before taking effect. Confirm submission of this request?",
  "pages.merchant.members.gameConfig.rtp.version": "Version",
  "pages.merchant.members.gameConfig.rtp.weight.title": "Allocate RTP Ratio",
  "pages.merchant.members.gameConfig.rtp.weight.assigned": "Allocated {value}",
  "pages.merchant.members.gameConfig.rtp.weight.tip":
    "Set the RTP ratio for each weight tier",
  "pages.merchant.members.gameConfig.rtp.weight.invalid":
    "RTP ratios must total 100%. Save & submit only when total equals 100%.",
  "pages.merchant.members.gameConfig.rtp.tier.high": "High",
  "pages.merchant.members.gameConfig.rtp.tier.medium": "Medium",
  "pages.merchant.members.gameConfig.rtp.tier.low": "Low",
  "pages.merchant.members.gameConfig.rtp.empty":
    "No RTP templates available for adjustment",
  "pages.merchant.members.gameConfig.rtp.placeholder":
    "Please select RTP template",
  "pages.merchant.members.gameConfig.rtp.noWeight.label": "RTP Config File",
  "pages.merchant.members.gameConfig.rtp.overall.title":
    "Final Overall Game RTP",
  "pages.merchant.members.gameConfig.rtp.overall.tip":
    "Overall RTP is calculated as (weight/total weight) * RTP per tier",
  "pages.merchant.members.gameConfig.rtp.overall.desc":
    "Divide each tier weight by the total weight, multiply by the corresponding RTP, then sum all three",
  "pages.merchant.members.gameConfig.betLevel.entry": "Change Bet Level",
  "pages.merchant.members.gameConfig.betLevel.modalTitle": "Change Bet Level",
  "pages.merchant.members.gameConfig.betLevel.subTitle":
    "Selecting a new bet level for game {gameName}",
  "pages.merchant.members.gameConfig.betLevel.selectTemplate":
    "Select a bet level template to apply to this game:",
  "pages.merchant.members.gameConfig.betLevel.previewCurrency":
    "Preview currency:",
  "pages.merchant.members.gameConfig.betLevel.levelName": "Level Name",
  "pages.merchant.members.gameConfig.betLevel.levelDistribution":
    "{currency} Level Distribution",
  "pages.merchant.members.gameConfig.betLevel.column.select": "Select",
  "pages.merchant.members.gameConfig.betLevel.loadFailed":
    "Failed to load bet level list, please try again",
  "pages.merchant.members.gameConfig.betLevel.success":
    "Bet level change request submitted",
  "pages.merchant.members.gameConfig.betLevel.warning":
    "Note: Changing the bet level will **simultaneously apply** the numerical rules for all supported currencies (USD, HKD, JPY, etc.) configured under this level. This may impact live revenue, please proceed carefully.",
  "pages.merchant.members.gameConfig.betLevel.currentGame": "Current Game",
  "pages.merchant.members.gameConfig.betLevel.currentLevel": "Current Level",
  "pages.merchant.members.gameConfig.betLevel.currentLevel.empty": "Set Level",
  "pages.merchant.members.gameConfig.betLevel.currency": "Currency Switch",
  "pages.merchant.members.gameConfig.betLevel.empty":
    "No available bet levels to change",
  "pages.merchant.members.gameConfig.betLevel.distribution":
    "{currency} Level Distribution",
  "pages.merchant.members.gameConfig.betLevel.distribution.empty":
    "No level distribution for current currency",
  "pages.merchant.members.gameConfig.betLevel.distribution.summaryEmpty":
    "Set Level",
  "pages.merchant.members.gameConfig.betLevel.distribution.tooltipTitle":
    "All Currencies Level Distribution",
  "pages.merchant.members.gameConfig.betLevel.distribution.tooltipDescription":
    "Displays the level distribution values for all configured currencies. Default level markers remain unchanged.",
  "pages.merchant.members.gameConfig.betLevel.currentTag": "Current Level",
  "pages.merchant.members.gameConfig.betLevel.defaultTag": "Default Level",
  "pages.merchant.members.gameConfig.betLevel.defaultSuffix": "Default",
  "pages.merchant.members.gameConfig.betLevel.target.required":
    "Please select a target level",
  "pages.merchant.members.gameConfig.betLevel.confirm.action": "Confirm Change",
  "pages.merchant.members.gameConfig.betLevel.confirm.pending": "Under Review",
  "pages.merchant.members.gameConfig.betLevel.confirm.title":
    "Confirm Level Change",
  "pages.merchant.members.gameConfig.betLevel.confirm.content":
    'Confirm switching game "{gameName}" to level "{targetLevelName}"? This may affect live revenue.',
  "pages.merchant.members.gameConfig.betLevel.emptyValue": "-",
  "pages.merchant.members.gameConfig.betLevel.pendingDraft":
    "Pending level change: {name}",
  "pages.merchant.members.gameConfig.betLevel.rejectedDraft":
    "Rejected draft: {name}",
  "pages.merchant.members.gameConfig.betLevel.status.pending": "Under Review",
  "pages.merchant.members.gameConfig.betLevel.status.rejected": "Rejected",
  "pages.merchant.members.gameConfig.column.betLevel": "Current Level",
  "pages.merchant.members.gameConfig.column.betLevelDistribution":
    "Level Distribution (Multi-Currency)",
  "pages.merchant.members.gameConfig.column.operation": "Operation",
  "pages.merchant.members.agent.title.edit": "Edit Agent",
  "pages.merchant.members.agent.title.add": "Add Agent",
  "pages.merchant.members.agent.form.level": "Level",
  "pages.merchant.members.agent.form.level.required": "Please select level",
  "pages.merchant.members.agent.form.level.1": "Level 1 Agent",
  "pages.merchant.members.agent.form.level.2": "Level 2 Agent",
  "pages.merchant.members.agent.form.parent.platform": "Platform",
  "pages.merchant.members.agent.form.agentName": "Agent Name",
  "pages.merchant.members.agent.form.agentName.required":
    "Please enter agent name",
  "pages.merchant.members.agent.form.fee": "Fee (%)",
  "pages.merchant.members.agent.form.fee.required": "Please enter fee",
  "pages.merchant.members.action.login": "Login",
  "pages.merchant.members.action.edit": "Edit",
  "pages.merchant.members.action.detail": "Detail",
  "pages.merchant.members.action.more": "More",
  "pages.merchant.members.action.currencyRatio": "Currency Ratio",
  "pages.merchant.members.action.resetKey": "Reset Public Key",
  "pages.merchant.members.action.resetPwd": "Reset Password",
  "pages.merchant.members.action.resetGoogle": "Reset Google Auth",
  "pages.merchant.members.action.resetGoogle.confirm":
    "Confirm reset Google auth",
  "pages.merchant.members.action.resetGoogle.content":
    "After resetting, the merchant needs to re-bind Google auth when logging in",
  "pages.merchant.members.action.resetGoogle.success":
    "Google auth reset successfully",
  "pages.merchant.members.action.openGame": "Open Game",
  "pages.merchant.members.action.bindMerchant": "Bind Merchant",
  "pages.merchant.members.action.unbindPID": "Unbind Parent",
  "pages.merchant.members.action.delete": "Delete",
  "pages.merchant.members.login.loading": "Preparing login environment...",

  "pages.merchant.members.resetPassword.title": "Reset Password",
  "pages.merchant.members.resetPassword.form.newPassword": "New Password",
  "pages.merchant.members.resetPassword.form.newPassword.placeholder":
    "Please enter new password",
  "pages.merchant.members.resetPassword.form.newPassword.required":
    "Please enter new password",
  "pages.merchant.members.resetPassword.form.newPassword.min":
    "Password must be at least 6 characters",
  "pages.merchant.members.resetPassword.form.confirmPassword":
    "Confirm New Password",
  "pages.merchant.members.resetPassword.form.confirmPassword.placeholder":
    "Please enter new password again",
  "pages.merchant.members.resetPassword.form.confirmPassword.required":
    "Please confirm new password",
  "pages.merchant.members.resetPassword.form.confirmPassword.mismatch":
    "The two passwords entered are inconsistent",
  "pages.merchant.members.resetPassword.success": "Password reset successfully",

  "pages.merchant.members.resetPublicKey.title": "Reset Public Key",
  "pages.merchant.members.resetPublicKey.form.publicKey": "Public Key",
  "pages.merchant.members.resetPublicKey.form.publicKey.placeholder":
    "Please enter public key",
  "pages.merchant.members.resetPublicKey.form.publicKey.required":
    "Please enter public key",
  "pages.merchant.members.resetPublicKey.success":
    "Public key reset successfully",

  "pages.merchant.members.delete.title": "Confirm Delete Merchant?",
  "pages.merchant.members.delete.confirmText": "Confirm Delete",
  "pages.merchant.members.delete.reason.required": "Please enter delete reason",
  "pages.merchant.members.delete.reason.placeholder":
    "Please enter delete reason, explain the reason",
  "pages.merchant.members.delete.reason.label": "Delete Reason",
  "pages.merchant.members.delete.warning":
    'You are trying to delete merchant "{name}". The delete operation is irreversible and will result in all data of the merchant and its subordinates being inaccessible. Please be sure to confirm the operation!',
  "pages.merchant.members.delete.success": "Delete successful",
  "pages.merchant.members.unknownMerchant": "Unknown Merchant",
  "pages.merchant.members.batchAdd.title": "Batch Import Merchants",
  "pages.merchant.members.batchAdd.step1.title": "Download Template",
  "pages.merchant.members.batchAdd.step1.desc":
    "Please fill in the content according to the template. If the field does not comply with the rules, the upload will fail.",
  "pages.merchant.members.batchAdd.step1.button": "Download Batch Template",
  "pages.merchant.members.batchAdd.step2.title": "Upload Merchant Information",
  "pages.merchant.members.batchAdd.step2.file.placeholder": "Please add file",
  "pages.merchant.members.batchAdd.step2.upload.button": "Upload File",
  "pages.merchant.members.batchAdd.step2.upload.error.format":
    "Only supports .xlsx .xls format",
  "pages.merchant.members.batchAdd.step2.hint":
    "Only supports .xlsx .xls format",
  "pages.merchant.members.batchAdd.uploading": "Batch uploading...",
  "pages.merchant.members.batchAdd.success": "Import successful",
  "pages.merchant.members.batchAdd.error.fileRequired": "Please select file",
  "pages.merchant.members.batchAdd.error.uploadFailed":
    "Import failed, please check if the format is correct",
  "pages.merchant.members.batchAdd.templateName":
    "Merchant Batch Import Template.xlsx",

  "pages.merchant.members.bindOperator.title": "Bind Merchant - {name}",
  "pages.merchant.members.bindOperator.selectedCount": "Selected {count} items",
  "pages.merchant.members.bindOperator.placeholder": "Please enter ID or Name",
  "pages.merchant.members.bindOperator.success": "Binding successful",
  "pages.merchant.members.bindOperator.error.atLeastOne":
    "Please select at least one merchant",
  "pages.merchant.members.bindOperator.empty": "No merchants selected",

  "pages.merchant.members.unbindParent.title": "Confirm Unbind Parent?",
  "pages.merchant.members.unbindParent.reason.required":
    "Please fill in unbind reason",
  "pages.merchant.members.unbindParent.reason.placeholder":
    "Please fill in the reason, required",
  "pages.merchant.members.unbindParent.reason.label": "Unbind Reason",
  "pages.merchant.members.unbindParent.warning":
    'After unbinding, the parent "{parentName}" will not be able to get the commission generated by the subordinate "{name}" revenue. Commissions generated before unbinding still need to be calculated. Please operate carefully!',
  "pages.merchant.members.unbindParent.success": "Unbinding successful",
  "pages.merchant.members.action.batchStatus.noneSelected":
    "Please select items to operate first",
  "pages.merchant.members.action.enable": "Enable",
  "pages.merchant.members.action.disable": "Disable",
  "pages.merchant.members.action.batchStatus.confirm.title":
    "Confirm {type}{statusText}",
  "pages.merchant.members.action.batchStatus.confirm.content":
    "Are you sure you want to {statusText}[{names}]?",
  "pages.merchant.members.action.batchStatus.loading":
    "{type}{statusText} in progress...",
  "pages.merchant.members.action.batchStatus.success":
    "{type}{statusText} successfully",
  "pages.merchant.members.action.batchStatus.error": "{statusText} failed",
  "pages.merchant.members.action.batch": "Batch ",
  "pages.merchant.members.export.filename": "Merchant-",
  "pages.merchant.members.export.success": "Export successful",
  "pages.merchant.members.export.error": "Export failed",
  "pages.merchant.members.export.error.retry":
    "Export failed, please try again later",
  "pages.merchant.members.detail.title.agent": "Agent Detail",
  "pages.merchant.members.detail.title.merchant": "Merchant Detail",
  "pages.merchant.members.detail.tab.basic": "Basic Info",
  "pages.merchant.members.detail.tab.games": "Game List",
  "pages.merchant.members.detail.column.appId": "App ID",
  "pages.merchant.members.detail.column.loginAccount": "Login Account",
  "pages.merchant.members.detail.column.loginPassword": "Login Password",
  "pages.merchant.members.detail.column.parent.none": "None",
  "pages.merchant.members.detail.column.fee": "Fee Rate",
  "pages.merchant.members.detail.column.incomeShare": "Income Share",
  "pages.merchant.members.detail.column.serverAddress": "Server Address",
  "pages.merchant.members.detail.column.ipWhitelist": "IP Whitelist",
  "pages.merchant.members.detail.column.publicKey": "Merchant Public Key",
  "pages.merchant.members.detail.column.googleSecret": "Google Secret",
  "pages.merchant.members.detail.column.createdAt": "Created At",
  "pages.merchant.members.detail.column.bindTime": "Bind Time",
  "pages.merchant.members.detail.column.loginTime": "Last Login",
  "pages.merchant.members.detail.column.loginIp": "Login IP",
  "pages.merchant.members.detail.column.status.open": "Open",
  "pages.merchant.members.detail.column.status.close": "Closed",

  "pages.merchant.members.error.missingTicket":
    "Missing verification ticket, please re-verify",
  "pages.common.copySuccess": "Copy successful",

  // Game Management
  "pages.games.list.title": "Game Management",
  "pages.games.list.selected": "{count} items selected",
  "pages.games.action.batchEnable": "Enable",
  "pages.games.action.batchDisable": "Disable",
  "pages.games.action.add": "Add Game",
  "pages.games.action.edit": "Edit",
  "pages.games.action.detail": "Detail",
  "pages.games.action.openMerchant": "Open Merchant",
  "pages.games.action.gameType": "Game Type",
  "pages.games.action.gameTag": "Game Tag",
  "pages.games.column.createdAt": "Online Time",
  "pages.games.column.gameType": "Game Type",
  "pages.games.column.gameTags": "Game Tags",
  "pages.games.column.status": "Status",
  "pages.games.column.keywords": "Search Game",
  "pages.games.column.keywords.placeholder": "Game ID/Name",
  "pages.games.column.gameNumber": "Game ID",
  "pages.games.column.name": "Game Name",
  "pages.games.column.icon": "Icon",
  "pages.games.column.onlineTime": "Online Time",
  "pages.games.column.rtp": "RTP",
  "pages.games.column.maxWin": "Max win",
  "pages.games.column.volatile": "Volatile",
  "pages.games.column.payline": "Payline",
  "pages.games.column.action": "Action",
  "pages.games.status.normal": "Normal",
  "pages.games.status.disabled": "Disabled",
  "pages.games.batch.confirm.title": "Confirm batch {status}",
  "pages.games.batch.confirm.content":
    "Are you sure you want to {status} the selected {count} games?",
  "pages.games.batch.success": "Batch {status} successfully",
  "pages.games.single.success": "{status} successfully",
  "pages.games.single.enable": "Enable",
  "pages.games.single.disable": "Disable",
  "pages.games.warning.selectAtLeastOne":
    "Please select games to operate first",

  "pages.games.edit.title.add": "Add Game",
  "pages.games.edit.title.edit": "Edit Game",
  "pages.games.edit.title.detail": "Game Detail",
  "pages.games.edit.section.basic": "*Basic Info",
  "pages.games.edit.section.params": "Game Parameters",
  "pages.games.edit.form.gameNumber": "Game ID",
  "pages.games.edit.form.gameNumber.placeholder": "Please enter game ID",
  "pages.games.edit.form.gameNumber.required": "Game ID is required",
  "pages.games.edit.form.gameType": "Game Type",
  "pages.games.edit.form.gameType.placeholder": "Please select",
  "pages.games.edit.form.gameType.required": "Game type is required",
  "pages.games.edit.form.tagIds": "Game Tags",
  "pages.games.edit.form.tagIds.placeholder": "Please select game tags",
  "pages.games.edit.form.status": "Status",
  "pages.games.edit.form.icon": "Game Icon",
  "pages.games.edit.form.icon.required": "Game icon is required",
  "pages.games.edit.form.icon.tip": "Recommended size: 488*488px",
  "pages.games.edit.form.cover": "Game Cover",
  "pages.games.edit.form.cover.required": "Game cover is required",
  "pages.games.edit.form.cover.tip": "Recommended size: 480*640px",
  "pages.games.edit.form.horizontalVideoUrl": "Game Intro Video (Landscape)",
  "pages.games.edit.form.horizontalVideoUrl.tip":
    "Please upload a landscape game intro video",
  "pages.games.edit.form.verticalVideoUrl": "Game Intro Video (Portrait)",
  "pages.games.edit.form.verticalVideoUrl.tip":
    "Please upload a portrait game intro video",
  "pages.games.edit.form.onlineTime": "Online Time",
  "pages.games.edit.form.onlineTime.placeholder": "Please select...",
  "pages.games.edit.form.rtp": "RTP",
  "pages.games.edit.form.rtp.required": "RTP is required",
  "pages.games.edit.form.volatile": "Volatile",
  "pages.games.edit.form.volatile.placeholder": "Please select",
  "pages.games.edit.form.volatile.low": "Low",
  "pages.games.edit.form.volatile.medium": "Medium",
  "pages.games.edit.form.volatile.high": "High",
  "pages.games.edit.form.freespin": "freespin",
  "pages.games.edit.form.rtpAdjust": "RTP Adjust",
  "pages.games.edit.form.buyBonusCount": "Buy Bonus Count",
  "pages.games.edit.form.buyBonusCount.error": "Only numbers 1-7 are allowed",
  "pages.games.edit.form.reelConfig": "Reel Config",
  "pages.games.edit.form.reelConfig.placeholder": "e.g., 3*3",
  "pages.games.edit.form.reelConfig.error.pattern":
    "Only numbers and * are allowed",
  "pages.games.edit.form.payline": "Payline",
  "pages.games.edit.form.betRange": "Bet Range",
  "pages.games.edit.form.betRange.error.max":
    "Bet range must be between 0 and 1000",
  "pages.games.edit.form.winRate": "Win Rate",
  "pages.games.edit.form.winRate.required": "Win rate is required",
  "pages.games.edit.form.winRate.error.max": "Win rate cannot exceed 100",
  "pages.games.edit.message.addSuccess": "Added successfully",
  "pages.games.edit.message.editSuccess": "Updated successfully",
  "pages.games.edit.message.uploadIncomplete":
    "Please wait for images to finish uploading",
  "pages.games.edit.message.incompleteLangs":
    "Please enter complete language names",

  "pages.games.openMerchant.title": "Open Merchant - {gameName}",
  "pages.games.openMerchant.gameInfo": "Game Information",
  "pages.games.openMerchant.batchAction": "Batch Action",
  "pages.games.openMerchant.batchEnable": "Batch Open",
  "pages.games.openMerchant.batchDisable": "Batch Close",
  "pages.games.openMerchant.search.placeholder": "Merchant ID/Name",
  "pages.games.openMerchant.column.merchantId": "Merchant ID",
  "pages.games.openMerchant.column.merchantName": "Merchant Name",
  "pages.games.openMerchant.column.parent": "Direct Parent",
  "pages.games.openMerchant.column.status": "Open Status",
  "pages.games.openMerchant.message.saveSuccess": "Saved successfully",
  "pages.games.openMerchant.message.noChanges": "No changes, no need to save",

  "pages.games.type.title": "Game Type Management",
  "pages.games.type.column.id": "Type ID",
  "pages.games.type.column.name": "Type Name",
  "pages.games.type.column.sort": "Sort",
  "pages.games.type.column.action": "Action",
  "pages.games.type.action.add": "Add Type",
  "pages.games.type.action.edit": "Edit",
  "pages.games.type.action.delete": "Delete",
  "pages.games.type.delete.confirm":
    "Are you sure you want to delete this type?",
  "pages.games.type.form.name": "Type Name",
  "pages.games.type.form.name.required": "Please enter type name",
  "pages.games.type.form.sort": "Sort",
  "pages.games.type.form.sort.required": "Please enter sort number",
  "pages.games.type.message.finishEditing":
    "Please finish current editing first",
  "pages.games.type.message.inputName": "Please enter type name",
  "pages.games.type.delete.title": "Confirm delete type",
  "pages.games.type.delete.content":
    "After deletion, games with this type will automatically clear the type. Please operate carefully",
  "pages.games.type.drawer.title": "Game Type",
  "pages.games.tag.column.name": "Tag Name",
  "pages.games.tag.column.sort": "Sort",
  "pages.games.tag.column.action": "Action",
  "pages.games.tag.label": "Game Tag",
  "pages.games.tag.placeholder": "Please select game tag",
  "pages.games.tag.action.add": "Add Tag",
  "pages.games.tag.action.edit": "Edit",
  "pages.games.tag.action.delete": "Delete",
  "pages.games.tag.message.finishEditing":
    "Please finish current editing first",
  "pages.games.tag.message.inputName": "Please enter tag name",
  "pages.games.tag.delete.title": "Confirm delete tag",
  "pages.games.tag.delete.content":
    "After deletion, related data configured with this tag will be removed. Please operate carefully",
  "pages.games.tag.drawer.title": "Game Tag",

  // Common
  "pages.common.all": "All",
  "pages.common.today": "Today",
  "pages.common.last7days": "Last 7 Days",
  "pages.common.last30days": "Last 30 Days",
  "pages.common.ok": "OK",
  "pages.common.cancel": "Cancel",
  "pages.common.save": "Save",
  "pages.common.next": "Next",
  "pages.common.previous": "Previous",
  "pages.common.search": "Search",
  "pages.common.reset": "Reset",
  "pages.common.pagination.showTotal": "{range0}-{range1} of {total} items",
  "pages.common.placeholder": "Please enter",
  "pages.common.select.placeholder": "Please select",
  "pages.common.date.start": "Start Date",
  "pages.common.date.end": "End Date",
  "pages.common.date.preset.today": "Today",
  "pages.common.date.preset.yesterday": "Yesterday",
  "pages.common.date.preset.last7Days": "Last 7 Days",
  "pages.common.date.preset.last15Days": "Last 15 Days",
  "pages.common.date.preset.last30Days": "Last 30 Days",
  "pages.common.date.preset.all": "All",
  "pages.common.date.preset.thisMonth": "This Month",
  "pages.common.date.preset.lastMonth": "Last Month",
  "pages.common.saveSuccess": "Saved successfully",
  "pages.common.publishSuccess": "Published successfully",
  "pages.common.deleteSuccess": "Deleted successfully",
  "pages.common.exportFailed": "Export failed",
  "pages.common.error.decimal2": "Up to 2 decimal places allowed",
  "pages.common.createdAt": "Created Time",
  "pages.common.time.local": "Local Time",
  "pages.common.time.beijing": "Beijing Time",
  "pages.common.id": "ID",
  "pages.common.error.noChinese": "Chinese characters are not allowed",
  "pages.common.platform": "Platform",
  "pages.common.agent.level.1": "Level 1 Agent",
  "pages.common.agent.level.2": "Level 2 Agent",
  "pages.common.agent.placeholder": "Please select agent",
  "pages.common.merchant.label": "Merchant",
  "pages.common.merchant.select": "Select Merchant",
  "pages.common.merchant.placeholder": "Please select merchant",
  "pages.common.unknown": "Unknown",
  "pages.common.upload": "Upload",
  "pages.common.upload.error": "Upload Failed",
  "pages.common.reason.upgrade": "Agent Level - Upgrade",
  "pages.common.reason.downgrade": "Agent Level - Downgrade",
  "pages.common.reason.upgrade.tip":
    "After upgrading, agents under the tree will also upgrade. Please operate with caution!",
  "pages.common.reason.downgrade.tip":
    "After downgrading, this agent cannot bind level 2 agents under its tree. Please operate with caution!",
  "pages.common.reason.required": "Please fill in the reason",
  "pages.common.reason.placeholder": "Please fill in the reason, required",
  "pages.games.language.column.language": "Language",
  "pages.games.language.column.code": "Language Code",
  "pages.games.language.column.name": "Name",
  "pages.games.language.label": "Language Name",
  "pages.games.language.placeholder": "Please enter name",
  "pages.games.openMerchant.selectedCount": "Selected {count} items",
  "pages.games.openMerchant.message.selectMerchant":
    "Please select merchant(s) first",
  "pages.games.openMerchant.merchantLabel": "Merchant",
  "pages.games.openMerchant.filter.opened": "Opened",
  "pages.games.openMerchant.filter.notOpened": "Not Opened",
  "pages.games.edit.form.rtp.placeholder": "Please enter RTP",
  "pages.games.edit.form.payline.placeholder": "Please enter payline",
  "pages.games.edit.form.winRate.placeholder": "Please enter win rate",
  "pages.game_static.title": "Game Assets",
  "pages.game_static.column.name": "Name",
  "pages.game_static.column.key": "Path Key",
  "pages.game_static.column.action": "Action",
  "pages.game_static.action.download": "Download",
  "pages.game_static.action.preview": "Preview",
  "pages.game_static.action.previewLoading": "Loading...",
  "pages.game_static.action.expandAll": "Expand All",
  "pages.game_static.action.collapseAll": "Collapse All",
  "pages.game_static.type.folder": "Folder",
  "pages.game_static.type.file": "File",
  "pages.game_static.message.fetchFailed": "Failed to load static asset list",
  "pages.game_static.message.downloadFailed": "Download failed",
  "pages.game_static.message.previewFailed": "Preview failed",
  "pages.game_static.modal.downloadingFolder": "Downloading Folder",
  "pages.game_static.progress.download": "File Download Progress",
  "pages.game_static.progress.zip": "Compression Progress",
  "pages.game_static.progress.overall": "OVERALL PROGRESS",
  "pages.game_static.progress.of": "of",
  "pages.game_static.progress.elapsed": "Elapsed",
  "pages.game_static.downloadCenter.title": "Download List",
  "pages.game_static.downloadCenter.clear": "Clear Completed",
  "pages.game_static.downloadCenter.empty": "No download tasks",
  "pages.game_static.downloadCenter.expand": "Expand File Progress",
  "pages.game_static.downloadCenter.collapse": "Collapse File Progress",
  "pages.game_static.downloadCenter.zippingProgress": "Compression Progress",
  "pages.game_static.downloadCenter.status.downloading": "Downloading",
  "pages.game_static.downloadCenter.status.zipping": "Compressing",
  "pages.game_static.downloadCenter.status.done": "Completed",
  "pages.game_static.downloadCenter.status.failed": "Failed",
  "pages.game_static.downloadCenter.action.retry": "Retry Download",
  "pages.game_static.downloadCenter.refreshWarning":
    "Reminder: Refreshing the page will fail downloads and clear download records.",
  "pages.game_static.downloadCenter.notify.success":
    "Download {name} succeeded",

  // Develop Config
  "pages.develop.card.integration": "Integration Guide",
  "pages.develop.integration.desc":
    "To integrate with the Croco Gaming system, please refer to the links below and follow the required steps.",
  "pages.develop.integration.doc": "Integration Document:",
  "pages.develop.integration.docTrans": "Integration Document (Transfer Mode):",
  "pages.develop.integration.api": "Production API URL:",
  "pages.develop.integration.download": "Game Asset Download:",
  "pages.develop.card.notice": "Important Notice",
  "pages.develop.notice.primary":
    "Please complete the RSA public key and RSA private key here, and use this key pair to generate signatures. Generating a new key pair will invalidate the previous one.",
  "pages.develop.notice.secondary":
    "We will keep operator information confidential. Please use it with confidence.",
  "pages.develop.card.keyConfig": "Key Configuration",
  "pages.develop.form.appId.label": "APP ID (Unique Operator Identifier)",
  "pages.develop.form.appId.placeholder": "Please enter APP ID",
  "pages.develop.form.platformPublicKey.label":
    "Croco Gaming Platform Public Key",
  "pages.develop.form.platformPublicKey.placeholder":
    "Please enter Croco Gaming platform public key",
  "pages.develop.form.rsaPublicKey.label": "RSA Public Key",
  "pages.develop.form.rsaPublicKey.placeholder": "Please enter RSA public key",
  "pages.develop.form.rsaPrivateKey.label": "RSA Private Key",
  "pages.develop.form.rsaPrivateKey.placeholder":
    "Please enter RSA private key",
  "pages.develop.card.signTest": "Signature Test",
  "pages.develop.form.signSource.label": "Data To Sign",
  "pages.develop.form.signSource.placeholder": "Please enter data to sign",
  "pages.develop.form.signResult.label": "Encrypted Data",
  "pages.develop.form.signResult.placeholder":
    "Signature result will be displayed here",
  "pages.develop.action.sign": "Sign",
  "pages.develop.message.noContent": "No content to copy",
  "pages.develop.message.copyFailed": "Copy failed",
  "pages.develop.message.signSourceRequired": "Please enter data to sign",
  "pages.develop.message.signSuccess": "Sign successful",
  "pages.develop.message.signFailed": "Sign failed",
  "pages.develop.message.initFailed":
    "Failed to load initial configuration, default content is shown",
  "pages.develop.message.resetSuccess": "Reset successful",
  "pages.develop.message.resetFailed": "Reset failed",

  // Permission Management
  "pages.system.auth.title": "Permission Management",
  "pages.system.auth.column.name": "Menu Name",
  "pages.system.auth.column.nameEn": "Menu English Name",
  "pages.system.auth.column.address": "Menu Address",
  "pages.system.auth.column.icon": "Menu Icon",
  "pages.system.auth.column.createdAt": "Created At",
  "pages.system.auth.column.type": "Menu Type",
  "pages.system.auth.column.type.page": "Page",
  "pages.system.auth.column.type.button": "Button",
  "pages.system.auth.column.visible": "Applicable Subjects",
  "pages.system.auth.column.visible.platform": "Platform",
  "pages.system.auth.column.visible.agent1": "Level 1 Agent",
  "pages.system.auth.column.visible.agent2": "Level 2 Agent",
  "pages.system.auth.column.visible.merchant": "Merchant",
  "pages.system.auth.column.sort": "Sort (Higher First)",
  "pages.system.auth.column.action": "Action",
  "pages.system.auth.action.addChild": "Add Submenu",
  "pages.system.auth.action.addRoot": "Add Root Menu",
  "pages.system.auth.action.edit": "Edit",
  "pages.system.auth.action.delete": "Delete",
  "pages.system.auth.delete.confirm.title": "Hint",
  "pages.system.auth.delete.confirm.content":
    "Are you sure you want to delete this menu?",
  "pages.system.auth.delete.success": "Deleted successfully",
  "pages.system.auth.delete.failure": "Deletion failed",
  "pages.system.auth.rootMenu": "Root Menu",
  "pages.system.auth.form.parent": "Parent Node",
  "pages.system.auth.form.parent.required": "Please select parent node",
  "pages.system.auth.form.name": "Menu Name",
  "pages.system.auth.form.name.required": "Please enter menu name",
  "pages.system.auth.form.nameEn": "Menu English Name",
  "pages.system.auth.form.nameEn.required": "Please enter menu English name",
  "pages.system.auth.form.address": "Menu Address",
  "pages.system.auth.form.address.required": "Please enter menu address",
  "pages.system.auth.form.icon": "Icon",
  "pages.system.auth.form.icon.placeholder": "Please select icon",
  "pages.system.auth.form.type": "Menu Type",
  "pages.system.auth.form.type.required": "Please select menu type",
  "pages.system.auth.form.visible": "Applicable Subjects",
  "pages.system.auth.form.visible.required":
    "Please select applicable subjects",
  "pages.system.auth.form.sort": "Sort",
  "pages.system.auth.form.sort.required": "Please enter sort",
  "pages.system.auth.form.sort.error.max": "Sort cannot exceed 1000",
  "pages.system.auth.edit.title": "Edit Menu",
  "pages.system.auth.add.title": "Add Menu",
  "pages.system.auth.message.updateSuccess": "Updated successfully",
  "pages.system.auth.message.addSuccess": "Added successfully",
  "pages.system.auth.message.error": "Operation failed",

  // Admin Management
  "pages.system.manager.title": "Admin Management",
  "pages.system.manager.list.title": "Admin List",
  "pages.system.manager.action.add": "Add Admin",
  "pages.system.manager.action.edit": "Edit",
  "pages.system.manager.action.delete": "Delete",
  "pages.system.manager.action.password": "Change Password",
  "pages.system.manager.column.id": "ID",
  "pages.system.manager.column.username": "Account",
  "pages.system.manager.column.nickname": "Name",
  "pages.system.manager.column.contact": "Contact",
  "pages.system.manager.column.role": "Role",
  "pages.system.manager.column.createdAt": "Created At",
  "pages.system.manager.column.loginTime": "Last Login Time",
  "pages.system.manager.column.loginIp": "Last Login IP",
  "pages.system.manager.column.status": "Enable/Disable",
  "pages.system.manager.column.action": "Action",
  "pages.system.manager.search.placeholder": "Please enter nickname or ID",
  "pages.system.manager.search.title": "Search Admin",
  "pages.system.manager.role.unknown": "Unknown Role({id})",
  "pages.system.manager.status.enable": "Enable",
  "pages.system.manager.status.disable": "Disable",

  // Components
  "component.google.title": "Security Verification",
  "component.google.prompt":
    "Please enter your Google verification code to perform the follow-up operation",
  "component.google.placeholder": "Please enter verification code",
  "component.google.required": "Please enter Google verification code",
  "component.google.formatError": "Please enter 6-digit verification code",
  "component.google.verifyFailed": "Verification failed",
  "component.google.noTicket": "Verification failed, ticket not obtained",
  "component.google.tip":
    "For your account security, please perform Google two-step verification",
  "component.google.cancel": "Cancel",
  "component.google.ok": "OK",
  "component.google.error": "Verification failed",

  "pages.system.manager.delete.confirm.title": "Confirm Delete Admin",
  "pages.system.manager.delete.confirm.content":
    "After deletion, the admin will not be able to log in to this account, and it cannot be recovered. Please operate with caution!",
  "pages.system.manager.status.confirm.title": "Disable Admin",
  "pages.system.manager.status.confirm.content":
    "The admin will not be able to log in during the disable period, and can log in again after enabling!",
  "pages.system.manager.message.fetchRolesFailed": "Failed to fetch role list",
  "pages.system.manager.message.updateStatusSuccess":
    "Status updated successfully",
  "pages.system.manager.message.updateStatusFailed": "Status update failed",
  "pages.system.manager.message.deleteSuccess": "Deleted successfully",
  "pages.system.manager.message.deleteFailed": "Deletion failed",
  "pages.system.manager.form.username": "Login Account",
  "pages.system.manager.form.username.required": "Please enter login account",
  "pages.system.manager.form.password": "Login Password",
  "pages.system.manager.form.password.required": "Please enter login password",
  "pages.system.manager.form.password.min":
    "Password length cannot be less than 6 characters",
  "pages.system.manager.form.nickname": "Admin Name",
  "pages.system.manager.form.nickname.required": "Please enter admin name",
  "pages.system.manager.form.contact": "Contact",
  "pages.system.manager.form.contact.required": "Please enter contact info",
  "pages.system.manager.form.role": "Role",
  "pages.system.manager.form.role.required": "Please select role",
  "pages.system.manager.form.remark": "Remark",
  "pages.system.manager.form.remark.placeholder": "Please enter remark",
  "pages.system.manager.form.oldPassword": "Old Password",
  "pages.system.manager.form.oldPassword.required": "Please enter old password",
  "pages.system.manager.form.newPassword": "New Password",
  "pages.system.manager.form.newPassword.required": "Please enter new password",
  "pages.system.manager.form.newPassword.min":
    "Password must be at least 6 characters",
  "pages.system.manager.form.newPassword.noSpace":
    "Password cannot contain spaces",
  "pages.system.manager.form.confirmPassword": "Confirm Password",
  "pages.system.manager.form.confirmPassword.required":
    "Please enter password again",
  "pages.system.manager.form.confirmPassword.mismatch":
    "The two passwords entered are inconsistent",
  "pages.system.manager.message.createSuccess": "Created successfully",
  "pages.system.manager.message.updateSuccess": "Updated successfully",
  "pages.system.manager.message.passwordSuccess":
    "Password changed successfully",
  "pages.system.manager.edit.title": "Edit Admin",
  "pages.system.manager.add.title": "Add Admin",
  "pages.system.manager.password.title": "Change Password",

  // System - Notice Management
  "pages.system.notice.list.title": "Notice Management",
  "pages.system.notice.column.id": "ID",
  "pages.system.notice.column.type": "Type",
  "pages.system.notice.column.title": "Title",
  "pages.system.notice.column.titleEn": "English Title",
  "pages.system.notice.column.content": "Content",
  "pages.system.notice.column.contentEn": "English Content",
  "pages.system.notice.column.createdAt": "Publish Time",
  "pages.system.notice.column.action": "Action",
  "pages.system.notice.action.add": "Add Notice",
  "pages.system.notice.action.detail": "Detail",
  "pages.system.notice.action.edit": "Edit",
  "pages.system.notice.action.delete": "Delete",
  "pages.system.notice.type.versionUpdate": "Version Update",
  "pages.system.notice.type.systemNotice": "System Notice",
  "pages.system.notice.drawer.add.title": "Add Notice",
  "pages.system.notice.drawer.edit.title": "Edit Notice",
  "pages.system.notice.drawer.detail.title": "Notice Detail",
  "pages.system.notice.form.type.required": "Please select notice type",
  "pages.system.notice.form.title.placeholder": "Please enter notice title",
  "pages.system.notice.form.title.required": "Please enter notice title",
  "pages.system.notice.form.titleEn.placeholder":
    "Please enter English notice title",
  "pages.system.notice.form.content.placeholder": "Please enter notice content",
  "pages.system.notice.form.content.required": "Please enter notice content",
  "pages.system.notice.form.contentEn.placeholder":
    "Please enter English notice content",
  "pages.system.notice.message.createSuccess": "Created successfully",
  "pages.system.notice.message.updateSuccess": "Updated successfully",
  "pages.system.notice.message.deleteSuccess": "Deleted successfully",
  "pages.system.notice.message.deleteFailed": "Deletion failed",
  "pages.system.notice.message.operationFailed": "Operation failed",
  "pages.system.notice.delete.confirm.title": "Confirm Delete",
  "pages.system.notice.delete.confirm.content":
    "Are you sure you want to delete this notice? Data cannot be recovered after deletion. Please proceed with caution!",
  "pages.system.notice.column.visibleLevels": "Visible Levels",
  "pages.system.notice.visibleLevels.platform": "Platform",
  "pages.system.notice.visibleLevels.agent1": "Level 1 Agent",
  "pages.system.notice.visibleLevels.agent2": "Level 2 Agent",
  "pages.system.notice.visibleLevels.merchant": "Merchant",
  "pages.system.notice.form.visibleLevels.required":
    "Please select visible levels",

  // Retention Analysis
  "pages.user_analysis.retention.tab.game": "By Game",
  "pages.user_analysis.retention.tab.merchant": "By Merchant",
  "pages.user_analysis.retention.filter.merchant": "Merchant",
  "pages.user_analysis.retention.filter.game": "Game",
  "pages.user_analysis.retention.stat.title": "Data Overview",
  "pages.user_analysis.retention.stat.totalUsers": "Total Users",
  "pages.user_analysis.retention.stat.newUsers": "New Users",
  "pages.user_analysis.retention.stat.d1Retention": "D1 Ret. Rate",
  "pages.user_analysis.retention.stat.d7Retention": "D7 Ret. Rate",
  "pages.user_analysis.retention.stat.churnRate": "Churn Rate",
  "pages.user_analysis.retention.stat.dau": "DAU",
  "pages.user_analysis.retention.stat.wau": "WAU",
  "pages.user_analysis.retention.stat.mau": "MAU",
  "pages.user_analysis.retention.stat.avgOnlineTime": "Avg Online Time",
  "pages.user_analysis.retention.stat.avgBetCount": "Avg Game Plays",
  "pages.user_analysis.retention.stat.today": "Today",
  "pages.user_analysis.country_area.stat.title": "Data Overview",
  "pages.user_analysis.country_area.stat.totalCountry": "Total Countries",
  "pages.user_analysis.country_area.stat.totalLogin": "Total Users",
  "pages.user_analysis.country_area.stat.totalBet": "Total Bet Amount",
  "pages.user_analysis.country_area.stat.totalScore": "Total Return Amount",
  "pages.user_analysis.country_area.stat.totalGgr": "GGR",
  "pages.user_analysis.country_area.stat.tooltip.totalCountry":
    "Total Countries: Number of countries with data under current filters",
  "pages.user_analysis.country_area.stat.tooltip.totalLogin":
    "Total Users: Cumulative number of users under current filters",
  "pages.user_analysis.country_area.stat.tooltip.totalBet":
    "Total Bet Amount: Cumulative bet amount, unit USD",
  "pages.user_analysis.country_area.stat.tooltip.totalScore":
    "Total Return Amount: Cumulative return amount, unit USD",
  "pages.user_analysis.country_area.stat.tooltip.totalGgr":
    "GGR: Total Bet - Total Return, unit USD",
  "pages.user_analysis.country_area.distribution.topCountry": "TOP Country",
  "pages.user_analysis.country_area.distribution.country": "Country",
  "pages.user_analysis.retention.stat.tooltip.totalUsers":
    "Total Users: Cumulative logged-in users under current filter (deduplicated)",
  "pages.user_analysis.retention.stat.tooltip.newUsers":
    "New Users: Newly registered users under current filter (deduplicated)",
  "pages.user_analysis.retention.stat.tooltip.d1Retention":
    "D1 Retention Rate: Users who bet on D0 (T0) and bet again on D1 (T+1)",
  "pages.user_analysis.retention.stat.tooltip.d7Retention":
    "D7 Retention Rate: Users who bet on D0 (T0) and bet again on D7 (T+7)",
  "pages.user_analysis.retention.stat.tooltip.churnRate":
    "Churn Rate: Users active on D0 (T0) who are no longer active on D1 (T+1)",
  "pages.user_analysis.retention.stat.tooltip.dau":
    "DAU: Deduplicated users active at least once in a day",
  "pages.user_analysis.retention.stat.tooltip.wau":
    "WAU: Deduplicated users active at least once in a week",
  "pages.user_analysis.retention.stat.tooltip.mau":
    "MAU: Deduplicated users active at least once in a month",
  "pages.user_analysis.retention.stat.tooltip.avgOnlineTime":
    "Avg Online Duration: Average online time of cumulative users",
  "pages.user_analysis.retention.stat.tooltip.avgBetCount":
    "Avg Game Plays: Average game plays per cumulative user (1 Spin = 1 play)",
  "pages.user_analysis.retention.online.title": "Online Behavior Analysis",
  "pages.user_analysis.retention.online.yAxis": "Avg Online Duration (min)",
  "pages.user_analysis.retention.online.tooltip": "Avg Online Duration",
  "pages.user_analysis.retention.country.title": "Country Login Rate TOP10",
  "pages.user_analysis.retention.country.yAxis": "Logged-in Players",
  "pages.user_analysis.retention.trend.title": "Active Trend Analysis",
  "pages.user_analysis.retention.trend.yAxis.avgBet": "Avg Game Plays (Times)",
  "pages.user_analysis.retention.trend.yAxis.onlineTime":
    "Avg Online Duration (min)",
  "pages.user_analysis.retention.loss.title": "Churn Rate Analysis",
  "pages.user_analysis.retention.loss.yAxis": "Churn Rate (%)",
  "pages.user_analysis.retention.loss.top10.title": "High Churn {type} TOP10",
  "pages.user_analysis.retention.loss.tab.game": "Game",
  "pages.user_analysis.retention.loss.tab.merchant": "Merchant",
  "pages.user_analysis.retention.loss.tab.country": "Country",
  "pages.user_analysis.retention.table.overview.title": "Retention Overview",
  "pages.user_analysis.retention.table.activeLoss.title":
    "Active/Churn Details",
  "pages.user_analysis.retention.table.column.name": "Name",
  "pages.user_analysis.retention.table.column.id": "ID",
  "pages.user_analysis.retention.table.column.totalActive":
    "Total Active Users",
  "pages.user_analysis.retention.table.column.firstLogin":
    "New Registered Users",
  "pages.user_analysis.retention.table.column.firstActive": "New Active Users",
  "pages.user_analysis.retention.table.column.totalBetNum": "Total Bet Count",
  "pages.user_analysis.retention.table.column.retention": "D{day} Retention",
  "pages.user_analysis.retention.table.column.date": "Date",
  "pages.user_analysis.retention.table.column.regActiveFirstLoginRate":
    "New Conv. Rate",
  "pages.user_analysis.retention.table.column.regActiveFirstLoginRate.tooltip":
    "Users who registered today and bet within 15 days / Users registered today",
  "pages.user_analysis.retention.table.column.dau": "DAU",
  "pages.user_analysis.retention.table.column.wau": "WAU",
  "pages.user_analysis.retention.table.column.mau": "MAU",
  "pages.user_analysis.retention.table.column.loginD1": "D1 Visit Ret.",
  "pages.user_analysis.retention.table.column.activeD": "D{day} Bet Ret.",
  "pages.user_analysis.retention.chart.noData": "No Data",
  "pages.user_analysis.retention.chart.tooltip.all":
    "All: Displaying last 30 days data by default",
  "pages.user_analysis.retention.chart.tooltip.today":
    "Today: Displaying today's data",
  "pages.user_analysis.retention.chart.tooltip.yesterday":
    "Yesterday: Displaying yesterday's data",
  "pages.user_analysis.retention.chart.tooltip.last7":
    "Last 7 Days: Displaying last 7 days data",
  "pages.user_analysis.retention.chart.tooltip.last15":
    "Last 15 Days: Displaying last 15 days data",
  "pages.user_analysis.retention.chart.tooltip.last30":
    "Last 30 Days: Displaying last 30 days data",

  // Action Analysis
  "pages.user_analysis.action.filter.merchant": "Merchant",
  "pages.user_analysis.action.filter.game": "Game",
  "pages.user_analysis.action.overview.title": "Data Overview",
  "pages.user_analysis.action.overview.step2Rate": "First Frame Success Rate",
  "pages.user_analysis.action.overview.step4Rate": "Operable Success Rate",
  "pages.user_analysis.action.overview.step5Rate": "First Conversion Rate",
  "pages.user_analysis.action.overview.step6Rate": "Top 3 Conversion Rate",
  "pages.user_analysis.action.overview.step7Rate": "Top 10 Conversion Rate",
  "pages.user_analysis.action.funnel.title": "Core Funnel",
  "pages.user_analysis.action.funnel.dataLegend":
    "Data meaning: CurrentValue/InitialValue%|CurrentValue/PreviousValue|CurrentValue",
  "pages.user_analysis.action.funnel.topGames.title": "Game TOP5",
  "pages.user_analysis.action.funnel.stage.enterGame": "Enter Game",
  "pages.user_analysis.action.funnel.stage.enterRoom": "Enter Room",
  "pages.user_analysis.action.funnel.stage.startBet": "Start Bet",
  "pages.user_analysis.action.funnel.stage.validBet": "Valid Bet",
  "pages.user_analysis.action.funnel.stage.paySuccess": "Pay Success",
  "pages.user_analysis.action.funnel.stage.step1": "Entered Users",
  "pages.user_analysis.action.funnel.stage.step2": "First Load",
  "pages.user_analysis.action.funnel.stage.step3": "First Frame",
  "pages.user_analysis.action.funnel.stage.step4": "Operable",
  "pages.user_analysis.action.funnel.stage.step41": "Game Introduction",
  "pages.user_analysis.action.funnel.stage.step42": "View Rules",
  "pages.user_analysis.action.funnel.stage.step5": "First Conversion",
  "pages.user_analysis.action.funnel.stage.step6": "3 Conversions",
  "pages.user_analysis.action.funnel.stage.step7": "10 Conversions",
  "pages.user_analysis.action.funnel.stage.step8": "First Feature",
  "pages.user_analysis.action.funnel.stage.step1.tooltip":
    'Click "Start Game" on the merchant side (get game URL)',
  "pages.user_analysis.action.funnel.stage.step2.tooltip":
    "The first progress bar finishes loading",
  "pages.user_analysis.action.funnel.stage.step3.tooltip":
    "Start button appears",
  "pages.user_analysis.action.funnel.stage.step4.tooltip": "Click start button",
  "pages.user_analysis.action.funnel.stage.step41.tooltip":
    "User clicks Click to continue",
  "pages.user_analysis.action.funnel.stage.step42.tooltip":
    "User views Paytable rules",
  "pages.user_analysis.action.funnel.stage.step5.tooltip": "Click spin button",
  "pages.user_analysis.action.funnel.stage.step6.tooltip": "3 successful spins",
  "pages.user_analysis.action.funnel.stage.step7.tooltip":
    "10 successful spins",
  "pages.user_analysis.action.funnel.stage.step8.tooltip":
    "Trigger other gameplay",
  "pages.user_analysis.action.funnel.metric.enterCount": "Entered Users",
  "pages.user_analysis.action.funnel.metric.successCount": "Success Users",
  "pages.user_analysis.action.funnel.metric.successRate": "Success Rate",
  "pages.user_analysis.action.funnel.metric.lossCount": "Lost Users",
  "pages.user_analysis.action.funnel.metric.lossRate": "Loss Rate",
  "pages.user_analysis.action.detail.label.enter": "Enter",
  "pages.user_analysis.action.detail.label.success": "Success",
  "pages.user_analysis.action.detail.label.loss": "Loss",
  "pages.user_analysis.action.funnel.metric.wow": "Today / WoW",
  "pages.user_analysis.action.mainTable.loadFailed":
    "Failed to load game main list",
  "pages.user_analysis.action.funnel.chart.labelText":
    "{stepName}: {value}({rate}|{preRate})",
  "pages.user_analysis.action.table.tooltip.attributionByEntryDate":
    "Attributed by entry date: the date shown in the list is the date when the player first entered the game. All later actions by that player, such as first conversion or triggering Feature, are attributed to this date.\nLimited by the selected date range: data is counted only up to your selected end date. For example, if you select the 13th-15th, actions performed on the 16th by players who entered on the 13th are not included.",
  "pages.user_analysis.action.table.title": "Main List",
  "pages.user_analysis.action.table.column.gameName": "Game Name",
  "pages.user_analysis.action.table.column.launchTime": "Launch Time",
  "pages.user_analysis.action.table.column.totalUserCount":
    "New Registered Users",
  "pages.user_analysis.action.table.column.totalUserCount.tooltip":
    "New registered users for a specific game on a specific date",
  "pages.user_analysis.action.table.column.activeUserCount":
    "Cumulative Bet Users",
  "pages.user_analysis.action.table.column.activeUserCount.tooltip":
    "Betting users for a specific game on a specific date. If the same player bets multiple times on the same day, it is deduplicated and counted as 1 betting user. No deduplication is needed across different days.",
  "pages.user_analysis.action.table.column.enterCount": "Entered Users",
  "pages.user_analysis.action.table.column.successRate": "Success Rate",
  "pages.user_analysis.action.table.column.step1.tooltip":
    "Click Start Game on the merchant side (get game URL)",
  "pages.user_analysis.action.table.column.step2.tooltip":
    "The first progress bar finishes loading. Left side shows conversion rate, right side shows actual count. Except for 157, 158, 160, and 668, data for other games are backfilled.",
  "pages.user_analysis.action.table.column.step3.tooltip":
    "Both progress bars finish loading, entering start. Left side shows conversion rate, right side shows actual count. Except for 157, 158, 160, and 668, data for other games are backfilled.",
  "pages.user_analysis.action.table.column.step4.tooltip":
    "User can perform any interactive operations. Left side shows conversion rate, right side shows actual count. Except for 157, 158, 160, and 668, data for other games are backfilled.",
  "pages.user_analysis.action.table.column.step41.tooltip":
    "User clicks Click to continue",
  "pages.user_analysis.action.table.column.step42.tooltip": "User views rules",
  "pages.user_analysis.action.table.column.step5.tooltip":
    "1 successful spin. Left side shows conversion rate, right side shows actual count.",
  "pages.user_analysis.action.table.column.step6.tooltip":
    "3 successful spins. Left side shows conversion rate, right side shows actual count.",
  "pages.user_analysis.action.table.column.step7.tooltip":
    "10 successful spins. Left side shows conversion rate, right side shows actual count.",
  "pages.user_analysis.action.table.column.step8.tooltip":
    "Trigger other gameplay. Left side shows conversion rate, right side shows actual count.",
  "pages.user_analysis.action.section.pending":
    "Page skeleton only. {count} filter params are ready for API integration.",
  "pages.user_analysis.action.section.staticApi":
    "Data source /api/v1/sys/getUserTrackStatic",
  "pages.user_analysis.action.section.listApi":
    "Data source /api/v1/sys/getUserTrackStaticList",
  "pages.user_analysis.action.section.scope":
    "This stage keeps the filter, overview, funnel, and main list only. Removed side modules and the single-session list are excluded.",

  // Country Area Analysis
  "pages.user_analysis.country_area.top10.title": "Country Top 10 Distribution",
  "pages.user_analysis.country_area.metric.login": "Login Count",
  "pages.user_analysis.country_area.metric.active": "Active Count",
  "pages.user_analysis.country_area.metric.bet": "Bet Amount",
  "pages.user_analysis.country_area.metric.ggr": "GGR",
  "pages.user_analysis.country_area.table.column.country": "Country",
  "pages.user_analysis.country_area.table.column.gameCount": "Game Count",
  "pages.user_analysis.country_area.table.column.merchantCount":
    "Merchant Count",
  "pages.user_analysis.country_area.table.column.userCount":
    "New Registered Users",
  "pages.user_analysis.country_area.table.column.betCount":
    "Cumulative Bet Count",
  "pages.user_analysis.country_area.table.column.betUserCount":
    "Cumulative Bet Users",
  "pages.user_analysis.country_area.table.column.betAmount": "Bet Amount",
  "pages.user_analysis.country_area.table.column.winAmount": "Win Amount",
  "pages.user_analysis.country_area.table.column.merchantFs":
    "Merchant Freespin",
  "pages.user_analysis.country_area.table.column.platFs": "Platform Freespin",
  "pages.user_analysis.country_area.table.column.ggr": "GGR",
  "pages.user_analysis.country_area.table.column.rtp": "RTP",
  "pages.user_analysis.country_area.table.column.avgBetCount": "Avg Bet Count",
  "pages.user_analysis.country_area.table.column.avgBetAmount":
    "Avg Bet Amount",
  "pages.user_analysis.country_area.table.column.avgBetPerBet":
    "Avg Bet Per Bet",
  "pages.user_analysis.country_area.table.tooltip.avgBetCount":
    "Avg Bet Count: Bet Count / User Count",
  "pages.user_analysis.country_area.table.tooltip.avgBetAmount":
    "Avg Bet Amount: Bet Amount / User Count",
  "pages.user_analysis.country_area.table.tooltip.avgBetPerBet":
    "Avg Bet Per Bet: Bet Amount / Bet Count",

  // Buy Bonus Statics
  "pages.statics.buybonus.stat.title": "Data Overview",
  "pages.statics.buybonus.stat.description": "Data refreshes every 15 minutes",
  "pages.statics.buybonus.stat.tooltip.totalBetUserCount":
    "Total Bet Users: Deduplicated number of users who bet under current filters",
  "pages.statics.buybonus.stat.tooltip.totalBuyUserCount":
    "Total Buy Users: Deduplicated number of users who purchased Buybonus under current filters",
  "pages.statics.buybonus.stat.tooltip.totalBuyBetCount":
    "Total Buy Count: Total number of Buybonus purchases under current filters (no deduplication)",
  "pages.statics.buybonus.stat.tooltip.totalBuyBetAmount":
    "Total Buy Amount: Cumulative amount of Buybonus purchases under current filters",
  "pages.statics.buybonus.stat.tooltip.totalBuyScoreAmount":
    "Total Return Amount: Cumulative return amount after purchasing Buybonus under current filters",
  "pages.statics.buybonus.stat.tooltip.totalProfitAmount":
    "Total Profit Amount: Profit obtained by the platform after purchasing Buybonus under current filters (Total Buy Amount - Total Return Amount)",
  "pages.statics.buybonus.stat.tooltip.rtp":
    "RTP: User return rate for Buybonus purchases under current filters\n(Total Return Amount / Total Buy Amount)",
  "pages.statics.buybonus.stat.tooltip.penetration":
    "Penetration = (Buy Value / Total Value) * 100%",

  "pages.statics.buybonus.column.game": "Game",
  "pages.statics.buybonus.column.userCount": "Buy Users",
  "pages.statics.buybonus.column.betCount": "Buy Count",
  "pages.statics.buybonus.column.betAmount": "Buy Amount",
  "pages.statics.buybonus.column.scoreAmount": "Return Amount",
  "pages.statics.buybonus.column.scoreAmount.tooltip":
    "Does not include bonuses",
  "pages.statics.buybonus.column.profitAmount": "Profit Amount",
  "pages.statics.buybonus.column.rtp": "RTP",
  "pages.statics.buybonus.column.buyBonusCount": "Levels",
  "pages.statics.buybonus.column.buyBonusCount.tooltip":
    "Number of buy bonus levels available for the current game",
  "pages.statics.buybonus.column.coreBuyBonusType": "Core Level",
  "pages.statics.buybonus.column.coreBuyBonusType.tooltip":
    "The most purchased level under the current filters",
  "pages.statics.buybonus.table.title": "Buy Bonus Statics",

  "pages.statics.buybonus.detail.column.date": "Date",
  "pages.statics.buybonus.detail.column.type": "Level",
  "pages.statics.buybonus.detail.typeValue": "Level {type}",
  "pages.statics.buybonus.detail.tab.daily": "By Date",
  "pages.statics.buybonus.detail.tab.type": "By Level",
  "pages.statics.buybonus.detail.slot.line1":
    "Users:{userCount} Count:{betCount}",
  "pages.statics.buybonus.detail.slot.s0": "S0 (Base Game)",
  "pages.statics.buybonus.detail.slot.line2":
    "Buy Amount:{betAmount} Return Amount:{scoreAmount} RTP:{rtp}",
  "pages.statics.buybonus.stat.penetration": "Penetration",

  // Game Hall Statistics
  "pages.statics.hall.filter.game": "Game",
  "pages.statics.hall.summary.hallExposure": "Hall Entry Impressions",
  "pages.statics.hall.summary.hallExposure.tooltip":
    "The number of times the Hall entry button is exposed on the main game screen when players enter a game. Counted once each time a player enters a new game.",
  "pages.statics.hall.summary.hallWakeup": "Hall Wakeups",
  "pages.statics.hall.summary.hallWakeup.tooltip":
    "The number of times players click the Hall button to open the Hall dialog.",
  "pages.statics.hall.summary.activityClick": "Activity Clicks",
  "pages.statics.hall.summary.activityClick.tooltip":
    "The number of times players click an activity module. Each click counts once.",
  "pages.statics.hall.summary.gameClick": "Game Clicks",
  "pages.statics.hall.summary.gameClick.tooltip":
    "The number of times players click a game module. Each click counts once.",
  "pages.statics.hall.trend.title": "Hall Activity Trend",
  "pages.statics.hall.trend.hallExposure": "Hall Impressions",
  "pages.statics.hall.trend.hallWakeup": "Hall Wakeups",
  "pages.statics.hall.trend.activityExposure": "Activity Impressions (PV)",
  "pages.statics.hall.trend.gameExposure": "Game Impressions (PV)",
  "pages.statics.hall.distribution.title": "Activity Traffic Distribution",
  "pages.statics.hall.distribution.total": "Accumulated Freespin",
  "pages.statics.hall.distribution.merchant": "Merchant Freespin",
  "pages.statics.hall.distribution.sevenDay": "7-Day Freespin",
  "pages.statics.hall.distribution.surprise": "Surprise Activity",
  "pages.statics.hall.tab.activity": "By Activity",
  "pages.statics.hall.tab.game": "By Game",
  "pages.statics.hall.tab.merchant": "By Merchant",
  "pages.statics.hall.column.activity": "Activity Name",
  "pages.statics.hall.column.game": "Game Name",
  "pages.statics.hall.column.merchant": "Merchant",
  "pages.statics.hall.column.activityType": "Activity Type",
  "pages.statics.hall.column.exposurePv": "Impressions (PV)",
  "pages.statics.hall.column.exposureUv": "Impressions (UV)",
  "pages.statics.hall.column.click": "Clicks",
  "pages.statics.hall.column.jump": "Redirects",
  "pages.statics.hall.column.clickRate": "Click Rate",
  "pages.statics.hall.column.clickRate.tooltip": "Clicks / Impressions (PV).",
  "pages.statics.hall.column.activityExposurePv.tooltip":
    "The total number of times the activity card was successfully rendered and shown to players in the Hall panel.",
  "pages.statics.hall.column.activityExposureUv.tooltip":
    "The total number of unique players to whom the activity card was successfully rendered and shown in the Hall panel.",
  "pages.statics.hall.column.activityClick.tooltip":
    "The total number of times players click activities in the Hall.",
  "pages.statics.hall.column.activityJump.tooltip":
    "The total number of times players click a game in the Hall and successfully navigate to it.",
  "pages.statics.hall.column.gameExposurePv.tooltip":
    "The total number of times the game card was successfully rendered and shown to players in the Hall panel.",
  "pages.statics.hall.column.gameExposureUv.tooltip":
    "The total number of unique players to whom the game card was successfully rendered and shown in the Hall panel.",
  "pages.statics.hall.column.gameClick.tooltip":
    "The total number of times players click games in the Hall.",
  "pages.statics.hall.column.gameJump.tooltip":
    "The total number of times players click a game in the Hall and successfully navigate to it.",
  "pages.statics.hall.column.merchantExposurePv.tooltip":
    "The total number of times the Hall floating button was successfully rendered and shown to players in games.",
  "pages.statics.hall.column.merchantHallWakeup.tooltip":
    "The number of times players click the Hall button to open the Hall dialog.",
  "pages.statics.hall.column.merchantHallWakeupRate.tooltip":
    "The proportion of players under the merchant who actively click the floating button to open the Hall panel. (Hall open clicks / Hall floating button impressions (PV)) * 100%.",
  "pages.statics.hall.column.merchantActivityClick.tooltip":
    "The total number of times players click activities in the Hall.",
  "pages.statics.hall.column.merchantActivityJump.tooltip":
    "The total number of times players click activities in the Hall and successfully navigate to them.",
  "pages.statics.hall.column.merchantGameClick.tooltip":
    "The total number of times players click games in the Hall.",
  "pages.statics.hall.column.merchantGameJump.tooltip":
    "The total number of times players click a game in the Hall and successfully launch and load the target game.",
  "pages.statics.hall.column.walletType": "Wallet Type",
  "pages.statics.hall.column.hallSwitch": "Hall Switch",
  "pages.statics.hall.column.hallWakeup": "Hall Wakeups",
  "pages.statics.hall.column.hallWakeupRate": "Hall Wakeup Rate",
  "pages.statics.hall.column.activityClick": "Activity Clicks",
  "pages.statics.hall.column.activityJump": "Activity Redirects",
  "pages.statics.hall.column.gameClick": "Game Clicks",
  "pages.statics.hall.column.gameJump": "Game Redirects",
  "pages.statics.hall.activity.total": "Accumulated Freespin",
  "pages.statics.hall.activity.sevenDay": "7-Day Freespin",
  "pages.statics.hall.activity.surprise": "Surprise Activity",
  "pages.statics.hall.enabled": "Enabled",
  "pages.statics.hall.disabled": "Disabled",
  "pages.statics.hall.message.fetchFailed": "Failed to load hall statistics",

  "pages.welcome.link": "Welcome",
  "pages.welcome.alertMessage":
    "Faster and stronger heavy-duty components have been released.",
  "pages.404.subTitle": "Sorry, the page you visited does not exist.",
  "pages.404.buttonText": "Back Home",
  "pages.admin.subPage.title": "This page can only be viewed by Admin",
  "pages.admin.subPage.alertMessage":
    "Umi ui is now released, welcome to use npm run ui to start the experience.",
  "pages.searchTable.createForm.newRule": "New Rule",
  "pages.searchTable.updateForm.ruleConfig": "Rule configuration",
  "pages.searchTable.updateForm.basicConfig": "Basic Information",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Rule Name",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Please enter the rule name!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Rule Description",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Please enter at least five characters",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Please enter a rule description of at least five characters!",
  "pages.searchTable.updateForm.ruleProps.title": "Configure Properties",
  "pages.searchTable.updateForm.object": "Monitoring Object",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Rule Template",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Rule Type",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Set Scheduling Period",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "Starting Time",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Please choose a start time!",
  "pages.searchTable.titleDesc": "Description",
  "pages.searchTable.ruleName": "Rule name is required",
  "pages.searchTable.titleCallNo": "Number of Service Calls",
  "pages.searchTable.titleStatus": "Status",
  "pages.searchTable.nameStatus.default": "default",
  "pages.searchTable.nameStatus.running": "running",
  "pages.searchTable.nameStatus.online": "online",
  "pages.searchTable.nameStatus.abnormal": "abnormal",
  "pages.searchTable.titleUpdatedAt": "Last Scheduled at",
  "pages.searchTable.exception": "Please enter the reason for the exception!",
  "pages.searchTable.titleOption": "Option",
  "pages.searchTable.config": "Configuration",
  "pages.searchTable.subscribeAlert": "Subscribe to alerts",
  "pages.searchTable.title": "Enquiry Form",
  "pages.searchTable.new": "New",
  "pages.searchTable.chosen": "chosen",
  "pages.searchTable.item": "item",
  "pages.searchTable.totalServiceCalls": "Total Number of Service Calls",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "batch deletion",
  "pages.searchTable.batchApproval": "batch approval",

  // System Management - Role Management
  "pages.system.role.list.title": "Role Management",
  "pages.system.role.action.add": "Add Role",
  "pages.system.role.action.edit": "Edit",
  "pages.system.role.action.delete": "Delete",
  "pages.system.role.modal.title.add": "Add Role",
  "pages.system.role.modal.title.edit": "Edit Role",
  "pages.system.role.form.name": "Role Name",
  "pages.system.role.form.name.required": "Please enter role name",
  "pages.system.role.form.status": "Status",
  "pages.system.role.form.status.open": "Open",
  "pages.system.role.form.status.close": "Disabled",
  "pages.system.role.form.menu": "Menu Permissions",
  "pages.system.role.column.name": "Name",
  "pages.system.role.column.searchName": "Search Role",
  "pages.system.role.column.searchPlaceholder": "Name/ID",
  "pages.system.role.column.updatedAt": "Updated Time",
  "pages.system.role.column.status": "Enable/Disable",
  "pages.system.role.message.fetchMenuFailed":
    "Failed to fetch permission menu",
  "pages.system.role.message.deleteConfirm.title": "Confirm Delete Role",
  "pages.system.role.message.deleteConfirm.content":
    "Data cannot be recovered after deletion. For administrator accounts already configured with this role, the corresponding role functions will be invisible. Please operate carefully!",
  "pages.system.role.message.deleteSuccess": "Deleted successfully",
  "pages.system.role.message.deleteFailed": "Failed to delete",
  "pages.system.role.message.statusUpdateSuccess":
    "Status updated successfully",
  "pages.system.role.message.statusUpdateFailed": "Failed to update status",
  "pages.system.role.message.stopConfirm.title": "Confirm Disable Role",
  "pages.system.role.message.stopConfirm.content":
    "After disabling, for administrator accounts already configured with this role, the corresponding role functions will be invisible. Please operate carefully!",
  "pages.system.role.message.addSuccess": "Added successfully",
  "pages.system.role.message.updateSuccess": "Updated successfully",
  "pages.system.role.message.operationFailed": "Operation failed",
  "pages.system.role.tree.unnamed": "Unnamed",

  // Merchant Management - User Management
  "pages.merchant.users.list.title": "User Management",
  "pages.merchant.users.column.registerTime": "Register Time",
  "pages.merchant.users.column.selectMerchant": "Select Merchant",
  "pages.merchant.users.column.currency": "Currency",
  "pages.merchant.users.placeholder.currency": "Please select currency",
  "pages.merchant.users.column.roleId": "User ID",
  "pages.merchant.users.column.agent": "Agent",
  "pages.merchant.users.tag.whiteUser": "Whitelist User",
  "pages.merchant.users.placeholder.roleId": "Please enter ID",
  "pages.merchant.users.column.ip": "IP",
  "pages.merchant.users.placeholder.ip": "Please enter IP",
  "pages.merchant.users.column.betCount": "Bet Count",
  "pages.merchant.users.column.betAmount": "Total Bet Amount",
  "pages.merchant.users.column.freespinAmount": "Freespin Amount",
  "pages.merchant.users.column.balance": "Balance",
  "pages.merchant.users.column.profit": "Profit/Loss (Platform)",
  "pages.merchant.users.column.scoreAmount": "Return Amount",
  "pages.merchant.users.column.registerIp": "Register IP",
  "pages.merchant.users.column.lastLoginTime": "Last Login Time",
  "pages.merchant.users.action.loginLogs": "Login Logs",
  "pages.merchant.users.action.loginLogsDetail": "Login Logs Detail",
  "pages.merchant.users.column.loginTime": "Login Time",

  // Merchant Management - Bill Management
  "pages.merchant.bill.title": "Bill Management",
  "pages.merchant.bill.summary.title": "Data Overview",
  "pages.merchant.bill.summary.totalBetAmount": "Total Bet Amount",
  "pages.merchant.bill.summary.totalScoreAmount": "Total Return Amount",
  "pages.merchant.bill.summary.totalGGR": "Total GGR",
  "pages.merchant.bill.summary.merchantIncome": "Merchant Net Income",
  "pages.merchant.bill.summary.rtp": "RTP",
  "pages.merchant.bill.summary.betCount": "Total Bet Count",
  "pages.merchant.bill.summary.averageBetAmount": "Avg Bet Amount",
  "pages.merchant.bill.column.agentLevel": "Agent Level Filter",
  "pages.merchant.bill.summary.tooltip":
    "Total Bet Amount: Cumulative bet amount of all users under the current filter conditions\n\nTotal Return Amount: Cumulative return amount of all users under the current filter conditions\n\nTotal GGR: Platform gross income under the current filter conditions.\n(Total Bet Amount - Total Return Amount)\n\nRTP: Accumulated player return rate under the current filter conditions.\nRTP = Total Return Amount / Total Bet Amount",
  "pages.merchant.bill.tab.daily": "Daily Bill",
  "pages.merchant.bill.tab.monthly": "Monthly Bill",
  "pages.merchant.bill.action.export": "Export Bill",
  "pages.merchant.bill.action.exportBill": "Export Bill",
  "pages.merchant.bill.export.filename": "BillReport_",
  "pages.merchant.bill.jackpot.title": "Jackpot Detail",
  "pages.merchant.bill.jackpot.close": "Got it",
  "pages.merchant.bill.column.platformIncome": "Platform Income",
  "pages.merchant.bill.column.platformIncome.tooltip":
    "Platform Income = (Bet Amount - Score Amount) * Fee Rate",
  "pages.merchant.bill.column.freespinAmount": "Jackpot",
  "pages.merchant.bill.column.freespinAmount.tooltip":
    "Jackpot = Platform Freespin + Accumulated Freespin",
  "pages.merchant.bill.column.dateRange": "Select Date",
  "pages.merchant.bill.column.currencyRatio": "Currency Ratio",

  "pages.common.totalRecords": "Total {total} records",
  "pages.common.empty": "No data",

  // Report Management - Flow Report
  "pages.report.flow.list.title": "Flow Records",
  "pages.report.flow.column.createdAt": "Creation Time",
  "pages.report.flow.preset.all": "All",
  "pages.report.flow.preset.today": "Today",
  "pages.report.flow.preset.last7Days": "Last 7 Days",
  "pages.report.flow.preset.last30Days": "Last 30 Days",
  "pages.report.flow.column.transferReference": "Flow ID",
  "pages.report.flow.placeholder.transferReference": "Please enter Flow ID",
  "pages.report.flow.column.type": "Change Type",
  "pages.report.flow.type.deposit": "Deposit",
  "pages.report.flow.type.withdraw": "Withdraw",
  "pages.report.flow.type.withdrawAll": "Withdraw All",
  "pages.report.flow.column.amount": "Amount",
  "pages.report.flow.column.balanceBefore": "Balance Before",
  "pages.report.flow.column.balanceAfter": "Balance After",
  "pages.report.flow.column.updatedAt": "Update Time",
  "pages.report.flow.message.exporting": "Exporting...",
  "pages.report.flow.export.filename": "Flow_Export_",
  "pages.report.flow.message.exportSuccess": "Export Successful",
  "pages.report.flow.message.exportFailed": "Export Failed",
  "pages.report.flow.summary.title": "Data Overview",
  "pages.report.flow.summary.tooltip.totalCount":
    "Total Flow Count: Under current filter conditions, the total number of all fund change records.",
  "pages.report.flow.summary.tooltip.incomeAmount":
    'Income Amount: The total amount of all "fund increase" records, such as "Deposit".',
  "pages.report.flow.summary.tooltip.outcomeAmount":
    'Outcome Amount: The total amount of all "fund decrease" records, such as "Withdraw" and "Withdraw All".',
  "pages.report.flow.summary.totalCount": "Total Flow Count",
  "pages.report.flow.summary.incomeAmount": "Income Amount",
  "pages.report.flow.summary.outcomeAmount": "Outcome Amount",
  "pages.report.flow.action.export": "Export",

  // Report Management - Bet Record
  "pages.report.betRecord.filter.title": "Filters",
  "pages.report.betRecord.filter.timeRange": "Time Range",
  "pages.report.betRecord.filter.betId": "Bet ID",
  "pages.report.betRecord.filter.userId": "User ID",
  "pages.report.betRecord.filter.ip": "IP",
  "pages.report.betRecord.filter.game": "Game",
  "pages.report.betRecord.filter.gameId": "Game ID",
  "pages.report.betRecord.filter.currency": "Currency",
  "pages.report.betRecord.filter.merchant": "Merchant",
  "pages.report.betRecord.filter.betAmountMin": "Min Bet Amount",
  "pages.report.betRecord.filter.betAmountMax": "Max Bet Amount",
  "pages.report.betRecord.filter.buybounsType": "Game Mode",
  "pages.report.betRecord.filter.freespinType": "FreeSpin Type",
  "pages.report.betRecord.filter.freespinType.merchant": "Accumulated",
  "pages.report.betRecord.filter.freespinType.platform": "Platform",
  "pages.report.betRecord.filter.freespinType.sevenDay": "7-Day FreeSpin",
  "pages.report.betRecord.overview.title": "Data Overview",
  "pages.report.betRecord.overview.description":
    "Real-time data, may differ from other report data.",
  "pages.report.betRecord.overview.totalBetAmount": "Total Bet Amount",
  "pages.report.betRecord.overview.totalScoreAmount": "Total Return Amount",
  "pages.report.betRecord.overview.totalScoreAmount.tooltip":
    "Does not include bonuses",
  "pages.report.betRecord.overview.totalWinAmount":
    "Total Profit/Loss (Platform)",
  "pages.report.betRecord.overview.platformFreespinAmount":
    "Platform Freespin Amount",
  "pages.report.betRecord.overview.merchantFreespinAmount":
    "Accumulated FreeSpin Amount",
  "pages.report.betRecord.overview.tooltip.totalBetAmount":
    "Total Bet Amount: Under current filter conditions, the cumulative bet amount of all users.",
  "pages.report.betRecord.overview.tooltip.totalScoreAmount":
    "Total Return Amount: Under current filter conditions, the cumulative return amount of all users. (Note: Total return amount does not include activity bonuses)",
  "pages.report.betRecord.overview.tooltip.totalWinAmount":
    "Total Profit/Loss (Platform): Under current filter conditions, the cumulative profit/loss amount on the platform side.",
  "pages.report.betRecord.overview.tooltip.totalWinAmountFormula":
    "Total Profit/Loss = Total Bet Amount - [Total Return Amount + Accumulated FreeSpin]",
  "pages.report.betRecord.overview.tooltip.platformFreespinAmount":
    "Platform Freespin Amount: Under current filter conditions, for Freespins provided by the platform side, the cumulative Freespin amount of all users.",
  "pages.report.betRecord.overview.tooltip.merchantFreespinAmount":
    "Accumulated FreeSpin Amount: Under current filter conditions, for Freespins provided by the merchant side, the cumulative Freespin amount of all users.",
  "pages.report.betRecord.table.title": "Bet Record List",
  "pages.report.betRecord.column.betId": "Bet ID",
  "pages.report.betRecord.column.merchantName": "Merchant Name",
  "pages.report.betRecord.column.merchantId": "Merchant ID",
  "pages.report.betRecord.column.parentOperator": "Direct Parent",
  "pages.report.betRecord.column.operatorPath": "Operator Path",
  "pages.report.betRecord.column.userId": "User ID",
  "pages.report.betRecord.column.gameId": "Game ID",
  "pages.report.betRecord.column.gameName": "Game Name",
  "pages.report.betRecord.column.currency": "Currency",
  "pages.report.betRecord.column.game": "Game",
  "pages.report.betRecord.column.merchant": "Merchant",
  "pages.report.betRecord.column.betAmount": "Bet Amount",
  "pages.report.betRecord.column.scoreAmount": "Return Amount",
  "pages.report.betRecord.column.scoreAmountUser": "Return Amount (User)",
  "pages.report.betRecord.column.winAmount": "Profit/Loss",
  "pages.report.betRecord.column.winAmountUser": "Profit/Loss (Platform)",
  "pages.report.betRecord.column.surplusCoin": "Wallet Balance",
  "pages.report.betRecord.column.freespinType": "Freespin Type",
  "pages.report.betRecord.column.freespin": "Freespin Amount",
  "pages.report.betRecord.column.gameMode": "Game Mode",
  "pages.report.betRecord.column.cascadeType": "Cascade Type",
  "pages.report.betRecord.column.platformFreespinAmount": "Platform Freespin",
  "pages.report.betRecord.column.merchantFreespinAmount":
    "Accumulated Freespin",
  "pages.report.betRecord.column.ip": "IP",
  "pages.report.betRecord.column.createdAt": "Bet Time",
  "pages.report.betRecord.column.settlementTime": "Settlement Time",
  "pages.report.betRecord.column.replay": "Replay",
  "pages.report.betRecord.column.action": "Action",
  "pages.report.betRecord.type.merchantFreespin": "Accumulated",
  "pages.report.betRecord.type.platformFreespin": "Platform",
  "pages.report.betRecord.type.sevenDayFreespin": "7-Day FreeSpin",
  "pages.report.betRecord.action.export": "Export",
  "pages.report.betRecord.action.replay": "Replay",
  "pages.report.betRecord.cascadeType.none": "-",
  "pages.report.betRecord.cascadeType.normalOrder": "Order Cascade",
  "pages.report.betRecord.cascadeType.miniGame": "Mini Game",
  "pages.report.betRecord.action.viewDetail": "View",
  "pages.report.betRecord.sortTip":
    "*Amount-related sorting is converted to USD before sorting (Default: last 6 months)",
  "pages.report.betRecord.export.filename": "BetRecord_",
  "pages.report.betRecord.message.exporting": "Exporting...",
  "pages.report.betRecord.message.exportSuccess": "Export Successful",
  "pages.report.betRecord.message.exportFailed": "Export Failed",

  // Agent Report
  "pages.report.agent.tab.custom": "Custom",
  "pages.report.agent.tab.game": "By Game",
  "pages.report.agent.tab.merchant": "By Merchant",
  "pages.report.agent.filter.merchant": "Merchant",
  "pages.report.agent.filter.game": "Game",
  "pages.report.agent.filter.currency": "Currency",
  "pages.report.agent.kpi.title": "Data Overview",
  "pages.report.agent.kpi.description": "Data refreshes every 15 minutes",
  "pages.report.agent.kpi.tooltip":
    "Total Bet Amount: Cumulative bet amount of all users within the selected time range under the current filter conditions.\n\nTotal Score Amount: Total prize amount obtained by all users under the current filter conditions (excluding activity amount).\n\nActivity Amount: Total Freespin amount obtained by all users under the current filter conditions. Platform Freespin + Accumulated Freespin\n\nTotal GGR: Total game revenue under the current filter conditions.\n(Total Bet Amount - Total Score Amount)\n\nTotal RTP: User Return Rate under the current filter conditions.\nRTP = Total Score Amount / Total Bet Amount\n\nTotal Bet Count: Total number of all betting behaviors under the current filter conditions. No deduplication required.\n\nTotal Bet User Count: Number of deduplicated users who have placed at least one bet under the current filter conditions. Deduplication required.\n\nGame Count: Number of enabled games.\n\nMerchant Count: Number of created merchants.",
  "pages.report.agent.kpi.betAmount": "Total Bet Amount",
  "pages.report.agent.kpi.scoreAmount": "Total Return Amount",
  "pages.report.agent.kpi.freespinAmount": "Activity Amount",
  "pages.report.agent.kpi.ggr": "Total GGR",
  "pages.report.agent.kpi.lossAmount": "Total Loss",
  "pages.report.agent.kpi.lossOrderCount": "Loss Order Count",
  "pages.report.agent.kpi.lossRate": "Overall Loss Rate",
  "pages.report.agent.kpi.profitRate": "Overall Profit Rate",
  "pages.report.agent.kpi.rtp": "Total RTP",
  "pages.report.agent.kpi.betCount": "Total Bet Count",
  "pages.report.agent.kpi.betUserCount": "Total Bet Users",
  "pages.report.agent.kpi.gameCount": "Game Count",
  "pages.report.agent.kpi.merchantCount": "Merchant Count",
  "pages.report.agent.kpi.negativeGGRMerchantCount": "Negative GGR Merchants",
  "pages.report.agent.kpi.prevPeriod": "Prev Period",
  "pages.report.agent.kpi.yesterday": "Yesterday",
  "pages.report.agent.kpi.beforeYesterday": "Day Before Yesterday",
  "pages.report.agent.kpi.ratio": "Ratio",
  "pages.report.agent.analysis.top10.game": "Game Top 10",
  "pages.report.agent.analysis.top10.merchant": "Merchant Top 10",
  "pages.report.agent.analysis.pie.title": "Data Distribution",
  "pages.report.agent.analysis.pie.betAmount": "Bet Amount",
  "pages.report.agent.analysis.pie.betCount": "Bet Count",
  "pages.report.agent.analysis.pie.ggr": "GGR",
  "pages.report.agent.analysis.pie.lossAmount": "Loss",
  "pages.report.agent.detail.period.daily": "Daily",
  "pages.report.agent.detail.period.weekly": "Weekly",
  "pages.report.agent.detail.period.monthly": "Monthly",
  "pages.report.agent.detail.level.1": "Level 1 Agent Statistics",
  "pages.report.agent.detail.level.2": "Level 2 Agent Statistics",
  "pages.report.agent.detail.level.3": "Merchant Detailed Data",
  "pages.report.agent.detail.column.date": "Date",
  "pages.report.agent.detail.column.profit": "Profit/Loss (Platform)",
  "pages.report.agent.detail.column.merchantFreespin": "Accumulated FreeSpin",
  "pages.report.agent.detail.column.platformFreespin": "Platform FreeSpin",
  "pages.report.agent.detail.column.avgBetAmount": "Avg Bet Amount",
  "pages.report.agent.detail.column.avgUserBetCount": "Avg User Bet Count",
  "pages.report.agent.detail.column.avgUserBetAmount": "Avg User Bet Amount",
  "pages.report.agent.detail.column.parentName": "Direct Parent",
  "pages.report.agent.detail.column.parentPath": "Affiliation Path",
  "pages.report.agent.detail.column.activityAmount": "Activity Amount",
  "pages.report.agent.detail.column.merchantId": "Merchant ID",
  "pages.report.agent.detail.column.gameId": "Game ID",
  "pages.report.agent.detail.column.statGame": "Stat Game",
  "pages.report.agent.detail.column.statMerchant": "Stat Merchant",
  "pages.report.agent.detail.column.lossAmount": "Loss Amount",
  "pages.report.agent.detail.column.lossRate": "Loss Rate",

  // Operation Logs
  "pages.system.logs.list.title": "Operation Logs",
  "pages.system.logs.detail.title": "Details",
  "pages.system.logs.field.id": "Log ID",
  "pages.system.logs.field.adminId": "Admin ID",
  "pages.system.logs.field.adminName": "Admin Name",
  "pages.system.logs.field.operatedId": "Operated ID",
  "pages.system.logs.field.operatedObject": "Operated Object",
  "pages.system.logs.field.operatedKeywords": "Operated",
  "pages.system.logs.field.adminKeywords": "Admin",
  "pages.system.logs.field.admin.placeholder": "Please enter name or ID",
  "pages.system.logs.field.subjectType": "Subject Type",
  "pages.system.logs.field.module": "Module",
  "pages.system.logs.field.action": "Action",
  "pages.system.logs.field.ip": "IP",
  "pages.system.logs.field.createdAt": "Created At",
  "pages.system.logs.field.before": "Before",
  "pages.system.logs.field.after": "After Change",
  "pages.system.logs.action.viewDetail": "View Detail",
  "pages.system.logs.subjectType.platform": "Platform",
  "pages.system.logs.subjectType.agent1": "Level 1 Agent",
  "pages.system.logs.subjectType.agent2": "Level 2 Agent",
  "pages.system.logs.subjectType.merchant": "Merchant",
  "pages.system.logs.module.role": "Role Management",
  "pages.system.logs.module.admin": "Admin List",
  "pages.system.logs.module.merchant": "Merchant Management",
  "pages.system.logs.json.changed": "(Changed)",
  "pages.system.logs.json.missing": "(Missing)",
  "pages.system.logs.json.was": "(was: {value})",
  "pages.system.logs.json.removed": "(Removed)",
  "pages.system.logs.json.added": "(Added)",
  "pages.system.logs.message.fetchError": "Failed to fetch logs",

  "pages.common.placeholder.select": "Please select",
  "pages.common.action": "Action",

  // Network and Request Errors
  "pages.common.error.network":
    "Network connection abnormal, please check your network",
  "pages.common.error.timeout":
    "Request timeout, please check your network connection",
  "pages.common.error.400": "Request error, please check parameters",
  "pages.common.error.401": "Unauthorized, please login again",
  "pages.common.error.403": "Access denied",
  "pages.common.error.404": "Request error, resource not found",
  "pages.common.error.405": "Request method not allowed",
  "pages.common.error.408": "Request timeout",
  "pages.common.error.500": "Server error",
  "pages.common.error.501": "Network not implemented",
  "pages.common.error.502": "Network error",
  "pages.common.error.503": "Service unavailable",
  "pages.common.error.504": "Network timeout",
  "pages.common.error.505": "HTTP version not supported",
  "pages.common.error.default": "Request exception, please try again",
  "pages.common.error.failed": "Request failed",
  "pages.common.error.response": "Response error: {status}",

  "pages.common.custom": "Custom",
  "pages.common.unit.min": "min",
  "pages.common.label.online": "Online",
  // Welcome Page
  "pages.welcome.title": "Welcome to Ant Design Pro",
  "pages.welcome.description":
    'Ant Design Pro is a scaffold solution that integrates umi, Ant Design and ProComponents. Committed to continuing to build upwards based on design specifications and basic components, refining typical templates/business components/supporting design resources, and further improving the experience of "users" and "designers" in the design and development process of enterprise-level middle and back-end products.',
  "pages.welcome.link.more": "Learn more",
  "pages.welcome.infoCard.umi.title": "About umi",
  "pages.welcome.infoCard.umi.desc":
    "umi is an extensible enterprise-level front-end application framework. umi is route-based and supports both configured routing and conventional routing, ensuring complete routing functions and using this for functional expansion.",
  "pages.welcome.infoCard.antd.title": "About ant design",
  "pages.welcome.infoCard.antd.desc":
    "antd is a React UI component library based on the Ant Design design system, mainly used for research and development of enterprise-level middle and back-end products.",
  "pages.welcome.infoCard.pro.title": "About Pro Components",
  "pages.welcome.infoCard.pro.desc":
    "ProComponents is a template component based on Ant Design with higher abstraction. It takes one component as one page as the development concept, bringing a better experience to middle and back-end development.",

  // Data Analysis
  "pages.statics.data.stat.title": "Data Overview",
  "pages.statics.data.stat.description": "Data refreshes every 15 minutes",
  "pages.statics.data.stat.tooltip.totalBetUserCount":
    "Total Bet Users: Deduplicated total number of users who bet during the period",
  "pages.statics.data.stat.tooltip.totalBetCount":
    "Total Bet Count: Total number of bets during the period",
  "pages.statics.data.stat.tooltip.totalBetAmount":
    "Total Bet Amount: Total amount of bets during the period",
  "pages.statics.data.stat.tooltip.avgUserBetAmount":
    "Avg Bet Amount (User): Total Bet Amount / Total Bet Users",
  "pages.statics.data.stat.tooltip.avgCountBetAmount":
    "Avg Bet Amount (Count): Total Bet Amount / Total Bet Count",
  "pages.statics.data.stat.tooltip.totalScoreAmount":
    "Total Score Amount: Total amount of prizes during the period",
  "pages.statics.data.stat.tooltip.userWinAmount":
    "Total Profit/Loss (Platform): Under current filter conditions, the cumulative profit/loss amount on the platform side. Total Profit/Loss = Total Bet Amount - [Total Return Amount + Accumulated FreeSpin]",
  "pages.statics.data.stat.tooltip.rtp":
    "Total RTP: Total Score Amount / Total Bet Amount",
  "pages.statics.data.stat.tooltip.newUserCount":
    "New Users: Number of newly registered users with activity during the period",
  "pages.statics.data.stat.tooltip.totalPlatformFsAmount":
    "Accumulated Freespin Amount: Total bet amount generated by Freespins provided by the game vendor under current filter conditions",
  "pages.statics.data.stat.tooltip.totalMerchantFsAmount":
    "Platform Freespin Amount: Total bet amount generated by Freespins provided by the merchant platform under current filter conditions",
  "pages.statics.data.table.title": "Data List",
  "pages.statics.data.table.tooltip.rtpAmount":
    "RTP (Amount): Score Amount / Bet Amount",
  "pages.statics.data.table.tooltip.rtpCount":
    "RTP (Count): Default each bet amount is 1 USD, Score Amount / (Bet Count * 1 USD)",
  "pages.statics.data.table.tooltip.baseGameRtp":
    "Only counts the RTP of the game's basic mode, excluding prize amounts from other activities",
  "pages.statics.data.table.tooltip.hundredAvgRtp":
    "Avg RTP (100+): For spins over 100, average RTP. (RTP1+RTP2+...RTPn)/n",
  "pages.statics.data.table.tooltip.hundredMaxRtp":
    "Max RTP (100+): For spins over 100, the highest RTP",
  "pages.statics.data.table.tooltip.hundredMinRtp":
    "Min RTP (100+): For spins over 100, the lowest RTP",
  "pages.statics.data.table.tooltip.quickSpinCount":
    "Quick Spin Count: During spin, each click on the speed-up button triggers once",
  "pages.statics.data.table.tooltip.superSpinCount":
    "Super Speed-Up Spin Count: During spin, each click on the super speed-up button triggers once",
  "pages.statics.data.column.game": "Game",
  "pages.statics.data.column.totalBetUserCount": "Total Bet Users",
  "pages.statics.data.column.totalBetCount": "Total Bet Count",
  "pages.statics.data.column.totalBetAmount": "Total Bet Amount",
  "pages.statics.data.column.avgCountBetAmount": "Avg Bet Amount",
  "pages.statics.data.column.totalScoreAmount": "Total Score Amount",
  "pages.statics.data.column.totalScoreAmount.tooltip":
    "Does not include bonuses",
  "pages.statics.data.column.userWinAmount": "Total Profit/Loss (Platform)",
  "pages.statics.data.column.rtp": "Total RTP",
  "pages.statics.data.column.totalPlatformFsAmount": "Platform Freespin Amount",
  "pages.statics.data.column.totalMerchantFsAmount":
    "Accumulated Freespin Amount",
  "pages.statics.data.column.betUserCount": "Bet Users",
  "pages.statics.data.column.betCount": "Bet Count",
  "pages.statics.data.column.betAmount": "Bet Amount",
  "pages.statics.data.column.avgBetCount": "Avg Bet Count",
  "pages.statics.data.column.avgBetAmountByCount": "Avg Bet Amount (Count)",
  "pages.statics.data.column.avgBetAmountByUser": "Avg Bet Amount (User)",
  "pages.statics.data.column.scoreAmount": "Score Amount",
  "pages.statics.data.column.totalWinAmount": "Total Profit/Loss (Platform)",
  "pages.statics.data.column.totalWinAmount.tooltip":
    "Total Profit/Loss (Platform): Under current filter conditions, the cumulative profit/loss amount on the platform side. Total Profit/Loss = Total Bet Amount - [Total Return Amount + Accumulated FreeSpin]",
  "pages.statics.data.column.rtpBase": "RTP (Base)",
  "pages.statics.data.column.rtpAmount": "RTP (Amount)",
  "pages.statics.data.column.rtpCount": "RTP (Count)",
  "pages.statics.data.column.baseGameRtp": "Base Game RTP",
  "pages.statics.data.column.hundredAvgRtp": "Avg RTP (100+)",
  "pages.statics.data.column.hundredMaxRtp": "Max RTP (100+)",
  "pages.statics.data.column.hundredMinRtp": "Min RTP (100+)",
  "pages.statics.data.column.quickSpinCount": "Quick Spin Count",
  "pages.statics.data.column.superSpinCount": "Super Speed-Up Spin Count",
  "pages.statics.data.column.newUserCount": "New Users",
  "pages.statics.data.column.prizeMultiple": "Prize Multiple",
  "pages.statics.data.column.newPlayerJackpot": "New Player Jackpot",
  "pages.statics.data.column.newPlayerJackpot.tooltip":
    "Daily jackpot consumed / Daily jackpot triggered",

  // Game Analysis
  "pages.statics.games.segment.core": "Core Data",
  "pages.statics.games.segment.payment": "I. Payment & Revenue",
  "pages.statics.games.segment.progress": "II. Progress Distribution",
  "pages.statics.games.segment.special": "III. Special Mechanism",
  "pages.statics.games.segment.maxwin": "IV. Maxwin Analysis",
  "pages.statics.games.table.title": "Game Analysis Data",
  "pages.statics.games.column.date": "Date",
  "pages.statics.games.column.operatorName": "Operator Name",
  "pages.statics.games.column.operatorToken": "Operator AppID",
  "pages.statics.games.column.operation": "Operation",
  "pages.statics.games.action.viewDetail": "View Details",
  "pages.statics.games.drawer.title": "{name} Game Track Details",
  "pages.statics.games.pagination.total": "Total {total} items",

  "pages.statics.data.column.merchantFreeSpinAmount": "Accumulated Freespin",
  "pages.statics.data.column.platformFreeSpinAmount": "Platform Freespin",

  // Data Analysis Activity Tags
  "pages.statics.data.tag.sevenFreeSpin": "7-Day",
  "pages.statics.data.tag.freeSpin": "Accumulated",
  "pages.statics.data.tag.activityId": "ID",
  "pages.statics.data.tag.activityName": "Name",
  "pages.statics.data.tag.activityTime": "Time",

  "pages.common.label.id": "ID",
  "pages.common.date.preset.previousCycle": "Previous Cycle",
  "pages.common.ratio.wow": "Ratio",
  "pages.common.percentage": "Percentage",

  "pages.safe.warn.filter.createdAt": "Created Time",
  "pages.safe.warn.filter.riskType": "Monitoring Model",
  "pages.safe.warn.filter.riskType.placeholder":
    "Please select a monitoring model",
  "pages.safe.warn.column.createdAt": "Created Time",
  "pages.safe.warn.column.monitorName": "Monitoring Name",
  "pages.safe.warn.column.riskType": "Monitoring Model",
  "pages.safe.warn.column.monitorRange": "Monitoring Scope",
  "pages.safe.warn.column.conditionThreshold": "Condition & Threshold",
  "pages.safe.warn.column.severity": "Warning Severity",
  "pages.safe.warn.column.status": "Status",
  "pages.safe.warn.riskType.rtpReport": "RTP Report Monitoring Model",
  "pages.safe.warn.riskType.singleAmount": "Single Amount Monitoring Model",
  "pages.safe.warn.riskType.behaviorFrequency":
    "Behavior Frequency Monitoring Model",
  "pages.safe.warn.riskType.singleGameLoss":
    "Single Game Loss Monitoring Model",
  "pages.safe.warn.riskType.singleUserAmount":
    "Single User Amount Monitoring Model",
  "pages.safe.warn.condition.yellow": "Yellow warning: {value}",
  "pages.safe.warn.condition.red": "Red warning: {value}",
  "pages.safe.warn.condition.layer": "Layer {index}: {value}",
  "pages.safe.warn.condition.frequency.seconds": "{count} sec",
  "pages.safe.warn.condition.frequency.betCount": "{count} bets",
  "pages.safe.warn.severity.yellow": "Yellow Warning",
  "pages.safe.warn.severity.red": "Red Warning",
  "pages.safe.warn.severity.blueLayer": "Blue Risk Layer {index}",
  "pages.safe.warn.status.enabled": "Enabled",
  "pages.safe.warn.status.disabled": "Disabled",
  "pages.safe.warn.action.add": "Add Risk Rule",
  "pages.safe.warn.action.batchEnable": "Batch Enable",
  "pages.safe.warn.action.batchDisable": "Batch Disable",
  "pages.safe.warn.action.edit": "Edit",
  "pages.safe.warn.action.copy": "Copy",
  "pages.safe.warn.action.detail": "Detail",
  "pages.safe.warn.action.status": "Toggle Status",
  "pages.safe.warn.drawer.title.create": "Add Risk Rule",
  "pages.safe.warn.drawer.title.edit": "Edit Risk Rule",
  "pages.safe.warn.drawer.form.name": "Monitoring Name",
  "pages.safe.warn.drawer.form.name.placeholder":
    "Please enter monitoring name",
  "pages.safe.warn.drawer.form.riskType": "Monitoring Model",
  "pages.safe.warn.drawer.form.riskType.placeholder":
    "Please select a monitoring model",
  "pages.safe.warn.drawer.form.thresholdYellow": "Yellow Warning Threshold",
  "pages.safe.warn.drawer.form.thresholdYellow.placeholder":
    "Please enter the yellow warning threshold",
  "pages.safe.warn.drawer.form.thresholdRed": "Red Warning Threshold",
  "pages.safe.warn.drawer.form.thresholdRed.placeholder":
    "Please enter the red warning threshold",
  "pages.safe.warn.drawer.form.frequencySeconds": "Within Seconds",
  "pages.safe.warn.drawer.form.frequencySeconds.placeholder":
    "Please enter seconds",
  "pages.safe.warn.drawer.form.frequencyBetCount":
    "Bet Count Greater Than or Equal To",
  "pages.safe.warn.drawer.form.frequencyBetCount.placeholder":
    "Please enter bet count",
  "pages.safe.warn.drawer.form.layeredThreshold": "Layer {index} Threshold",
  "pages.safe.warn.drawer.form.layeredThreshold.placeholder":
    "Please enter threshold",
  "pages.safe.warn.drawer.form.amountRulePrefix": "Greater than or equal to",
  "pages.safe.warn.drawer.form.frequencyConnector":
    "seconds, and the bet count is greater than or equal to",
  "pages.safe.warn.drawer.form.layeredThresholdText": "Layered Thresholds",
  "pages.safe.lossAnalysis.detail.summary.totalBetAmount": "Total Bet Amount",
  "pages.safe.lossAnalysis.detail.summary.totalScoreAmount": "Reward Amount",
  "pages.safe.lossAnalysis.detail.summary.totalLossAmount": "Total Loss",
  "pages.safe.lossAnalysis.detail.summary.totalLossAmountDescription":
    "Sum of all loss amounts",
  "pages.safe.warn.drawer.form.layeredThresholdText.placeholder":
    "Enter layered thresholds, one per line or separated by commas",
  "pages.safe.warn.drawer.form.layeredThresholdText.extra":
    "The value will be serialized as a comma-separated string on submit, for example: 1000,2000,3000",
  "pages.safe.warn.drawer.section.threshold": "Threshold Config",
  "pages.safe.warn.drawer.section.rtpThreshold": "RTP Threshold Config",
  "pages.safe.warn.drawer.section.amountThreshold": "Amount Threshold Config",
  "pages.safe.warn.drawer.section.frequencyRule": "Behavior Frequency Rule",
  "pages.safe.warn.drawer.section.yellow": "Yellow Warning Rule",
  "pages.safe.warn.drawer.section.red": "Red Warning Rule",
  "pages.safe.warn.drawer.section.layeredThreshold": "Layered Threshold Config",
  "pages.safe.warn.unit.percent": "%",
  "pages.safe.warn.unit.dollar": "$",
  "pages.safe.warn.unit.times": "times",
  "pages.safe.warn.drawer.action.addLayer": "Add Threshold Layer",
  "pages.safe.warn.drawer.action.removeLayer": "Remove Current Layer",
  "pages.safe.warn.drawer.validation.nameRequired":
    "Please enter monitoring name",
  "pages.safe.warn.drawer.validation.riskTypeRequired":
    "Please select a monitoring model",
  "pages.safe.warn.drawer.validation.thresholdYellowRequired":
    "Please enter the yellow warning threshold",
  "pages.safe.warn.drawer.validation.thresholdRedRequired":
    "Please enter the red warning threshold",
  "pages.safe.warn.drawer.validation.frequencyYellowSecondsRequired":
    "Please enter seconds for the yellow warning rule",
  "pages.safe.warn.drawer.validation.frequencyYellowBetCountRequired":
    "Please enter bet count for the yellow warning rule",
  "pages.safe.warn.drawer.validation.frequencyRedSecondsRequired":
    "Please enter seconds for the red warning rule",
  "pages.safe.warn.drawer.validation.frequencyRedBetCountRequired":
    "Please enter bet count for the red warning rule",
  "pages.safe.warn.drawer.validation.layeredThresholdsRequired":
    "Please enter at least one layered threshold",
  "pages.safe.warn.drawer.validation.layeredThresholdRequired":
    "Please complete the threshold value",
  "pages.safe.warn.drawer.validation.layeredThresholdFormatInvalid":
    "Layered thresholds only support positive integers separated by new lines or commas",
  "pages.safe.warn.message.listFailed": "Failed to load risk warning list",
  "pages.safe.warn.message.selectAtLeastOne":
    "Please select at least one risk config",
  "pages.safe.warn.message.statusIdMissing": "Risk config ID not found",
  "pages.safe.warn.message.statusUpdateSuccess": "{status} successfully",
  "pages.safe.warn.message.statusUpdateFailed": "Failed to set to {status}",
  "pages.safe.warn.message.saveIdMissing":
    "Risk config ID not found, unable to save the edit",
  "pages.safe.warn.message.createSuccess": "Risk config created successfully",
  "pages.safe.warn.message.createFailed": "Failed to create risk config",
  "pages.safe.warn.message.updateSuccess": "Risk config updated successfully",
  "pages.safe.warn.message.updateFailed": "Failed to update risk config",
  "pages.safe.warn.message.placeholder":
    "{action} is not available in this iteration. The current page only keeps a placeholder entry.",
  "pages.safe.warn.selection.selected": "{count} items selected",
  "pages.safe.warn.selection.clear": "Clear Selection",
  "pages.safe.warn.empty": "No risk warning config data",

  "pages.safe.logs.list.title": "Risk Logs",
  "pages.safe.logs.filter.createdAt": "Trigger Time",
  "pages.safe.logs.filter.riskType": "Alert Type",
  "pages.safe.logs.filter.riskType.placeholder": "Please select alert type",
  "pages.safe.logs.column.alertName": "Alert Type",
  "pages.safe.logs.column.merchantName": "Merchant",
  "pages.safe.logs.column.gameName": "Game",
  "pages.safe.logs.column.roleId": "User ID",
  "pages.safe.logs.column.ip": "User IP",
  "pages.safe.logs.column.content": "Abnormal Data",
  "pages.safe.logs.column.alertLevel": "Alert Level",
  "pages.safe.logs.column.createdAt": "Trigger Time",
  "pages.safe.logs.alertLevel.yellow": "Yellow Warning",
  "pages.safe.logs.alertLevel.red": "Red Warning",
  "pages.safe.logs.action.detail": "Detail",
  "pages.safe.logs.action.remark": "Remark",
  "pages.safe.logs.remark.title": "Risk Logs - Remark",
  "pages.safe.logs.remark.form.placeholder": "Please enter a remark, optional",
  "pages.safe.logs.remark.form.max": "Remark can contain up to 500 characters",
  "pages.safe.logs.remark.message.idMissing": "Risk log ID not found",
  "pages.safe.logs.remark.message.versionMissing": "Risk log version not found",
  "pages.safe.logs.remark.message.success": "Remark saved successfully",
  "pages.safe.logs.remark.message.failed": "Failed to save remark",
  "pages.safe.logs.message.listFailed": "Failed to load risk logs",
  "pages.safe.logs.message.detailPlaceholder":
    "Detail is not available in this iteration. Only a placeholder entry is kept.",
  "pages.safe.logs.empty": "No risk log data",

  "pages.safe.lossAnalysis.filter.merchant": "Merchant",
  "pages.safe.lossAnalysis.filter.game": "Game",
  "pages.safe.lossAnalysis.overview.amountNote":
    "All amounts shown in the list have been converted to USD",
  "pages.safe.lossAnalysis.overview.totalLossAmount": "Total Loss",
  "pages.safe.lossAnalysis.overview.totalLossAmount.tooltip":
    "Total Loss = Total Payout - Total Bet",
  "pages.safe.lossAnalysis.overview.totalLossRate": "Overall Loss Rate",
  "pages.safe.lossAnalysis.overview.totalLossRate.tooltip":
    "Overall Loss Rate = (Total Payout - Total Bet) / Total Bet",
  "pages.safe.lossAnalysis.overview.lossOrderCount": "Loss Orders",
  "pages.safe.lossAnalysis.overview.compare": "Compare {label}",
  "pages.safe.lossAnalysis.overview.today": "Today",
  "pages.safe.lossAnalysis.overview.previousCycle": "Previous Cycle",
  "pages.safe.lossAnalysis.tab.game": "Game Loss Ranking",
  "pages.safe.lossAnalysis.tab.merchant": "Merchant Loss Ranking",
  "pages.safe.lossAnalysis.tab.player": "High-Risk Player Ranking",
  "pages.safe.lossAnalysis.table.title": "Loss Ranking",
  "pages.safe.lossAnalysis.table.column.gameId": "Game ID",
  "pages.safe.lossAnalysis.table.column.gameName": "Game Name",
  "pages.safe.lossAnalysis.table.column.merchantId": "Merchant ID",
  "pages.safe.lossAnalysis.table.column.merchantName": "Merchant Name",
  "pages.safe.lossAnalysis.table.column.playerId": "Player ID",
  "pages.safe.lossAnalysis.table.column.netLossAmount": "Net Loss",
  "pages.safe.lossAnalysis.table.column.lossRate": "Loss Rate",
  "pages.safe.lossAnalysis.table.column.lossOrderCount": "Loss Orders",
  "pages.safe.lossAnalysis.table.column.userCount": "User Count",
  "pages.safe.lossAnalysis.table.column.maxSingleLossAmount": "Max Single Loss",
  "pages.safe.lossAnalysis.table.column.maxSingleLossAmount.tooltip":
    "The single order with the largest platform loss amount under the current filter conditions",
  "pages.safe.lossAnalysis.table.column.betAmount": "Total Bet",
  "pages.safe.lossAnalysis.table.column.scoreAmount": "Total Payout",
  "pages.safe.lossAnalysis.table.column.action": "Action",
  "pages.safe.lossAnalysis.action.detail": "View Detail",
  "pages.safe.lossAnalysis.action.export": "Export",
  "pages.safe.lossAnalysis.export.filename.game": "GameLossRanking_",
  "pages.safe.lossAnalysis.export.filename.merchant": "MerchantLossRanking_",
  "pages.safe.lossAnalysis.export.filename.player": "HighRiskPlayerRanking_",
  "pages.safe.lossAnalysis.message.overviewFailed":
    "Failed to load loss analysis overview",
  "pages.safe.lossAnalysis.message.gameRankFailed":
    "Failed to load game loss ranking",
  "pages.safe.lossAnalysis.message.merchantRankFailed":
    "Failed to load merchant loss ranking",
  "pages.safe.lossAnalysis.message.playerRankFailed":
    "Failed to load high-risk player ranking",
  "pages.safe.lossAnalysis.message.exportFailed": "Export failed",
  "pages.safe.lossAnalysis.message.placeholder":
    "{action} is not available in this iteration. Only a placeholder entry is kept.",
  "pages.safe.lossAnalysis.empty": "No loss ranking data",
  "pages.safe.lossAnalysis.detail.title.description":
    "Every losing bet record is included, preserving the original currency",
  "pages.safe.lossAnalysis.detail.title.game": "Game {gameName} (ID: {gameId})",
  "pages.safe.lossAnalysis.detail.title.merchant":
    "Merchant {operatorName} (ID: {operatorId})",
  "pages.safe.lossAnalysis.detail.title.player": "Player {roleId}",
  "pages.safe.lossAnalysis.detail.column.lossAmount": "Loss Amount",
  "pages.safe.lossAnalysis.detail.message.listFailed":
    "Failed to load loss details",
  "pages.safe.lossAnalysis.detail.empty": "No loss detail data",

  // RTP Config
  "pages.config.rtp.filter.createdAt": "Created At",
  "pages.config.rtp.filter.keywords": "ID/Name",
  "pages.config.rtp.filter.keywords.placeholder":
    "Enter ID/Game Name/Plan Name",
  "pages.config.rtp.filter.approvalStatus": "Approval Status",
  "pages.config.rtp.approvalStatus.pendingPublish": "Pending Publish",
  "pages.config.rtp.approvalStatus.underReview": "Under Review",
  "pages.config.rtp.approvalStatus.published": "Published",
  "pages.config.rtp.approvalStatus.rejected": "Rejected",
  "pages.config.rtp.column.id": "ID",
  "pages.config.rtp.column.game": "Game",
  "pages.config.rtp.column.name": "Plan",
  "pages.config.rtp.column.configName": "Current Yaml",
  "pages.config.rtp.column.rtp": "Overall RTP",
  "pages.config.rtp.column.rtp.tooltip":
    "Overall RTP is sourced from Total RTP in the dispatch verification results",
  "pages.config.rtp.column.approvalStatus": "Approval Status",
  "pages.config.rtp.column.status": "Enable/Disable",
  "pages.config.rtp.column.configVersion": "Current Version",
  "pages.config.rtp.column.createdAt": "Import Time",
  "pages.config.rtp.column.updatedAt": "Last Import Time",
  "pages.config.rtp.column.action.placeholder": "Reserved",
  "pages.config.rtp.status.enabled": "Enable",
  "pages.config.rtp.status.disabled": "Disable",
  "pages.config.rtp.action.batchEnable": "Batch Enable",
  "pages.config.rtp.action.batchDisable": "Batch Disable",
  "pages.config.rtp.action.export": "Export Config",
  "pages.config.rtp.action.import": "Import Config",
  "pages.config.rtp.action.addVersion": "Add Version",
  "pages.config.rtp.action.versionManagement": "Version Management",
  "pages.config.rtp.versionHistory.title":
    "Version Management - {configName} - {name}",
  "pages.config.rtp.versionHistory.empty": "No version history data",
  "pages.config.rtp.versionHistory.column.configVersion": "Version",
  "pages.config.rtp.versionHistory.column.fileName": "File Name",
  "pages.config.rtp.versionHistory.download": "Download",
  "pages.config.rtp.versionHistory.column.remark": "Remark",
  "pages.config.rtp.versionHistory.column.rtp": "Overall RTP",
  "pages.config.rtp.versionHistory.column.importTime": "Import Time",
  "pages.config.rtp.versionHistory.column.operator": "Operator",
  "pages.config.rtp.versionHistory.column.status": "Status",
  "pages.config.rtp.versionHistory.status.enabled": "Enabled",
  "pages.config.rtp.versionHistory.status.pendingReview": "Pending Review",
  "pages.config.rtp.versionHistory.status.disabled": "Disabled",
  "pages.config.rtp.versionHistory.enable.confirm.title":
    "Confirm Enable Version",
  "pages.config.rtp.versionHistory.enable.confirm.content":
    "You are about to activate version {configVersion}. After publishing, the currently running old version will be automatically deactivated and returned to unpublished status. This action will directly affect online game configuration. Please confirm whether to continue?",
  "pages.config.rtp.versionHistory.revoke.confirm.title": "Confirm Revoke",
  "pages.config.rtp.versionHistory.revoke.confirm.content":
    "After revocation, the enablement application will be withdrawn in the review center. (Reviewers will not be able to see this application)",
  "pages.config.rtp.versionHistory.configContent.title": "Config Content",
  "pages.config.rtp.action.revoke": "Revoke",
  "pages.config.rtp.action.edit": "Edit",
  "pages.config.rtp.action.enable": "Enable",
  "pages.config.rtp.action.remark": "Remark",
  "pages.config.rtp.action.review": "Submit Review",
  "pages.config.rtp.action.runCheck": "Run Check",
  "pages.config.rtp.action.runCheck.running": "Running simulation rounds",
  "pages.config.rtp.action.runCheck.error": "Run check failed",
  "pages.config.rtp.action.runCheck.completed": "Run check completed",
  "pages.config.rtp.action.pending": "Feature to be extended later",
  "pages.config.rtp.check.title": "RTP Check - {name}",
  "pages.config.rtp.export.filename": "RTPConfig_",
  "pages.config.rtp.modal.title.create": "Add Version",
  "pages.config.rtp.modal.title.edit": "Edit RTP Config",
  "pages.config.rtp.modal.tip":
    "Please upload an accurate YAML/JSON config file and ensure the run check passes before saving.",
  "pages.config.rtp.modal.section.upload": "Upload Template",
  "pages.config.rtp.modal.section.runCheck": "Run Check",
  "pages.config.rtp.modal.action.saveDraft": "Save",
  "pages.config.rtp.modal.action.saveAndPublish": "Save and Enable",
  "pages.config.rtp.modal.form.game": "Game",
  "pages.config.rtp.modal.form.game.placeholder": "Please select a game",
  "pages.config.rtp.modal.form.game.required": "Please select a game",
  "pages.config.rtp.modal.form.game.editLocked":
    "Game cannot be changed when editing",
  "pages.config.rtp.modal.form.name": "Plan Name",
  "pages.config.rtp.modal.form.name.placeholder": "Please enter plan name",
  "pages.config.rtp.modal.form.name.required": "Please enter plan name",
  "pages.config.rtp.modal.form.config": "Config File",
  "pages.config.rtp.modal.form.config.placeholder": "Please select config file",
  "pages.config.rtp.modal.form.config.required": "Please upload config file",
  "pages.config.rtp.modal.form.config.current":
    "Current config file: {fileName}",
  "pages.config.rtp.modal.form.config.extra":
    "Only .json, .yaml, .yml files are supported",
  "pages.config.rtp.modal.form.configVersion": "Version",
  "pages.config.rtp.modal.form.configVersion.placeholder":
    "Please enter version",
  "pages.config.rtp.modal.form.configVersion.required": "Please enter version",
  "pages.config.rtp.modal.form.configVersion.existing":
    "Existing versions: {versions}",
  "pages.config.rtp.modal.form.configVersion.duplicate":
    "Version number already exists, please enter a different one",
  "pages.config.rtp.modal.form.remark": "Remark",
  "pages.config.rtp.modal.form.remark.placeholder": "Please enter remark",
  "pages.config.rtp.modal.form.rtp": "Overall RTP",
  "pages.config.rtp.modal.form.rtp.required":
    "Please complete run check or enter RTP",
  "pages.config.rtp.modal.form.otherParams": "Additional Params",
  "pages.config.rtp.modal.form.otherParams.placeholder":
    "Please enter additional params",
  "pages.config.rtp.modal.form.runResult": "Run Result",
  "pages.config.rtp.modal.form.runResult.placeholder":
    "Run output will be auto-filled here, or you can manually add notes",
  "pages.config.rtp.modal.runCheck.title": "Run Check Terminal",
  "pages.config.rtp.modal.runCheck.gameBin.label":
    "Current order execution program: ",
  "pages.config.rtp.modal.runCheck.gameBin.loading": "Loading run program...",
  "pages.config.rtp.modal.runCheck.gameBin.empty": "No valid run program found",
  "pages.config.rtp.modal.runCheck.gameBin.required":
    "No valid run program found",
  "pages.config.rtp.modal.runCheck.tab.base": "Basic Mode",
  "pages.config.rtp.modal.runCheck.result.required":
    "Please complete run check and generate run result first",
  "pages.config.rtp.modal.runCheck.metrics.missing":
    "Base mode run check missing required metrics: {fields}",
  "pages.config.rtp.action.runResult": "Run Check",
  "pages.config.rtp.preview.title": "Verification Result Snapshot Preview",
  "pages.config.rtp.preview.snapshot.label":
    "Core data indicators from run check at submission:",
  "pages.config.rtp.preview.snapshot.title": "Historical Run Snapshot",
  "pages.config.rtp.preview.snapshot.empty":
    "No historical run result snapshot",
  "pages.config.rtp.preview.snapshot.tip":
    "Note: The above results are snapshots from submission time, for historical review only. They do not represent real-time verification results of the current config file.",
  "pages.config.rtp.preview.rerun.section": "Config Retest (Re-run)",
  "pages.config.rtp.preview.rerun.title": "Re-run Result",
  "pages.config.rtp.preview.rerun.tip":
    "Note: The following is the latest re-run result from the current config. Results may differ from historical snapshots if config or program has changed.",
  "pages.config.rtp.preview.rerun.disabled":
    "Current record lacks valid config file path or run program path. Unable to re-run.",
  "pages.config.rtp.preview.action.rerun": "Re-run Check",
  "pages.config.rtp.preview.action.rerun.completed":
    "Re-run completed. Can run again.",
  "pages.config.rtp.preview.action.close": "Close",
  "pages.config.rtp.preview.gameBin.label": "Current run program: ",
  "pages.config.rtp.preview.gameBin.empty": "No valid run program found",
  "pages.config.rtp.remark.title": "RTP Config - Remark",
  "pages.config.rtp.remark.form.placeholder": "Please enter remark (optional)",
  "pages.config.rtp.remark.form.max": "Remark cannot exceed 500 characters",
  "pages.config.rtp.remark.message.success": "Remark saved successfully",
  "pages.config.rtp.remark.message.failed": "Failed to save remark",
  "pages.config.rtp.remark.message.idMissing": "RTP config ID does not exist",
  "pages.config.rtp.modal.upload.message.success":
    "Config file uploaded successfully",
  "pages.config.rtp.modal.upload.message.failed": "Config file upload failed",
  "pages.config.rtp.modal.upload.message.fileNameMismatch":
    "File name must be {expected}, but got {actual}",
  "pages.config.rtp.modal.upload.message.invalidResponse":
    "Upload response missing file URL. Please try again later.",
  "pages.config.rtp.message.listFailed": "Failed to load RTP config list",
  "pages.config.rtp.message.createSuccess": "RTP config imported successfully",
  "pages.config.rtp.message.createFailed": "Failed to import RTP config",
  "pages.config.rtp.message.nameUpdateSuccess":
    "Plan name updated successfully",
  "pages.config.rtp.message.nameUpdateFailed": "Failed to update plan name",
  "pages.config.rtp.message.saveDraftSuccess": "Saved successfully",
  "pages.config.rtp.message.saveAndPublishSuccess":
    "Saved and enabled successfully",
  "pages.config.rtp.message.saveAndEnableSuccess": "Enable request submitted",
  "pages.config.rtp.message.updateSuccess": "RTP config updated successfully",
  "pages.config.rtp.message.updateFailed": "Failed to update RTP config",
  "pages.config.rtp.message.reviewSuccess": "Review submitted successfully",
  "pages.config.rtp.message.reviewFailed": "Failed to submit review",
  "pages.config.rtp.message.enableSuccess": "Enabled successfully",
  "pages.config.rtp.message.enableFailed": "Failed to enable",
  "pages.config.rtp.message.revokeSuccess": "Revoked successfully",
  "pages.config.rtp.message.revokeFailed": "Failed to revoke",
  "pages.config.rtp.message.disableSuccess": "Config disabled",
  "pages.config.rtp.message.selectAtLeastOne":
    "Please select at least one RTP config",
  "pages.config.rtp.message.statusUpdateSuccess": "{status} successfully",
  "pages.config.rtp.message.statusUpdateFailed": "{status} failed",
  "pages.config.rtp.message.statusIdMissing": "RTP config ID does not exist",
  "pages.config.rtp.confirm.enable.title": "Confirm to enable this config?",
  "pages.config.rtp.confirm.enable.content":
    "After enabling, this RTP tier will immediately go live and directly affect actual player strategies. Please confirm the timing aligns with operational expectations.",
  "pages.config.rtp.confirm.review.title": "Confirm to submit review?",
  "pages.config.rtp.confirm.review.content":
    'After submission, this config will enter "Under Review" status and you will not be able to modify it during this period.',
  "pages.config.rtp.selection.selected": "{count} items selected",
  "pages.config.rtp.selection.clear": "Clear selection",
  "pages.config.rtp.card.count": "{count} configs",
  "pages.config.rtp.card.unknownGame": "Unnamed Game",
  "pages.config.rtp.card.reviewedCount": "{count} reviewed configs",
  "pages.config.rtp.card.currentOnline": "Current online:",
  "pages.config.rtp.card.importGame": "Import This Game Config",
  "pages.config.rtp.empty": "No RTP config data",

  // Activity Management
  "pages.business.manage.tab.merchantFreeSpin": "Accumulated Freespin",
  "pages.business.manage.tab.sevenFreeSpin": "7-Day FreeSpin",
  "pages.business.manage.filter.createdAt": "Created",
  "pages.business.manage.filter.keywords": "Search",
  "pages.business.manage.filter.keywords.placeholder": "ID / Name",
  "pages.business.manage.filter.activityTime": "Activity Time",
  "pages.business.manage.filter.approvalStatus": "Approval Status",
  "pages.business.manage.filter.activityStatus": "Activity Status",
  "pages.business.manage.column.id": "Activity ID",
  "pages.business.manage.column.name": "Activity Name",
  "pages.business.manage.column.game": "Game",
  "pages.business.manage.column.appids": "Merchants",
  "pages.business.manage.column.activityStatus": "Activity Status",
  "pages.business.manage.column.createdAt": "Created",
  "pages.business.manage.column.getTime": "Claim Time",
  "pages.business.manage.column.useTime": "Use Time",
  "pages.business.manage.column.startTime": "Start Time",
  "pages.business.manage.column.endTime": "End Time",
  "pages.business.manage.column.totalEndTime": "Draw End Time",
  "pages.business.manage.column.giftConfig": "Gift Config",
  "pages.business.manage.column.times": "Times",
  "pages.business.manage.column.level": "Bet Tier",
  "pages.business.manage.column.betMin": "Min Bet",
  "pages.business.manage.column.prizePool": "Prize Pool",
  "pages.business.manage.column.betAmount": "Min Bet",
  "pages.business.manage.column.totalBonus": "Prize Pool",
  "pages.business.manage.column.freeSpinCount": "Free Spins",
  "pages.business.manage.column.freeSpinBet": "Bet Tier Value",
  "pages.business.manage.column.approvalStatus": "Approval Status",
  "pages.business.manage.column.dayConfig": "D{day} Config",
  "pages.business.manage.column.activityTime": "Activity Time",
  "pages.business.manage.action.copy": "Copy",
  "pages.business.manage.action.detail": "Detail",
  "pages.business.manage.action.delete": "Delete",
  "pages.business.manage.action.edit": "Edit",
  "pages.business.manage.action.shelf": "On/Off Shelf",
  "pages.business.manage.action.up": "On Shelf",
  "pages.business.manage.action.publish": "Publish",
  "pages.business.manage.action.down": "Off Shelf",
  "pages.business.manage.action.analysis": "Analysis",
  "pages.business.manage.action.add": "Add Activity",
  "pages.business.manage.action.addDay": "Add Day",
  "pages.business.manage.analysis.title": "Data Analysis - {name}",
  "pages.business.manage.analysis.subtitle":
    "Activity ID: {id} | Activity Time: {time}",
  "pages.business.manage.analysis.action.search": "Search",
  "pages.business.manage.analysis.empty": "No analysis data",
  "pages.business.manage.analysis.dayTag": "Day {day}",
  "pages.business.manage.analysis.chart.title":
    "Daily Prize Pool Consumption and User Participation Trend",
  "pages.business.manage.analysis.chart.date": "Date",
  "pages.business.manage.analysis.chart.description":
    "Shows the total daily bonus consumed (line chart) and the number of unique participating/spinning users of the day (bar chart).",
  "pages.business.manage.analysis.card.poolConsumed": "Prize Pool Progress",
  "pages.business.manage.analysis.card.poolProgressLabel":
    "Consumption Progress",
  "pages.business.manage.analysis.card.poolConsumedFooter": "Speed: {amount}",
  "pages.business.manage.analysis.card.poolOverBudgetWarning":
    "Warning: Over budget by {rate}",
  "pages.business.manage.analysis.card.poolOverBudgetAction":
    "Fallback Fund Coverage",
  "pages.business.manage.analysis.card.poolConsumedEta": "Consumed Soon",
  "pages.business.manage.analysis.card.participants":
    "Qualified and Participant Users",
  "pages.business.manage.analysis.card.participantsUv":
    "Qualified and Participant Users (UV)",
  "pages.business.manage.analysis.card.participantsActivation":
    "penetration {activationRate}",
  "pages.business.manage.analysis.card.qualifiedUsersLabel":
    "Qualified Spin Users",
  "pages.business.manage.analysis.card.participantsDesc":
    "Qualified users {qualifiedUsers}, activation rate {activationRate}",
  "pages.business.manage.analysis.card.freeSpinPv": "Total FreeSpin PV",
  "pages.business.manage.analysis.card.freeSpinPvTotal":
    "FreeSpin Total Count (PV)",
  "pages.business.manage.analysis.card.freeSpinPvUnit": "times",
  "pages.business.manage.analysis.card.averageSpinsLabel":
    "Average Spins per User",
  "pages.business.manage.analysis.card.averageSpinsDesc":
    "Average spins per participant {averageSpins}",
  "pages.business.manage.analysis.card.merchantNet": "Merchant Net Income",
  "pages.business.manage.analysis.card.merchantNetDesc":
    "Net income after bet, payout, and FreeSpin payout deductions",
  "pages.business.manage.analysis.card.freeSpinPayout": "FreeSpin Payout",
  "pages.business.manage.analysis.card.freeSpinPayoutFs":
    "FREESPIN Actual Payout (FS PAYOUT)",
  "pages.business.manage.analysis.card.freeSpinPayoutDesc":
    "Total bonus amount completed by players through FS rewards",
  "pages.business.manage.analysis.card.betThresholdDesc":
    "Prize pool usage threshold {betThreshold}",
  "pages.business.manage.analysis.card.userStructure": "User Structure",
  "pages.business.manage.analysis.card.userStructureMix":
    "User Structure (New / Existing)",
  "pages.business.manage.analysis.card.newRateLabel": "New: {count} ({rate})",
  "pages.business.manage.analysis.card.oldRateLabel":
    "Existing: {count} ({rate})",
  "pages.business.manage.analysis.card.userStructureDesc":
    "New users {newRate}, existing users {oldRate}",
  "pages.business.manage.analysis.section.dailyTrend": "Daily Trend",
  "pages.business.manage.analysis.section.funnel":
    "Designed Consumption & Conversion Funnel",
  "pages.business.manage.analysis.section.funnelDescription":
    "Merchant-exclusive process control efficiency at every stage",
  "pages.business.manage.analysis.section.details": "Core Metrics",
  "pages.business.manage.analysis.reportList.title":
    "Activity Data Reconciliation",
  "pages.business.manage.analysis.reportList.description":
    "Current view: detailed statistics by calendar date. Single-merchant activities directly show overall and conversion reconciliation data.",
  "pages.business.manage.analysis.reportList.total": "{total} items",
  "pages.business.manage.analysis.reportList.date": "Date",
  "pages.business.manage.analysis.reportList.totalBetUsers": "Total Bet Users",
  "pages.business.manage.analysis.reportList.dailyPayout":
    "Daily Prize Pool Spend",
  "pages.business.manage.analysis.reportList.cumulativePayout":
    "Cumulative Prize Pool Spend",
  "pages.business.manage.analysis.reportList.qualifiedUsers": "Triggered Users",
  "pages.business.manage.analysis.reportList.triggerRate": "Trigger Rate",
  "pages.business.manage.analysis.reportList.participantUsers": "SPIN Users",
  "pages.business.manage.analysis.reportList.activityConversionRate":
    "Activity Conversion",
  "pages.business.manage.analysis.reportList.freeSpinCount":
    "Total FREESPIN Count",
  "pages.business.manage.analysis.table.date": "Date",
  "pages.business.manage.analysis.table.dayNo": "Day No.",
  "pages.business.manage.analysis.table.totalBetUsers": "Bet Users",
  "pages.business.manage.analysis.table.qualifiedUsers": "Qualified Users",
  "pages.business.manage.analysis.table.participantUsers":
    "Daily Unique Participants (Users)",
  "pages.business.manage.analysis.table.freeSpinCount": "FreeSpin Count",
  "pages.business.manage.analysis.table.dailyPayout":
    "Daily Prize Pool Consumption ($)",
  "pages.business.manage.analysis.table.cumulativePayout": "Cumulative Payout",
  "pages.business.manage.analysis.table.triggerRate": "Trigger Rate",
  "pages.business.manage.analysis.table.activityConversionRate":
    "Activity Conversion Rate",
  "pages.business.manage.analysis.detail.totalBetUsers":
    "Paid Bet Users During Activity",
  "pages.business.manage.analysis.detail.qualifiedUsers": "Qualified Users",
  "pages.business.manage.analysis.detail.participantUsers":
    "Actual Participant Users",
  "pages.business.manage.analysis.detail.claimRate": "Claim Rate",
  "pages.business.manage.analysis.detail.usageRate": "Usage Rate",
  "pages.business.manage.analysis.detail.poolProgress": "Pool Usage Rate",
  "pages.business.manage.analysis.funnel.qualifiedUsers": "Qualified Users",
  "pages.business.manage.analysis.funnel.claimedUsers": "Claimed Users",
  "pages.business.manage.analysis.funnel.participantUsers":
    "FreeSpin Participant Users",
  "pages.business.manage.analysis.funnel.usedUsers":
    "Users with FreeSpin Orders",
  "pages.business.manage.analysis.funnel.stage1":
    "Stage 1: Trigger Threshold and Activate",
  "pages.business.manage.analysis.funnel.stage2":
    "Stage 2: Actual FreeSpin Participants",
  "pages.business.manage.analysis.funnel.stage3":
    "Stage 3: Users with Second-Bet Conversion",
  "pages.business.manage.analysis.funnel.baseTag": "Base",
  "pages.business.manage.analysis.insight.highActivation":
    "Participation conversion is strong, indicating the current activity setup is attractive to target users.",
  "pages.business.manage.analysis.insight.highPoolUsage":
    "Prize pool consumption is already high. It is worth watching both budget usage and follow-up payout rhythm.",
  "pages.business.manage.analysis.insight.default":
    "Use the daily trend and funnel conversion together to keep tracking trigger and usage efficiency.",
  "pages.business.manage.analysis.unit.users": "users",
  "pages.business.manage.analysis.unit.newUsers": "new",
  "pages.business.manage.sevenAnalysis.section.stages":
    "D1 ~ D7 Stage Pool Burn Control",
  "pages.business.manage.sevenAnalysis.section.stagesDescription":
    "Displays budget usage, thresholds, and reward setup for each stage.",
  "pages.business.manage.sevenAnalysis.section.stagesOverBudget":
    "Stage pool overflow protection triggered",
  "pages.business.manage.sevenAnalysis.stage.day": "D{day}",
  "pages.business.manage.sevenAnalysis.stage.threshold": "Threshold",
  "pages.business.manage.sevenAnalysis.stage.reward": "Reward",
  "pages.business.manage.sevenAnalysis.chart.title":
    "D1 ~ D7 Progressive Trigger & Consumption Trend",
  "pages.business.manage.sevenAnalysis.chart.description":
    "Shows the prize pool payout and active participant trend across each stage.",
  "pages.business.manage.sevenAnalysis.chart.dailyPayout": "Stage Payout ($)",
  "pages.business.manage.sevenAnalysis.chart.participantUsers": "Reached Users",
  "pages.business.manage.sevenAnalysis.chart.leftAxisTitle":
    "Tiered Payout ($)",
  "pages.business.manage.sevenAnalysis.chart.rightAxisTitle": "Qualified Users",
  "pages.business.manage.sevenAnalysis.card.d7RetentionRate":
    "D7 Retention Rate",
  "pages.business.manage.sevenAnalysis.card.d7RetentionDesc":
    "D1 qualified: {d1} | D7 qualified: {d7}",
  "pages.business.manage.sevenAnalysis.card.averageActiveDays":
    "Avg Active Qualified Days",
  "pages.business.manage.sevenAnalysis.card.averageActiveDaysDesc":
    "Reflects how sticky users remain across consecutive stages.",
  "pages.business.manage.sevenAnalysis.section.retention":
    "Sequence: Progressive Retention Decay (D1 ~ D7)",
  "pages.business.manage.sevenAnalysis.section.retentionDescription":
    "Shows how many users successfully reach each subsequent day threshold and the sequential decay structure.",
  "pages.business.manage.sevenAnalysis.retention.dayQualified":
    "D{day} Qualified Users",
  "pages.business.manage.sevenAnalysis.retention.insight":
    "Current D6 has {d6} users and D7 has {d7} users. It is worth checking whether the last two stages still have enough reward pull.",
  "pages.business.manage.sevenAnalysis.section.conversion":
    "Behavior: User Conversion Funnel",
  "pages.business.manage.sevenAnalysis.section.conversionDescription":
    "Shows conversion efficiency across the qualify → claim → consume pipeline.",
  "pages.business.manage.sevenAnalysis.funnel.achieved":
    "Stage 1: Reached Threshold (Achieved)",
  "pages.business.manage.sevenAnalysis.funnel.claimed":
    "Stage 2: Claimed FreeSpin (Get)",
  "pages.business.manage.sevenAnalysis.funnel.used":
    "Stage 3: Consumed FreeSpin (Used)",
  "pages.business.manage.sevenAnalysis.funnel.claimRateLabel": "Claim Rate",
  "pages.business.manage.sevenAnalysis.funnel.usageRateLabel": "Usage Rate",
  "pages.business.manage.sevenAnalysis.funnel.selector.overall":
    "Overall Activity Cumulative",
  "pages.business.manage.sevenAnalysis.funnel.selector.day": "D{day} Stage",
  "pages.business.manage.sevenAnalysis.insight.lowRetention":
    "Trend alert: D7 retention is only {rate}. Recheck the later-stage thresholds and budget setup.",
  "pages.business.manage.sevenAnalysis.insight.highConsumption":
    "Trend insight: total prize pool usage has reached {rate}. Keep watching the payout rhythm of later stages.",
  "pages.business.manage.sevenAnalysis.insight.healthyRetention":
    "Trend insight: D7 retention is currently {rate}, and the stage carry-over looks relatively stable.",
  "pages.business.manage.sevenAnalysis.conversionAdvice":
    "Operational tip: claim conversion is solid ({claimRate}) and usage rate is excellent ({usageRate}). Consider nudging users whose spins are about to expire.",
  "pages.business.manage.sevenAnalysis.unit.days": "days",
  "pages.business.manage.sevenAnalysis.matrix.title":
    "Activity Data Reconciliation Ledger (D1-D7 Daily Cross Matrix)",
  "pages.business.manage.sevenAnalysis.matrix.description":
    "With backend event tracking, visually present multi-dimensional flow reconciliation for each stage and calendar date.",
  "pages.business.manage.sevenAnalysis.matrix.hint":
    "This grid has D1-D7 stages on the horizontal axis and calendar dates on the vertical axis. Each cell contains 5 dimensions of detailed data (daily payout, cumulative payout, qualified users, spin users, spin count). Since players register and progress on different days, this matrix accurately reconstructs the instantaneous burn ledger for each stage on each day.",
  "pages.business.manage.sevenAnalysis.matrix.colDailyPayout": "Daily Payout",
  "pages.business.manage.sevenAnalysis.matrix.colCumulativePayout":
    "Cumul. Payout",
  "pages.business.manage.sevenAnalysis.matrix.colQualifiedUsers": "Qualified",
  "pages.business.manage.sevenAnalysis.matrix.colParticipantUsers":
    "Spin Users",
  "pages.business.manage.sevenAnalysis.matrix.colFreeSpinCount": "Spin Count",
  "pages.business.manage.sevenAnalysis.matrix.calendarDate": "Calendar Date",
  "pages.business.manage.sevenAnalysis.matrix.emptyCell": "—",
  "pages.business.manage.sevenAnalysis.tooltip.poolConsumed":
    "The total value of free spins already claimed by all players during the activity period",
  "pages.business.manage.sevenAnalysis.tooltip.participantsUv":
    "Penetration rate = Number of players who met the threshold and actually used free spins / conversion rate relative to qualified users",
  "pages.business.manage.sevenAnalysis.tooltip.freeSpinPv":
    "Total cumulative FreeSpin spins consumed by all players during the activity, i.e., average spins per user",
  "pages.business.manage.sevenAnalysis.tooltip.userStructure":
    "Distribution of new users (first bet on platform during the activity) vs. returning users (already bet before the activity) among participating players",
  "pages.business.manage.sevenAnalysis.tooltip.d7Retention":
    "The percentage of players who met the D1 threshold and consistently continued through to meet the final D7 threshold.",
  "pages.business.manage.sevenAnalysis.tooltip.averageActiveDays":
    "Average number of consecutive threshold-meeting days for players in the D1-D7 tiered FreeSpin activity",
  "pages.business.manage.sevenAnalysis.tooltip.freeSpinPayout":
    "Total amount returned to players when they use the gifted FreeSpin for spins",
  "pages.business.manage.sevenAnalysis.tooltip.merchantNet":
    "The merchant's final net profit after deducting free spin payout from GGR (bet amount - return amount). Net profit = (bet amount - return amount) - (free spin payout)",
  "pages.business.manage.sevenAnalysis.card.poolConsumed":
    "7-Day Total Pool Consumption",
  "pages.business.manage.drawer.title.add": "New Accumulated Freespin",
  "pages.business.manage.drawer.title.edit": "Edit Accumulated Freespin",
  "pages.business.manage.seven.drawer.title.add": "New 7-Day FreeSpin",
  "pages.business.manage.seven.drawer.title.edit": "Edit 7-Day FreeSpin",
  "pages.business.manage.drawer.placeholder.name": "Enter activity name",
  "pages.business.manage.drawer.placeholder.game": "Select game",
  "pages.business.manage.drawer.placeholder.appids": "Select merchants",
  "pages.business.manage.drawer.activityTime": "Activity Time",
  "pages.business.manage.drawer.totalEndTime": "Draw End Time",
  "pages.business.manage.drawer.beijingTimeDesc":
    "Beijing Time (UTC+8) is currently used",
  "pages.business.manage.drawer.saveDraft": "Save Draft",
  "pages.business.manage.drawer.saveAndPublish": "Save & Publish",
  "pages.business.manage.drawer.tooltip.betAmount":
    "The cumulative minimum bet amount required to participate in FreeSpin activities",
  "pages.business.manage.drawer.tooltip.freeSpinCount":
    "The number of free spins awarded by the FreeSpin activity",
  "pages.business.manage.drawer.tooltip.freeSpinBet":
    "The bet tier value for free spins",
  "pages.business.manage.drawer.message.missingId":
    "Activity ID missing, cannot submit",
  "pages.business.manage.drawer.message.numberRequired":
    "Please enter a number",
  "pages.business.manage.drawer.message.activityEndAfterStart":
    "End time must be later than start time",
  "pages.business.manage.drawer.message.getEndAfterGetStart":
    "Claim end time must be later than claim start time",
  "pages.business.manage.drawer.message.useStartAfterGetStart":
    "Use start time must be later than claim start time",
  "pages.business.manage.drawer.message.useEndAfterGetStart":
    "Use end time must be later than claim start time",
  "pages.business.manage.modal.delete.title": "Confirm Delete?",
  "pages.business.manage.modal.delete.content":
    "Are you sure you want to delete this activity?",
  "pages.business.manage.modal.publish.content":
    "Confirm to publish this activity?",
  "pages.business.manage.modal.up.title": "Submit Publish Request",
  "pages.business.manage.modal.up.content":
    "Are you sure you want to submit a publish request for this activity?",
  "pages.business.manage.modal.down.title": "Submit Off-Shelf Request",
  "pages.business.manage.modal.down.content":
    "Are you sure you want to submit an off-shelf request for this activity?",
  "pages.business.manage.message.deleteBlockedReviewing":
    "Activity under review cannot be deleted",
  "pages.business.manage.message.deleteBlockedEnabled":
    "Published or In-progress activity cannot be deleted",
  "pages.business.manage.message.editBlockedReviewing":
    "Activity under review cannot be edited",
  "pages.business.manage.message.editBlockedOnShelf":
    "Published activity cannot be edited",
  "pages.business.manage.message.editBlockedExpired":
    "Expired activity cannot be edited",
  "pages.business.manage.message.deleteBlockedExpired":
    "Expired activity cannot be deleted",
  "pages.business.manage.message.downBlockedReviewing":
    "Activity under review cannot be taken down",
  "pages.business.manage.message.deleteSuccess": "Deleted successfully",
  "pages.business.manage.message.upSubmitSuccess": "Publish request submitted",
  "pages.business.manage.message.downSubmitSuccess":
    "Off-shelf request submitted",
  "pages.business.manage.message.publishSuccess": "Published successfully",

  // Activity Status
  "pages.business.manage.activityStatus.pendingStart": "Not Started",
  "pages.business.manage.activityStatus.inProgress": "In Progress",
  "pages.business.manage.activityStatus.expired": "Expired",
  "pages.business.manage.activityStatus.offShelf": "Off Shelf",

  // Activity Approval Status
  "pages.business.manage.activityApprovalStatus.pendingPublish":
    "Pending Publish",
  "pages.business.manage.activityApprovalStatus.underReview": "Under Review",
  "pages.business.manage.activityApprovalStatus.published": "Published",
  "pages.business.manage.activityApprovalStatus.rejected": "Rejected",

  // Review Center - My Requests
  "pages.reviewCenter.my.list.title": "My Requests",
  "pages.reviewCenter.my.filter.createdAt": "Submitted",
  "pages.reviewCenter.my.filter.status": "Review Status",
  "pages.reviewCenter.my.filter.status.placeholder": "Select status",
  "pages.reviewCenter.my.column.id": "Ticket",
  "pages.reviewCenter.my.column.applyType": "Action",
  "pages.reviewCenter.my.column.applicant": "Applicant",
  "pages.reviewCenter.my.column.associatedObject": "Associated Object",
  "pages.reviewCenter.my.column.status": "Status",
  "pages.reviewCenter.my.column.handlerName": "Handler",
  "pages.reviewCenter.my.column.createdAt": "Submitted",
  "pages.reviewCenter.my.status.pending": "Pending",
  "pages.reviewCenter.my.status.approved": "Approved",
  "pages.reviewCenter.my.status.rejected": "Rejected",
  "pages.reviewCenter.my.action.detail": "Detail",
  "pages.reviewCenter.my.action.detail.placeholder":
    "Detail is not available yet, placeholder entry only",
  "pages.reviewCenter.my.message.listFailed": "Failed to load review list",
  "pages.reviewCenter.my.value.unknownApplyType": "Unknown review type",
  "pages.reviewCenter.my.empty": "No review data",

  // Review Center - Pending My Approval
  "pages.reviewCenter.pending.list.title": "Pending Approvals",
  "pages.reviewCenter.pending.filter.all": "All",
  "pages.reviewCenter.pending.filter.createdAt": "Submitted",
  "pages.reviewCenter.pending.filter.applicant": "Applicant",
  "pages.reviewCenter.pending.filter.applicant.placeholder": "Select applicant",
  "pages.reviewCenter.pending.filter.applyType": "Application Type",
  "pages.reviewCenter.pending.filter.applyType.placeholder":
    "Select application type",
  "pages.reviewCenter.pending.filter.status": "Review Status",
  "pages.reviewCenter.pending.filter.status.placeholder": "Select status",
  "pages.reviewCenter.pending.column.id": "Ticket",
  "pages.reviewCenter.pending.column.applicant": "Applicant",
  "pages.reviewCenter.pending.column.adminId": "Applicant",
  "pages.reviewCenter.pending.column.adminName": "Applicant Name",
  "pages.reviewCenter.pending.column.applyType": "Application Type",
  "pages.reviewCenter.pending.column.associatedObject": "Associated Object",
  "pages.reviewCenter.pending.column.status": "Status",
  "pages.reviewCenter.pending.column.handlerName": "Handler",
  "pages.reviewCenter.pending.column.createdAt": "Submitted",
  "pages.reviewCenter.pending.message.listFailed":
    "Failed to load pending list",
  "pages.reviewCenter.pending.message.reviewActionPlaceholder":
    "Approve/Reject has not been integrated yet",
  "pages.reviewCenter.pending.message.approveMissingId":
    "Missing ticket ID, unable to approve",
  "pages.reviewCenter.pending.message.approveSuccess": "Approved",
  "pages.reviewCenter.pending.message.approveFailed": "Approval failed",
  "pages.reviewCenter.pending.message.rejectMissingId":
    "Missing ticket ID, unable to reject",
  "pages.reviewCenter.pending.message.rejectSuccess": "Rejected",
  "pages.reviewCenter.pending.message.rejectFailed": "Rejection failed",
  "pages.reviewCenter.pending.message.reviewCommentsRequired":
    "Please enter review comments",
  "pages.reviewCenter.pending.value.unknownApplicant": "Unknown applicant",
  "pages.reviewCenter.pending.value.unknownApplyType":
    "Unknown application type",
  "pages.reviewCenter.pending.empty": "No pending data",
  "pages.reviewCenter.pending.approve.title": "Approve Request",
  "pages.reviewCenter.pending.approve.alert.title": "Confirm Approval",
  "pages.reviewCenter.pending.approve.alert.description":
    "You are processing the {applyType} request for ticket {id}.",
  "pages.reviewCenter.pending.reject.alert.description":
    "You are processing the {applyType} request for ticket {id}.",
  "pages.reviewCenter.pending.approve.form.reviewComments": "Review Comments",
  "pages.reviewCenter.pending.approve.form.reviewComments.placeholder":
    "Enter approval reason (optional)",
  "pages.reviewCenter.pending.approve.form.reviewComments.help":
    "Review comments are optional and will be passed as reviewComments upon submission.",

  // Review Center - Modal
  "pages.reviewCenter.modal.title.detail": "Review Detail",
  "pages.reviewCenter.modal.action.close": "Close",
  "pages.reviewCenter.modal.action.cancel": "Cancel",
  "pages.reviewCenter.modal.action.reject": "Reject",
  "pages.reviewCenter.modal.action.approve": "Approve",
  "pages.reviewCenter.modal.reviewComments": "Review Comments",
  "pages.reviewCenter.modal.reviewComments.placeholder":
    "Please enter review comments (required)",
  "pages.reviewCenter.modal.feedback.title": "Review Feedback",
  "pages.reviewCenter.modal.feedback.operator": "Handler: ",
  "pages.reviewCenter.modal.feedback.operatedAt": "Handled at: ",

  // Review Center - RTP
  "pages.reviewCenter.rtp.meta.id": "Ticket",
  "pages.reviewCenter.rtp.meta.applyType": "Action",
  "pages.reviewCenter.rtp.meta.applicant": "Applicant",
  "pages.reviewCenter.rtp.meta.applicantName": "Applicant Name",
  "pages.reviewCenter.rtp.meta.associatedObject": "Associated Object",
  "pages.reviewCenter.rtp.meta.createdAt": "Submitted",
  "pages.reviewCenter.rtp.meta.status": "Status",
  "pages.reviewCenter.whitelist.name": "User Whitelist",
  "pages.reviewCenter.whitelist.operation.enable": "Enable Whitelist",
  "pages.reviewCenter.whitelist.operation.disable": "Disable Whitelist",
  "pages.reviewCenter.whitelist.operation.create": "Create Whitelist",
  "pages.reviewCenter.whitelist.listOperation.enable": "Enable Whitelist",
  "pages.reviewCenter.whitelist.listOperation.disable": "Disable Whitelist",
  "pages.reviewCenter.whitelist.listOperation.create": "Create Whitelist",
  "pages.reviewCenter.whitelist.field.operation": "Operation",
  "pages.reviewCenter.whitelist.field.ids": "Whitelist Record IDs",
  "pages.reviewCenter.whitelist.field.roleIds": "User IDs",
  "pages.reviewCenter.whitelist.field.appid": "Application Merchant",
  "pages.reviewCenter.whitelist.field.useScene": "Usage Scenario",
  "pages.reviewCenter.whitelist.field.remark": "Remark",
  "pages.reviewCenter.rtp.compare.title": "Config Comparison",
  "pages.reviewCenter.rtp.compare.before": "Before",
  "pages.reviewCenter.rtp.compare.after": "After",
  "pages.reviewCenter.rtp.compare.empty": "No comparison data",
  "pages.reviewCenter.activity.field.activityType": "Activity Type",
  "pages.reviewCenter.activity.field.submitConfig": "Submit Config",
  "pages.reviewCenter.activity.field.plannedEndTime": "Planned End Time",
  "pages.reviewCenter.activity.offShelf.sectionTitle": "Changes and Data",
  "pages.reviewCenter.activity.offShelf.sectionDesc":
    "Request early takedown of this activity due to strategy adjustment.",
  "pages.reviewCenter.activity.offShelf.compareTitle":
    "Takedown Activity - Before/After Comparison",
  "pages.reviewCenter.activity.offShelf.status.onShelfRunning":
    "Running (On Shelf)",
  "pages.reviewCenter.activity.offShelf.status.forceOffShelf":
    "Force Takedown (Off Shelf)",
  "pages.reviewCenter.activity.offShelf.status.offShelfDone": "Off Shelf",
  "pages.reviewCenter.rtp.field.name": "Name",
  "pages.reviewCenter.rtp.field.gameId": "Game ID",
  "pages.reviewCenter.rtp.field.configName": "Config File",
  "pages.reviewCenter.rtp.field.configVersion": "Config Version",
  "pages.reviewCenter.rtp.field.configPath": "Config Path",
  "pages.reviewCenter.rtp.field.gameBinPath": "Runner Program",
  "pages.reviewCenter.rtp.field.gameDependencyZipPath": "Dependency Package",
  "pages.reviewCenter.rtp.field.otherParams": "Additional Params",
  "pages.reviewCenter.rtp.field.rtp": "RTP",
  "pages.reviewCenter.rtp.field.runResult": "Run Result",
  "pages.reviewCenter.rtp.runResult.snapshot": "Historical Results",
  "pages.reviewCenter.rtp.runResult.snapshotEmpty": "No historical run results",
  "pages.reviewCenter.rtp.runResult.current": "Current Run Result",
  "pages.reviewCenter.rtp.runResult.currentEmpty":
    "Run verification above to display current result here",
  "pages.reviewCenter.rtp.runCheck.disabled":
    "Missing config path or runner program, unable to run verification",
  "pages.reviewCenter.bet.level.default": "Default",
  "pages.reviewCenter.bet.compare.emptyCurrencyLevels":
    "No currency level config",
  "pages.reviewCenter.gameBet.meta.operatorName": "Merchant",
  "pages.reviewCenter.gameBet.meta.appid": "AppID",
  "pages.reviewCenter.gameBet.meta.gameName": "Game Name",
  "pages.reviewCenter.gameBet.compare.title": "Changes and Data",
  "pages.reviewCenter.gameBet.compare.summaryLabel": "Summary",
  "pages.reviewCenter.gameBet.compare.summary":
    "Change merchant game bet level template from {before} to {after}.",
  "pages.reviewCenter.gameBet.field.betLevelName": "Bet Level Template",
  "pages.reviewCenter.gameRtp.compare.title": "Changes and Data",
  "pages.reviewCenter.gameRtp.compare.summaryLabel": "Summary",
  "pages.reviewCenter.gameRtp.compare.summary":
    "Adjust game RTP probability tier weight configuration.",
  "pages.reviewCenter.gameRtp.compare.loading": "Loading RTP tier info",
  "pages.reviewCenter.gameRtp.field.tierWithValue": "Tier {value}",
  "pages.reviewCenter.gameRtp.field.tierFallback": "Config ID {id}",
  "pages.reviewCenter.gameRtp.field.tier.high": "High",
  "pages.reviewCenter.gameRtp.field.tier.medium": "Medium",
  "pages.reviewCenter.gameRtp.field.tier.low": "Low",
  "pages.reviewCenter.gameRtp.field.rtpMathVersion": "Version",
  "pages.reviewCenter.gameRtp.field.overallRtp": "Overall RTP",
  "pages.reviewCenter.newPlayer.compare.title": "Changes and Data",
  "pages.reviewCenter.newPlayer.compare.summaryLabel": "Summary",
  "pages.reviewCenter.newPlayer.compare.summary":
    "Configure new player protection pool accumulation and forced exit conditions.",
  "pages.reviewCenter.risk.compare.title": "Changes and Data",
  "pages.reviewCenter.risk.compare.summaryLabel": "Summary",
  "pages.reviewCenter.risk.compare.summary":
    "Tighten max payout and single bet risk amounts across all mini-games and globally.",
  "pages.reviewCenter.compensateFreeSpin.field.timeRange": "Activity Time",
  "pages.reviewCenter.compensateFreeSpin.field.totalEndTime":
    "Activity Draw End Time",
  "pages.common.close": "Close",
  "pages.gameVerification.list.title": "Game Verification Program List",
  "pages.gameVerification.action.add": "Add Program",
  "pages.gameVerification.action.update": "Update",
  "pages.gameVerification.action.history": "History",
  "pages.gameVerification.filter.searchGame": "Search Game",
  "pages.gameVerification.filter.searchGame.placeholder": "Name/ID",
  "pages.gameVerification.column.game": "Game",
  "pages.gameVerification.column.gameVersion": "Current Version",
  "pages.gameVerification.column.fileName": "Program File",
  "pages.gameVerification.column.updatedAt": "Last Updated",
  "pages.gameVerification.column.nickName": "Operator",
  "pages.gameVerification.column.action": "Action",
  "pages.gameVerification.drawer.add.title": "Upload Verification Program",
  "pages.gameVerification.drawer.update.title": "Update Verification Program",
  "pages.gameVerification.drawer.gameId": "Game",
  "pages.gameVerification.drawer.gameId.required": "Please select a game",
  "pages.gameVerification.drawer.gameVersion": "Version",
  "pages.gameVerification.drawer.gameVersion.required": "Please enter version",
  "pages.gameVerification.drawer.gameVersion.placeholder": "e.g. v3.4.3",
  "pages.gameVerification.drawer.gameVersion.selectGameFirst":
    "Please select a game first",
  "pages.gameVerification.drawer.binPath": "Program File",
  "pages.gameVerification.drawer.binPath.required":
    "Please upload program file",
  "pages.gameVerification.drawer.dependencyZipPath": "Dependency Package",
  "pages.gameVerification.drawer.dependencyZipPath.desc":
    "Some game verification runs require uploading related dependency packages. Contact the relevant developers if needed. The dependency package should include all dependency files/folders in the verification program directory, packaged as a zip file and uploaded.",
  "pages.gameVerification.upload.placeholder": "Add file",
  "pages.gameVerification.drawer.updateDesc": "Update Description",
  "pages.gameVerification.drawer.add.submit": "Confirm Upload",
  "pages.gameVerification.drawer.update.submit": "Confirm Update",
  "pages.gameVerification.drawer.add.success": "Added successfully",
  "pages.gameVerification.drawer.update.success": "Updated successfully",
  "pages.gameVerification.history.title": "Version History - {gameName}",
  "pages.gameVerification.history.version": "Version",
  "pages.gameVerification.history.updateDesc": "Version Description",
  "pages.gameVerification.history.updatedAt": "Updated At",
  "pages.gameVerification.history.nickName": "Operator",
  "pages.gameVerification.history.action": "Action",
  "pages.gameVerification.history.download": "Download Program",
  "pages.gameVerification.history.downloadDependency": "Download Dependency",
  "pages.gameVerification.history.latest": "Latest",

  // Common
  "pages.common.edit": "Edit",

  // Review Center
  "pages.reviewCenter.my.placeholder": "My review list feature coming soon",

  // Country Area Analysis
  "pages.user_analysis.country_area.table.title": "Detailed Data Table",

  // Activity Management - Approval Status (Merchant FreeSpin)
  "pages.business.manage.approvalStatus.pendingSubmit": "Pending Submit",
  "pages.business.manage.approvalStatus.onShelfReview": "On-Shelf Review",
  "pages.business.manage.approvalStatus.onShelfRejected": "On-Shelf Rejected",
  "pages.business.manage.approvalStatus.onShelf": "Published",
  "pages.business.manage.approvalStatus.offShelfReview": "Off-Shelf Review",
  "pages.business.manage.approvalStatus.offShelfRejected": "Off-Shelf Rejected",
  "pages.business.manage.approvalStatus.offShelf": "Off Shelf",

  // Activity Management - Approval Status (7-Day FreeSpin)
  "pages.business.manage.seven.approvalStatus.pendingSubmit": "Pending Submit",
  "pages.business.manage.seven.approvalStatus.onShelfReview": "On-Shelf Review",
  "pages.business.manage.seven.approvalStatus.onShelfRejected":
    "On-Shelf Rejected",
  "pages.business.manage.seven.approvalStatus.onShelf": "On Shelf",
  "pages.business.manage.seven.approvalStatus.offShelfReview":
    "Off-Shelf Review",
  "pages.business.manage.seven.approvalStatus.offShelfRejected":
    "Off-Shelf Rejected",
  "pages.business.manage.seven.approvalStatus.offShelf": "Off Shelf",
  "pages.business.manage.seven.filter.approvalStatus.pendingPublish":
    "Pending Publish",
  "pages.business.manage.seven.filter.approvalStatus.underReview":
    "Under Review",
  "pages.business.manage.seven.filter.approvalStatus.published": "Published",
  "pages.business.manage.seven.filter.approvalStatus.rejected": "Rejected",

  // Currency Config
  "pages.config.currency.code": "Currency Code",
  "pages.config.currency.code.placeholder": "Please enter currency code",
  "pages.config.currency.name": "Currency Name",
  "pages.config.currency.symbol": "Currency Symbol",
  "pages.config.currency.currencyMult": "Currency Multiplier",
  "pages.config.currency.currencyMult.required":
    "Please enter currency multiplier",
  "pages.config.currency.currencyMult.extra":
    "Coefficient to amplify or reduce amounts based on exchange rate, used to adjust player or platform earnings",
  "pages.config.currency.currencyMult.tooltip":
    "Coefficient to amplify or reduce amounts based on exchange rate, used to adjust player or platform earnings",
  "pages.config.currency.fixedExchangeRate": "Fixed Exchange Rate",
  "pages.config.currency.fixedExchangeRate.required":
    "Please enter fixed exchange rate",
  "pages.config.currency.fixedExchangeRate.extra":
    "Fixed USD conversion ratio set by the platform, unaffected by market changes, used for stable settlement",
  "pages.config.currency.fixedExchangeRate.tooltip":
    "Fixed USD conversion ratio set by the platform, unaffected by market changes, used for stable settlement",
  "pages.config.currency.realExchangeRate": "Real-Time Exchange Rate",
  "pages.config.currency.realExchangeRate.tooltip":
    "Rate automatically converted at current market USD exchange rate, fluctuates with market changes",
  "pages.config.currency.status": "Status",
  "pages.config.currency.createdAt": "Created Time",
  "pages.config.currency.lastUpdatedAt": "Real-Time Exchange Rate Last Updated",
  "pages.config.currency.refresh.button": "Refresh Rate",
  "pages.config.currency.refresh.tooltip":
    "Click to refresh real-time exchange rate",
  "pages.config.currency.refresh.success":
    "Exchange rate refreshed successfully",
  "pages.config.currency.refresh.failed": "Exchange rate refresh failed",
  "pages.config.currency.edit.title": "Edit Currency",
  "pages.config.currency.edit.message.success": "Update successful",
  "pages.config.currency.edit.message.failed": "Update failed",
  "pages.config.currency.edit.message.noId": "Currency ID does not exist",
  "pages.config.currency.status.success": "Status updated successfully",
  "pages.config.currency.status.failed": "Status update failed",
  "pages.config.currency.status.noId": "Currency ID does not exist",

  // Bet Level Config
  "pages.config.bet.filter.createdAt": "Created Time",
  "pages.config.bet.filter.keywords": "ID/Name",
  "pages.config.bet.filter.keywords.placeholder":
    "Please enter ID or bet level plan name",
  "pages.config.bet.filter.reviewStatus": "Review Status",
  "pages.config.bet.column.name": "Bet Level Plan Name",
  "pages.config.bet.column.currencys": "Configured Currencies",
  "pages.config.bet.column.sort": "Sort",
  "pages.config.bet.column.createdAt": "Created Time",
  "pages.config.bet.column.levelCount": "Level Count",
  "pages.config.bet.column.minLevel": "Min Level Value",
  "pages.config.bet.column.maxLevel": "Max Level Value",
  "pages.config.bet.column.usedMerchantCount": "Merchants Using",
  "pages.config.bet.column.usedGameCount": "Games Using",
  "pages.config.bet.column.reviewStatus": "Review Status",
  "pages.config.bet.column.status": "Enable/Disable",
  "pages.config.bet.reviewStatus.pendingRelease": "Pending Publish",
  "pages.config.bet.reviewStatus.underReview": "Under Review",
  "pages.config.bet.reviewStatus.published": "Published",
  "pages.config.bet.reviewStatus.rejected": "Rejected",
  "pages.config.bet.status.enabled": "Enabled",
  "pages.config.bet.status.disabled": "Disabled",
  "pages.config.bet.action.batchEnable": "Batch Enable",
  "pages.config.bet.action.batchDisable": "Batch Disable",
  "pages.config.bet.action.add": "Add Bet Level",
  "pages.config.bet.action.detail": "Detail",
  "pages.config.bet.action.edit": "Edit",
  "pages.config.bet.action.copy": "Copy",
  "pages.config.bet.action.delete": "Delete",
  "pages.config.bet.action.publish": "Publish",
  "pages.config.bet.drawer.title.create": "Add Bet Level",
  "pages.config.bet.drawer.title.detail": "Bet Level Detail",
  "pages.config.bet.drawer.title.edit": "Edit Bet Level",
  "pages.config.bet.drawer.action.saveDraft": "Save Draft",
  "pages.config.bet.drawer.action.saveAndPublish": "Save and Publish",
  "pages.config.bet.drawer.section.currency": "Configured Currencies",
  "pages.config.bet.drawer.section.level": "Level Value Details",
  "pages.config.bet.drawer.form.name": "Bet Level Name",
  "pages.config.bet.drawer.form.name.placeholder":
    "Please enter bet level name",
  "pages.config.bet.drawer.form.name.required": "Please enter bet level name",
  "pages.config.bet.drawer.form.sort": "Bet Level Sort",
  "pages.config.bet.drawer.form.sort.placeholder": "Please enter sort order",
  "pages.config.bet.drawer.form.sort.required": "Please enter sort order",
  "pages.config.bet.drawer.form.status": "Enable",
  "pages.config.bet.drawer.currency.add": "Add New Currency",
  "pages.config.bet.drawer.currency.empty": "Please add currency first",
  "pages.config.bet.drawer.currency.search": "Search currency",
  "pages.config.bet.drawer.currency.usdRequired":
    "USD currency is mandatory and cannot be deleted",
  "pages.config.bet.drawer.table.currency": "Currency",
  "pages.config.bet.drawer.table.levelColumn": "Level {index}",
  "pages.config.bet.drawer.level.add": "Add Level Item",
  "pages.config.bet.drawer.level.column.level": "Level Value",
  "pages.config.bet.drawer.level.column.sort": "Level Sort",
  "pages.config.bet.drawer.level.column.default": "Default Level",
  "pages.config.bet.drawer.level.input.level": "Enter Amount",
  "pages.config.bet.drawer.level.input.sort": "Sort",
  "pages.config.bet.drawer.level.required":
    "Please complete level values and sort under {currency} currency",
  "pages.config.bet.drawer.level.greaterThanZero":
    "Level value must be greater than 0",
  "pages.config.bet.drawer.level.atLeastOne":
    "At least one level value is required under any currency",
  "pages.config.bet.drawer.message.saveDraftSuccess":
    "Bet level draft saved successfully",
  "pages.config.bet.drawer.message.createSuccess":
    "Bet level created successfully",
  "pages.config.bet.drawer.message.updateSuccess":
    "Bet level updated successfully",
  "pages.config.bet.drawer.message.createFailed": "Failed to create bet level",
  "pages.config.bet.drawer.message.updateFailed": "Failed to update bet level",
  "pages.config.bet.message.listFailed": "Failed to load bet level config list",
  "pages.config.bet.message.selectAtLeastOne":
    "Please select at least one published bet level config",
  "pages.config.bet.message.statusUpdateSuccess": "{status} successfully",
  "pages.config.bet.message.statusUpdateFailed": "{status} failed",
  "pages.config.bet.message.statusIdMissing":
    "Bet level config ID does not exist",
  "pages.config.bet.message.publishSuccess": "Config submitted for review",
  "pages.config.bet.message.publishFailed": "Failed to submit for review",
  "pages.config.bet.confirm.publish.title": "Confirm Submit for Review?",
  "pages.config.bet.confirm.publish.content":
    'After submission, this config will enter "Under Review" status and you will not be able to modify/update it during this period.',
  "pages.config.bet.detail.empty": "No currently active bet level details",
  "pages.config.bet.selection.selected": "{count} items selected",
  "pages.config.bet.selection.clear": "Clear selection",
  "pages.config.bet.empty": "No bet level config data",

  // Gift Spin Records
  "pages.business.giftspin.column.userId": "User ID",
  "pages.business.giftspin.column.merchantName": "Merchant Name",
  "pages.business.giftspin.column.activityName": "Activity Name",
  "pages.business.giftspin.column.game": "Game",
  "pages.business.giftspin.column.spinCount": "Spin Count",
  "pages.business.giftspin.column.betLevel": "Bet Level",
  "pages.business.giftspin.column.costEstimate": "Cost Estimate",
  "pages.business.giftspin.column.remark": "Remark",
  "pages.business.giftspin.column.approvalStatus": "Approval Status",
  "pages.business.giftspin.column.executeStatus": "Execute Status",
  "pages.business.giftspin.column.id": "Record ID",
  "pages.business.giftspin.column.operator": "Applicant",
  "pages.business.giftspin.column.operateTime": "Operate Time",
  "pages.business.giftspin.column.createdAt": "Created At",
  "pages.business.giftspin.column.activityTime": "Activity Time",
  "pages.business.giftspin.column.startTime": "Activity Start Time",
  "pages.business.giftspin.column.endTime": "Activity End Time",
  "pages.business.giftspin.column.totalEndTime": "Lottery End Time",
  "pages.business.giftspin.filter.time": "Time Range",
  "pages.business.giftspin.filter.keywords": "User ID",
  "pages.business.giftspin.filter.keywords.placeholder": "Enter User ID",
  "pages.business.giftspin.filter.merchant": "Merchant",
  "pages.business.giftspin.filter.game": "Game",
  "pages.business.giftspin.filter.status": "Approval Status",
  "pages.business.giftspin.action.create": "Grant FreeSpin",
  "pages.business.giftspin.action.confirmGrant": "Confirm Grant",
  "pages.business.giftspin.action.detail": "Detail",
  "pages.business.giftspin.drawer.create.title": "Grant FreeSpin Times",
  "pages.business.giftspin.drawer.detail.title": "Gift Spin Detail",
  "pages.business.giftspin.detail.applicant": "Applicant",
  "pages.business.giftspin.form.game": "Game",
  "pages.business.giftspin.form.game.placeholder": "Please select a game",
  "pages.business.giftspin.form.merchant": "Merchant",
  "pages.business.giftspin.form.merchant.placeholder":
    "Please select a merchant",
  "pages.business.giftspin.form.activityTime": "Activity Start Time",
  "pages.business.giftspin.form.totalEndTime": "Activity Lottery End Time",
  "pages.business.giftspin.form.totalBonus": "Prize Amount",
  "pages.business.giftspin.form.freeSpinCount": "Grant Times",
  "pages.business.giftspin.form.freeSpinCount.suffix": "times",
  "pages.business.giftspin.form.freeSpinBet": "Bet Level",
  "pages.business.giftspin.form.roleIds": "User ID",
  "pages.business.giftspin.form.roleIds.placeholder":
    "Enter user IDs, separate multiple users with commas",
  "pages.business.giftspin.form.roleIds.required": "Please enter user IDs",
  "pages.business.giftspin.form.roleIds.max":
    "A maximum of 1000 user IDs is supported",
  "pages.business.giftspin.form.remark": "Remark",
  "pages.business.giftspin.form.remark.placeholder": "Optional...",
  "pages.business.giftspin.form.message.numberRequired":
    "Please enter a number",
  "pages.business.giftspin.message.grantSuccess": "Grant successful",
  "pages.business.giftspin.message.submitReviewSuccess":
    "Submitted for review successfully",
  "pages.business.giftspin.approvalStatus.pendingPublish": "Pending Publish",
  "pages.business.giftspin.approvalStatus.underReview": "Under Review",
  "pages.business.giftspin.approvalStatus.published": "Published",
  "pages.business.giftspin.approvalStatus.rejected": "Rejected",
  "pages.business.giftspin.executeStatus.unexecuted": "Unexecuted",
  "pages.business.giftspin.executeStatus.executed": "Executed",

  // User whitelist
  "pages.business.whitelist.column.merchantId": "Merchant ID",
  "pages.business.whitelist.column.merchantName": "Merchant Name",
  "pages.business.whitelist.column.agent1": "Level 1 Agent",
  "pages.business.whitelist.column.agent2": "Level 2 Agent",
  "pages.business.whitelist.column.userId": "User ID",
  "pages.business.whitelist.column.validTime": "Valid Time",
  "pages.business.whitelist.column.useScene": "Usage Scenario",
  "pages.business.whitelist.column.status": "Status",
  "pages.business.whitelist.column.operation": "Action",
  "pages.business.whitelist.filter.merchant": "Merchant",
  "pages.business.whitelist.filter.merchantPlaceholder": "Select merchant",
  "pages.business.whitelist.filter.userId": "User ID",
  "pages.business.whitelist.filter.userIdPlaceholder": "Enter user ID",
  "pages.business.whitelist.filter.status": "Status",
  "pages.business.whitelist.filter.statusPlaceholder": "Select status",
  "pages.business.whitelist.filter.enabled": "Enabled",
  "pages.business.whitelist.filter.disabled": "Disabled",
  "pages.business.whitelist.action.edit": "Edit",
  "pages.business.whitelist.action.enable": "Enable",
  "pages.business.whitelist.action.disable": "Disable",
  "pages.business.whitelist.action.add": "Add Whitelist",
  "pages.business.whitelist.action.export": "Export",
  "pages.business.whitelist.action.batchEdit": "Batch Edit",
  "pages.business.whitelist.action.batchEnable": "Batch Enable",
  "pages.business.whitelist.action.batchDisable": "Batch Disable",
  "pages.business.whitelist.action.saveAndEnable": "Save and Enable",
  "pages.business.whitelist.export.filename": "UserWhitelist_",
  "pages.business.whitelist.selection.selected": "{count} selected",
  "pages.business.whitelist.drawer.create.title": "Add Whitelist",
  "pages.business.whitelist.drawer.edit.title": "Edit Whitelist",
  "pages.business.whitelist.drawer.batchEdit.title": "Batch Edit Whitelist",
  "pages.business.whitelist.form.merchant": "Application Merchant",
  "pages.business.whitelist.form.merchantPlaceholder": "Select merchant",
  "pages.business.whitelist.form.effectiveTime": "Effective Time",
  "pages.business.whitelist.form.timezoneHint":
    "Times use Beijing time. Please follow the operating region's local time.",
  "pages.business.whitelist.form.useScene": "Usage Scenario",
  "pages.business.whitelist.form.userId": "User ID",
  "pages.business.whitelist.form.userIdPlaceholder":
    "Enter user IDs separated by commas",
  "pages.business.whitelist.form.userIdRequired": "Enter user ID",
  "pages.business.whitelist.form.selectedRecords": "Selected Records",
  "pages.business.whitelist.form.selectedRecordsValue": "Record IDs: {ids}",
  "pages.business.whitelist.form.remark": "Remark",
  "pages.business.whitelist.form.remarkPlaceholder": "Optional",
  "pages.business.whitelist.message.missingIds":
    "No whitelist records selected for editing",
  "pages.business.whitelist.message.saveSuccess": "Saved successfully",
  "pages.business.whitelist.message.disableSuccess": "Disabled successfully",
  "pages.business.whitelist.message.enableSuccess": "Enabled successfully",
  "pages.business.whitelist.status.disableTitle":
    "Confirm Disable Whitelist User",
  "pages.business.whitelist.status.enableTitle":
    "Confirm Enable Whitelist User",
  "pages.business.whitelist.status.singleDisableDescription":
    "You are disabling the whitelist for user {userId} under merchant {merchant}.",
  "pages.business.whitelist.status.singleEnableDescription":
    "You are enabling the whitelist for user {userId} under merchant {merchant}.",
  "pages.business.whitelist.status.batchDisableDescription":
    "You are disabling {count} selected whitelist users (User IDs: {userIds}).",
  "pages.business.whitelist.status.batchEnableDescription":
    "You are enabling {count} selected whitelist users (User IDs: {userIds}).",
  "pages.business.whitelist.status.disableNotice":
    "After disabling, the user's bets will immediately return to the regular RTP environment and regular order statistics.",
  "pages.business.whitelist.status.enableNotice":
    "After enabling, the user's bets will use the configured whitelist RTP environment.",
  "pages.business.whitelist.status.disableReason": "Disable Reason",
  "pages.business.whitelist.status.enableReason": "Enable Reason",
  "pages.business.whitelist.status.reasonRequired":
    "Enter the operation reason",
  "pages.business.whitelist.status.reasonPlaceholder":
    "Enter the operation reason",
  "pages.business.whitelist.status.notEffective": "Not effective",
  "pages.business.whitelist.status.effective": "Effective",
  "pages.business.whitelist.status.expired": "Expired",
  "pages.business.whitelist.status.disabled": "Disabled",
  "pages.business.whitelist.useScene.live": "Live streaming",
  "pages.business.whitelist.useScene.channel": "Channel promotion",
  "pages.business.whitelist.useScene.internal": "Internal demo",
  "pages.business.whitelist.useScene.other": "Other",
  "pages.business.whitelist.empty": "No whitelist records",
  "pages.business.whitelist.message.operationPending":
    "Business operation API contract is pending",

  "pages.business.whitelistRecord.column.betId": "Bet ID",
  "pages.business.whitelistRecord.column.merchantName": "Merchant Name",
  "pages.business.whitelistRecord.column.merchantId": "Merchant ID",
  "pages.business.whitelistRecord.column.parentOperator": "Direct Parent",
  "pages.business.whitelistRecord.column.operatorPath": "Operator Path",
  "pages.business.whitelistRecord.column.userId": "User ID",
  "pages.business.whitelistRecord.column.gameId": "Game ID",
  "pages.business.whitelistRecord.column.gameName": "Game Name",
  "pages.business.whitelistRecord.column.currency": "Currency",
  "pages.business.whitelistRecord.column.betAmount": "Bet Amount",
  "pages.business.whitelistRecord.column.scoreAmount": "Payout (User)",
  "pages.business.whitelistRecord.column.winAmount": "P&L (Platform)",
  "pages.business.whitelistRecord.column.surplusCoin": "Wallet Balance",
  "pages.business.whitelistRecord.column.freespinType": "FreeSpin Type",
  "pages.business.whitelistRecord.column.freespinAmount": "FreeSpin Amount",
  "pages.business.whitelistRecord.column.gameMode": "Game Mode",
  "pages.business.whitelistRecord.column.cascadeType": "Cascade Mode",
  "pages.business.whitelistRecord.cascadeType.none": "-",
  "pages.business.whitelistRecord.cascadeType.normalOrder": "Order Cascade",
  "pages.business.whitelistRecord.cascadeType.miniGame": "Mini Game",
  "pages.business.whitelistRecord.column.betTime": "Bet Time",
  "pages.business.whitelistRecord.column.settlementTime": "Settlement Time",
  "pages.business.whitelistRecord.column.ip": "Bet IP",
  "pages.business.whitelistRecord.column.action": "Action",
  "pages.business.whitelistRecord.filter.timeRange": "Bet Time",
  "pages.business.whitelistRecord.filter.betId": "Bet ID",
  "pages.business.whitelistRecord.filter.betIdPlaceholder": "Enter ID",
  "pages.business.whitelistRecord.filter.userId": "User ID",
  "pages.business.whitelistRecord.filter.userIdPlaceholder": "Enter user ID",
  "pages.business.whitelistRecord.filter.game": "Game",
  "pages.business.whitelistRecord.filter.currency": "Currency",
  "pages.business.whitelistRecord.filter.merchant": "Merchant",
  "pages.business.whitelistRecord.filter.betAmount": "Bet Amount",
  "pages.business.whitelistRecord.filter.betAmountMinPlaceholder": "Min bet",
  "pages.business.whitelistRecord.filter.betAmountMaxPlaceholder": "Max bet",
  "pages.business.whitelistRecord.filter.freespinType": "FreeSpin Type",
  "pages.business.whitelistRecord.filter.freespinType.merchant": "Cumulative",
  "pages.business.whitelistRecord.filter.freespinType.platform": "Platform",
  "pages.business.whitelistRecord.filter.freespinType.sevenDay": "Seven-day",
  "pages.business.whitelistRecord.filter.gameMode": "Game Mode",
  "pages.business.whitelistRecord.type.merchantFreespin": "Cumulative",
  "pages.business.whitelistRecord.type.platformFreespin": "Platform",
  "pages.business.whitelistRecord.type.sevenDayFreespin": "Seven-day",
  "pages.business.whitelistRecord.overview.title": "Overview",
  "pages.business.whitelistRecord.overview.tooltip.totalBetAmount":
    "Total Bet Amount: Under current filter conditions, the cumulative bet amount of whitelisted users.",
  "pages.business.whitelistRecord.overview.tooltip.totalScoreAmount":
    "Total Payout Amount: Under current filter conditions, the cumulative payout amount of all whitelisted users. (Note: Total payout amount excludes promotional bonuses.)",
  "pages.business.whitelistRecord.overview.tooltip.totalWinAmount":
    "Total P&L (Platform): Under current filter conditions, the cumulative profit/loss amount on the platform side.",
  "pages.business.whitelistRecord.overview.tooltip.totalWinAmountFormula":
    "Total P&L = Total Bet Amount - [Total Payout Amount + Cumulative FreeSpin]",
  "pages.business.whitelistRecord.overview.tooltip.platformFreespinAmount":
    "Platform FreeSpin Amount: Under current filter conditions, the FreeSpin amount of whitelisted users from FreeSpins provided by merchants.",
  "pages.business.whitelistRecord.overview.tooltip.merchantFreespinAmount":
    "Cumulative FreeSpin Amount: Under current filter conditions, the FreeSpin amount of whitelisted users from FreeSpins provided by game channels.",
  "pages.business.whitelistRecord.overview.totalBetAmount": "Total Bet Amount",
  "pages.business.whitelistRecord.overview.totalScoreAmount":
    "Total Payout Amount",
  "pages.business.whitelistRecord.overview.totalWinAmount": "Total P&L (Platform)",
  "pages.business.whitelistRecord.overview.platformFreespinAmount":
    "Platform FreeSpin Amount",
  "pages.business.whitelistRecord.overview.merchantFreespinAmount":
    "Cumulative FreeSpin Amount",
  "pages.business.whitelistRecord.action.export": "Export",
  "pages.business.whitelistRecord.action.replay": "Replay",
  "pages.business.whitelistRecord.export.filename": "WhitelistBetRecords_",
  "pages.business.whitelistRecord.message.exportFailed": "Export failed",
  "pages.business.whitelistRecord.sortTip":
    "*Amount sorting is applied after the operation is completed",
  "pages.business.whitelistRecord.pagination.total": "{total} records",
  "pages.business.whitelistRecord.empty": "No whitelist bet records",
  "pages.reviewCenter.gameHall.name": "Game Hall Configuration",
  "pages.reviewCenter.gameHall.title": "Game Hall Configuration Details",
  "pages.reviewCenter.gameHall.section.switches": "Hall Switches",
  "pages.reviewCenter.gameHall.section.activities": "Activity Configuration",
  "pages.reviewCenter.gameHall.section.games": "Game Configuration",
  "pages.reviewCenter.gameHall.field.item": "Configuration Item",
  "pages.reviewCenter.gameHall.field.hallSwitch": "Hall Switch",
  "pages.reviewCenter.gameHall.field.activitySwitch": "Activity Display Switch",
  "pages.reviewCenter.gameHall.field.gameSwitch": "Game Display Switch",
  "pages.reviewCenter.gameHall.field.activityId": "Activity ID",
  "pages.reviewCenter.gameHall.field.activityType": "Activity Type",
  "pages.reviewCenter.gameHall.field.gameId": "Game ID",
  "pages.reviewCenter.gameHall.field.badge": "Badge",
  "pages.reviewCenter.gameHall.field.weight": "Weight",
  "pages.reviewCenter.gameHall.field.visible": "Visible",
  "pages.reviewCenter.gameHall.value.enabled": "Enabled",
  "pages.reviewCenter.gameHall.value.disabled": "Disabled",
  "pages.reviewCenter.gameHall.empty": "No configuration data",
};
